
(function() {
 const API_TOKEN = 'sf_t1t_a8f3e2d1c4b5967081234abcdef56789';
 function apiFetch(url, opts) {
  opts = opts || {};
  opts.headers = Object.assign({'X-Api-Token': API_TOKEN}, opts.headers || {});
  return fetch(url, opts);
 }

 const partsFinderApp = {
 apiBaseUrl: 'https://app.team1texas.com/apps/portal/compatibility',
 defaultImage: '{{ "logo.svg" | asset_url }}',

 currentMake: null,
 currentMakeName: null,
 currentModel: null,
 currentModelName: null,
 currentCategory: null,
 currentCategoryName: null,
 currentProductCategory: '',
 productCategories: [],
 currentParentCategory: null,
 currentParentCategoryName: null,
 categoryAncestors: [],
 currentSearchQuery: '',
 currentFilterQuery: '',
 allProducts: [],
 filteredProducts: [],
 allMakes: [],
 allCategories: [],
 makeModelsCache: {},
 searchDebounceTimer: null,
 filterDebounceTimer: null,
 _expandedCategories: {},
 _recentSearchesKey: 'pf_recent_searches',
 _popularMakeHandles: ['caterpillar','bobcat','john-deere','kubota','case','takeuchi','volvo','komatsu','new-holland','hitachi'],

 els: {},

 init() {
  const hdr = document.querySelector('#shopify-section-header, .shopify-section-header, header.header, .header-wrapper, header');
  if (hdr) {
  const hdrH = hdr.getBoundingClientRect().height;
  if (hdrH > 0) document.documentElement.style.setProperty('--pf-header-h', hdrH + 'px');
  }

  this.els = {
  makeSelect: document.getElementById('pf-make-select'),
  modelSelect: document.getElementById('pf-model-select'),
  searchBtn: document.getElementById('pf-search-btn'),
  resultsHeader: document.getElementById('pf-results-header'),
  resultCount: document.getElementById('pf-result-count'),
  searchTitle: document.getElementById('pf-search-title'),
  loading: document.getElementById('pf-loading'),
  loadingText: document.getElementById('pf-loading-text'),
  browseMakes: document.getElementById('pf-browse-makes'),
  makesGrid: document.getElementById('pf-makes-grid'),
  browseModels: document.getElementById('pf-browse-models'),
  modelsGrid: document.getElementById('pf-models-grid'),
  modelsTitle: document.getElementById('pf-models-title'),
  products: document.getElementById('pf-products'),
  empty: document.getElementById('pf-empty'),
  quickSearchInput: document.getElementById('pf-quick-search-input'),
  searchResults: document.getElementById('pf-search-results'),
  searchQuery: document.getElementById('pf-search-query'),
  equipmentSection: document.getElementById('pf-equipment-section'),
  equipmentResults: document.getElementById('pf-equipment-results'),
  productSection: document.getElementById('pf-product-section'),
  productResults: document.getElementById('pf-product-results'),
  searchNoResults: document.getElementById('pf-search-no-results'),
  clearFilters: document.getElementById('pf-clear-filters'),
  toast: document.getElementById('pf-toast'),
  toastMessage: document.getElementById('pf-toast-message'),
  resultsFilterInput: document.getElementById('pf-results-filter-input'),
  filterCount: document.getElementById('pf-filter-count'),
  filteredCount: document.getElementById('pf-filtered-count'),
  totalCount: document.getElementById('pf-total-count'),
  searchFilterInput: document.getElementById('pf-search-filter-input'),
  searchFilterCount: document.getElementById('pf-search-filter-count'),
  searchFilteredCount: document.getElementById('pf-search-filtered-count'),
  searchTotalCount: document.getElementById('pf-search-total-count'),
  typeTabs: document.getElementById('pf-type-tabs'),
  typeTabsScroll: document.getElementById('pf-type-tabs-scroll'),
  mobileTypeTabs: document.getElementById('pf-mobile-type-tabs'),
  mobileTypeTabsList: document.getElementById('pf-mobile-type-tabs-list'),
  filteredBanner: document.getElementById('pf-filtered-banner'),
  filteredBannerLabel: document.getElementById('pf-filtered-banner-label'),
  treadTabs: document.getElementById('pf-tread-tabs'),
  treadTabsScroll: document.getElementById('pf-tread-tabs-scroll'),
  mobileTreadTabs: document.getElementById('pf-mobile-tread-tabs'),
  mobileTreadTabsList: document.getElementById('pf-mobile-tread-tabs-list'),
  oemInput: document.getElementById('pf-oem-input'),
  serialInput: document.getElementById('pf-serial-input')
  };

  this.activeTypeTab = null;
  this.activeTreadTab = null;
  this.funnelStep = null;
  this.funnelSelections = { type: null, tread: null, width: null, size: null };
  this.treadTypeImages = {};
  this.stockAlerts = { enabled: true, low_stock_threshold: 5, phone_number: '18665168473', phone_display: '(866) 516-8473' };
  this.volumeDiscounts = { enabled: false, best_value_badge: true, tiers: [], promo_message: null, promo_code: null };

  this.parseUrlParams();

  if ((this.currentMake && this.currentModel) || this.currentCategory) {
  this.showLoading();
  }

  this.bindEvents();

  this.initTomSelect();

  this.loadProductCategories();

  this.loadTreadTypeImages().then(() => {
   this.loadMakes();
   this.loadEquipmentTypes();
   this.loadCategories();
  });
  this.loadStorefrontConfig();

  window.addEventListener('popstate', () => {
  const prevMake = this.currentMake;
  const prevModel = this.currentModel;
  const prevCategory = this.currentCategory;
  this.parseUrlParams();

  if (this.allProducts && this.allProducts.length > 0 &&
   this.currentMake === prevMake && this.currentModel === prevModel &&
   this.currentCategory === prevCategory) {
   if (!this.restoreBrowseFromUrl(this.allProducts) && !this.restoreFunnelFromUrl()) {
   if (this.currentCategory) {
    this.renderCategoryProducts(this.allProducts);
   } else {
    this.renderProducts(this.allProducts);
   }
   }
   this.scrollToTop();
   return;
  }

  if (!this.currentCategory && !this.currentMake && !this.currentSearchQuery) {
   this.showMakes();
   this.scrollToTop();
   return;
  }

  this.syncSelectors();
  this.loadContent();
  });

  try { this.initSessionTracker(); } catch(e) {  }

 },

 initSessionTracker() {
  const self = this;
  const wsBase = self.apiBaseUrl.replace('https://', 'wss://').replace('http://', 'ws://').replace('/apps/portal/compatibility', '');

  this.sessionTracker = {
  sessionId: null,
  sessionCode: null,
  socket: null,
  channel: null,
  connected: false,
  buffer: [],
  flushTimer: null,
  heartbeatTimer: null,
  endpoint: self.apiBaseUrl.replace('/compatibility', '') + '/pf-session',
  wsUrl: wsBase + '/storefront/websocket',

  init() {
   try {
   let sid = sessionStorage.getItem('pf_session_id');
   if (!sid) {
    sid = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : 'pf-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('pf_session_id', sid);
   }
   this.sessionId = sid;

   this.connectWebSocket();

   this.track('page_load', {
    referrer: document.referrer || '',
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    user_agent: navigator.userAgent
   });
   } catch(e) {  }
  },

  connectWebSocket() {
   try {
    const url = this.wsUrl + '?session_id=' + encodeURIComponent(this.sessionId) + '&vsn=2.0.0';
    const ws = new WebSocket(url);
    const tracker = this;
    const joinRef = '1';
    let msgRef = 1;

    ws.onopen = () => {
     const joinPayload = {
      ip: '', // Server gets this from conn
      user_agent: navigator.userAgent
     };
     ws.send(JSON.stringify([joinRef, String(++msgRef), 'pf_session:' + tracker.sessionId, 'phx_join', joinPayload]));
    };

    ws.onmessage = (evt) => {
     try {
      const msg = JSON.parse(evt.data);
      const event = msg[3];
      const payload = msg[4];

      if (event === 'phx_reply' && payload && payload.status === 'ok') {
       if (!tracker.connected) {
        tracker.connected = true;
        tracker.socket = ws;
        tracker._msgRef = msgRef;

        if (payload.response && payload.response.session_code) {
         tracker.sessionCode = payload.response.session_code;
         tracker.showSessionCode(payload.response.session_code);
        }

        tracker.flushBuffer();

        tracker.heartbeatTimer = setInterval(() => {
         if (ws.readyState === 1) {
          ws.send(JSON.stringify([null, String(++tracker._msgRef), 'phoenix', 'heartbeat', {}]));
         }
        }, 30000);
       }
      } else if (event === 'operator_push') {
       tracker.handleOperatorPush(payload);
      } else if (event === 'operator_joined') {
       tracker.showOperatorBadge(payload.name);
      }
     } catch(e) {  }
    };

    ws.onerror = () => { tracker.connected = false; };
    ws.onclose = () => {
     tracker.connected = false;
     tracker.socket = null;
     clearInterval(tracker.heartbeatTimer);
     setTimeout(() => {
      if (!tracker.connected) tracker.connectWebSocket();
     }, 3000);
    };
   } catch(e) {
    this.connected = false;
   }
  },

  track(eventType, eventData) {
   try {
   const event = {
    event_type: eventType,
    event_data: eventData || {},
    timestamp: new Date().toISOString()
   };

   if (this.connected && this.socket && this.socket.readyState === 1) {
    this.socket.send(JSON.stringify([
     null, String(++this._msgRef),
     'pf_session:' + this.sessionId,
     'event',
     event
    ]));
   } else {
    this.buffer.push(event);
    if (this.buffer.length >= 3) {
     this.flush();
    } else {
     clearTimeout(this.flushTimer);
     this.flushTimer = setTimeout(() => this.flush(), 2000);
    }
   }
   } catch(e) {  }
  },

  flushBuffer() {
   if (this.buffer.length === 0 || !this.connected || !this.socket) return;
   const events = this.buffer.splice(0);
   try {
    this.socket.send(JSON.stringify([
     null, String(++this._msgRef),
     'pf_session:' + this.sessionId,
     'event_batch',
     { events: events }
    ]));
   } catch(e) {
    this.buffer.unshift(...events);
   }
  },

  flush() {
   try {
   clearTimeout(this.flushTimer);
   if (this.buffer.length === 0 || !this.sessionId) return;

   if (this.connected && this.socket && this.socket.readyState === 1) {
    this.flushBuffer();
    return;
   }

   const events = this.buffer.splice(0);
   const body = JSON.stringify({
    session_id: this.sessionId,
    events: events
   });

   if (navigator.sendBeacon) {
    navigator.sendBeacon(this.endpoint + (this.endpoint.indexOf('?') >= 0 ? '&' : '?') + 'api_token=' + API_TOKEN, new Blob([body], { type: 'application/json' }));
   } else {
    apiFetch(this.endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body,
    keepalive: true
    }).catch(() => {});
   }
   } catch(e) {  }
  },

  showSessionCode(code) {
   const badge = document.createElement('div');
   badge.id = 'pf-session-code';
   badge.style.cssText = 'position:fixed;bottom:12px;right:12px;background:rgba(0,0,0,0.7);color:#fbbf24;padding:4px 10px;border-radius:6px;font-family:monospace;font-size:11px;font-weight:bold;z-index:9999;letter-spacing:1px;cursor:help;';
   badge.title = 'Your session code — share with support';
   badge.textContent = code;
   document.body.appendChild(badge);
  },

  showOperatorBadge(name) {
   let badge = document.getElementById('pf-operator-badge');
   if (!badge) {
    badge = document.createElement('div');
    badge.id = 'pf-operator-badge';
    badge.style.cssText = 'position:fixed;bottom:12px;left:12px;background:#059669;color:white;padding:6px 14px;border-radius:8px;font-size:12px;font-weight:600;z-index:9999;display:flex;align-items:center;gap:6px;box-shadow:0 2px 8px rgba(0,0,0,0.2);';
    document.body.appendChild(badge);
   }
   badge.innerHTML = '<span style="width:8px;height:8px;background:#34d399;border-radius:50%;display:inline-block;animation:pulse 1.5s infinite"></span> ' + (name || 'Support') + ' is helping you';
  },

  handleOperatorPush(payload) {
   if (!payload || !payload.action) return;
   try {
    switch(payload.action) {
     case 'select_make':
      if (payload.data && payload.data.handle) {
       self.navigateToMake(payload.data.handle);
      }
      break;
     case 'select_model':
      if (payload.data && payload.data.handle) {
       self.navigateToModel(payload.data.handle);
      }
      break;
     case 'show_product':
      if (payload.data && payload.data.handle) {
       self.showProductByHandle(payload.data.handle);
      }
      break;
     case 'navigate':
      if (payload.data && payload.data.path) {
       window.location.href = payload.data.path;
      }
      break;
    }
   } catch(e) {  }
  }
  };
  this.sessionTracker.init();

  window.addEventListener('beforeunload', () => {
  try { this.sessionTracker.flush(); } catch(e) {}
  });
 },

 bindEvents() {
  document.addEventListener('click', (e) => {
  try {
   const link = e.target.closest('.pf-card-link, .pf-search-product-card');
   if (link && this.sessionTracker) {
   const card = link.closest('.pf-card, .mainsearch-product-box');
   const title = card ? (card.querySelector('.pf-card-title, .pf-search-product-title')?.textContent || '').trim() : '';
   const href = link.getAttribute('href') || '';
   this.sessionTracker.track('view_product', { title: title, url: href });
   }
  } catch(e) {  }
  });

  this.els.quickSearchInput.addEventListener('input', (e) => {
  clearTimeout(this.searchDebounceTimer);
  this.searchDebounceTimer = setTimeout(() => this.onQuickSearch(e.target.value), 200);
  });

  this.els.quickSearchInput.addEventListener('keydown', (e) => {
  if (e.key === 'Enter') {
   e.preventDefault();
   const q = e.target.value.trim();
   if (q.length < 2) {
    e.target.classList.add('pf-input-error');
    e.target.setAttribute('placeholder', 'Please enter at least 2 characters...');
    setTimeout(() => {
     e.target.classList.remove('pf-input-error');
     e.target.setAttribute('placeholder', 'Search by size, description, or part #...');
    }, 2000);
    return;
   }
   this.onQuickSearch(q);
  }
  });

  if (this.els.resultsFilterInput) {
  this.els.resultsFilterInput.addEventListener('input', (e) => {
   clearTimeout(this.filterDebounceTimer);
   this.filterDebounceTimer = setTimeout(() => this.onResultsFilter(e.target.value), 150);
  });
  }

  if (this.els.searchFilterInput) {
  this.els.searchFilterInput.addEventListener('input', (e) => {
   clearTimeout(this.searchFilterDebounceTimer);
   this.searchFilterDebounceTimer = setTimeout(() => this.onSearchResultsFilter(e.target.value), 150);
  });
  }

  if (this.els.oemInput) {
  this.els.oemInput.addEventListener('input', () => this.updateSearchButtonState());
  this.els.oemInput.addEventListener('keydown', (e) => {
   if (e.key === 'Enter' && this.els.oemInput.value.trim().length >= 3) this.onSearchSubmit();
  });
  }
  if (this.els.serialInput) {
  this.els.serialInput.addEventListener('input', () => this.updateSearchButtonState());
  this.els.serialInput.addEventListener('keydown', (e) => {
   if (e.key === 'Enter' && this.els.serialInput.value.trim().length >= 3) this.onSearchSubmit();
  });
  }

  document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
   if (this.currentSearchQuery) {
   this.clearSearch();
   }
  }
  });
 },

 initTomSelect() {
  const self = this;

  if (!this.els.makeSelect || !this.els.modelSelect) {
   return;
  }

  this.makeTomSelect = new AutoComplete({
  input: this.els.makeSelect,
  items: [],
  placeholder: 'Type manufacturer...',
  maxVisible: 10,
  theme: 'dark',
  name: 'pf-make',
  onSelect: function(value) {
   self.onMakeChange(value);
  }
  });

  this.modelTomSelect = new AutoComplete({
  input: this.els.modelSelect,
  items: [],
  placeholder: 'Type model number...',
  maxVisible: 10,
  disabled: true,
  theme: 'dark',
  name: 'pf-model',
  onSelect: function(value) {
   self.onModelChange(value);
  }
  });
 },

 parseUrlParams() {
  const params = new URLSearchParams(window.location.search);
  this.currentMake = params.get('make') || null;
  this.currentModel = params.get('model') || null;
  this.currentCategory = params.get('category') || null;
  this.currentProductCategory = params.get('product_category') || '';
  this.currentSearchQuery = params.get('search') || '';
  this.currentMakeName = null;
  this.currentModelName = null;
  this.currentCategoryName = null;
  this._pendingFunnel = {
  type: params.get('ftype') || null,
  tread: params.get('ftread') || null,
  width: params.get('fwidth') || null,
  size: params.get('fsize') || null
  };
 },

 updateUrl(pushState = true) {
  const url = new URL(window.location.href);

  if (this.currentSearchQuery) {
  url.searchParams.set('search', this.currentSearchQuery);
  url.searchParams.delete('make');
  url.searchParams.delete('model');
  url.searchParams.delete('category');
  } else if (this.currentCategory) {
  url.searchParams.delete('search');
  url.searchParams.set('category', this.currentCategory);
  url.searchParams.delete('make');
  url.searchParams.delete('model');
  } else {
  url.searchParams.delete('search');
  url.searchParams.delete('category');

  if (this.currentMake) {
   url.searchParams.set('make', this.currentMake);
  } else {
   url.searchParams.delete('make');
  }

  if (this.currentModel) {
   url.searchParams.set('model', this.currentModel);
  } else {
   url.searchParams.delete('model');
  }
  }

  url.searchParams.delete('make_name');
  url.searchParams.delete('model_name');

  if (this.currentProductCategory) {
   url.searchParams.set('product_category', this.currentProductCategory);
  } else {
   url.searchParams.delete('product_category');
  }

  url.searchParams.delete('ftype');
  url.searchParams.delete('ftread');
  url.searchParams.delete('fwidth');
  url.searchParams.delete('fsize');
  url.searchParams.delete('browse');
  url.searchParams.delete('bmfr');
  url.searchParams.delete('bmodel');

  if (pushState) {
  history.pushState({}, '', url.toString());
  } else {
  history.replaceState({}, '', url.toString());
  }
 },

 updateFunnelUrl() {
  if (this._skipUrlUpdate) return;
  const url = new URL(window.location.href);
  const fs = this.funnelSelections;
  if (fs.type) url.searchParams.set('ftype', fs.type); else url.searchParams.delete('ftype');
  if (fs.tread) url.searchParams.set('ftread', fs.tread); else url.searchParams.delete('ftread');
  if (fs.width) url.searchParams.set('fwidth', fs.width); else url.searchParams.delete('fwidth');
  if (fs.size) url.searchParams.set('fsize', fs.size); else url.searchParams.delete('fsize');
  history.pushState({}, '', url.toString());
 },

 restoreFunnelFromUrl() {
  const pf = this._pendingFunnel;
  this._pendingFunnel = null;
  if (!pf || !pf.type) return false;

  const products = this.allProducts || [];
  if (products.length === 0) return false;

  const typeProducts = products.filter(p => {
  const pType = (p.product_type || p.type || 'Other').trim();
  return pType === pf.type;
  });
  if (typeProducts.length === 0) return false;

  if (pf.tread) {
  const self = this;
  const treadProducts = typeProducts.filter(p => self.classifyTread(p) === pf.tread);
  if (treadProducts.length === 0) return false;
  }

  this.buildTypeTabs(products);
  this._skipUrlUpdate = true;

  if (pf.size) {
  this.funnelSelections = { type: pf.type, tread: pf.tread, width: pf.width, size: null };
  this.activeTypeTab = pf.type;
  this.activeTreadTab = pf.tread;
  this.selectFunnelSize(pf.size);
  } else if (pf.width) {
  this.funnelSelections = { type: pf.type, tread: pf.tread, width: null, size: null };
  this.activeTypeTab = pf.type;
  this.activeTreadTab = pf.tread;
  this.selectFunnelWidth(pf.width);
  } else if (pf.tread) {
  this.funnelSelections = { type: pf.type, tread: null, width: null, size: null };
  this.activeTypeTab = pf.type;
  this.selectFunnelTread(pf.tread);
  } else {
  this.selectFunnelType(pf.type);
  }

  this._skipUrlUpdate = false;
  return true;
 },

 mmToInches(mm) {
  const n = parseFloat(mm);
  if (isNaN(n)) return '?';
  return Math.ceil(n / 25.4);
 },

 async syncSelectors() {
  if (this.currentMake && this.makeTomSelect) {
  this.makeTomSelect.setValue(this.currentMake, true);
  await this.loadModels(this.currentMake);
  if (this.currentModel && this.modelTomSelect) {
   this.modelTomSelect.setValue(this.currentModel, true);
  }
  }
 },

 loadContent() {
  if (this.currentCategory) {
  this.loadCategoryProducts();
  } else if (this.currentMake && this.currentModel) {
  this.loadProducts();
  } else if (this.currentMake) {
  this.showBrowseModels(this.currentMake, this.currentMakeName);
  } else {
  this.showMakes();
  }
 },

 async loadProductCategories() {
  try {
   const response = await apiFetch(`${this.apiBaseUrl}/product-categories`);
   const data = await response.json();
   if (data.product_categories && Array.isArray(data.product_categories)) {
    this.productCategories = data.product_categories;
    this.renderProductCategoryTabs();
   }
  } catch (err) {
  }
 },

 renderProductCategoryTabs() {
  const container = document.getElementById('pf-category-tabs');
  if (!container || !this.productCategories.length) return;

  const activeStyle = 'flex:1 1 calc(50% - 4px);min-width:0;padding:8px 4px;font-size:11px;font-weight:700;text-align:center;cursor:pointer;border-radius:8px;border:1px solid rgba(79,195,247,0.4);background:rgba(79,195,247,0.15);color:#4fc3f7;transition:all 0.2s;text-transform:uppercase;letter-spacing:0.3px;overflow:hidden;text-overflow:ellipsis;';
  const inactiveStyle = 'flex:1 1 calc(50% - 4px);min-width:0;padding:8px 4px;font-size:11px;font-weight:700;text-align:center;cursor:pointer;border-radius:8px;border:1px solid rgba(255,255,255,0.15);background:rgba(255,255,255,0.04);color:rgba(255,255,255,0.6);transition:all 0.2s;text-transform:uppercase;letter-spacing:0.3px;overflow:hidden;text-overflow:ellipsis;';
  const isAll = !this.currentProductCategory;

  let html = `<button class="pf-category-tab ${isAll ? 'active' : ''}" data-category="" onclick="partsFinderApp.setProductCategory('')" style="${isAll ? activeStyle : inactiveStyle}">All</button>`;

  this.productCategories.forEach(cat => {
   const isActive = this.currentProductCategory === cat.key;
   html += `<button class="pf-category-tab ${isActive ? 'active' : ''}" data-category="${cat.key}" onclick="partsFinderApp.setProductCategory('${cat.key}')" style="${isActive ? activeStyle : inactiveStyle}">${cat.name}<span style="display:block;font-size:10px;font-weight:400;opacity:0.7;">${cat.product_count}</span></button>`;
  });

  container.innerHTML = html;

  const mobileContainer = document.getElementById('pf-mobile-category-tabs');
  if (mobileContainer) mobileContainer.innerHTML = html;
 },

 setProductCategory(category) {
  if (this.currentProductCategory === category) return;
  this.currentProductCategory = category;

  this.currentMake = null;
  this.currentMakeName = null;
  this.currentModel = null;
  this.currentModelName = null;
  this.allProducts = [];
  this.filteredProducts = [];
  this.makeModelsCache = {};
  this.categoryProducts = null;

  this.renderProductCategoryTabs();

  this.updateUrl();

  if (this.makeTomSelect) {
   this.makeTomSelect.clear(true);
   this.makeTomSelect.clearOptions();
  }
  if (this.modelTomSelect) {
   this.modelTomSelect.clear(true);
   this.modelTomSelect.clearOptions();
   this.modelTomSelect.disable();
  }

  if (this.els.products) this.els.products.innerHTML = '';
  if (this.els.makesGrid) this.els.makesGrid.innerHTML = '';

  this.loadMakes();

  this.trackEvent('select_product_category', { category: category || 'all' });
 },

 async loadMakes() {
  const makeLoadingEl = document.getElementById('pf-make-loading');
  if (makeLoadingEl) makeLoadingEl.classList.remove('hidden');
  try {
  const catParam = this.currentProductCategory ? `?product_category=${this.currentProductCategory}` : '';
  const response = await apiFetch(`${this.apiBaseUrl}/makes${catParam}`);
  const data = await response.json();

  if (data.makes && Array.isArray(data.makes) && data.makes.length > 0) {
   data.makes.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
   this.allMakes = data.makes;

   if (this.makeTomSelect) {
   data.makes.forEach(make => {
    this.makeTomSelect.addOption({
    value: make.handle,
    text: make.name,
    name: make.name
    });
   });

   if (this.currentSearchQuery) {
    this.els.quickSearchInput.value = this.currentSearchQuery;
    this.onQuickSearch(this.currentSearchQuery);
   } else if (this.currentMake) {
    const makeData = this.allMakes.find(m => m.handle === this.currentMake);
    if (makeData) {
    this.currentMakeName = makeData.name;
    }
    this.makeTomSelect.setValue(this.currentMake, true);
    await this.loadModels(this.currentMake);
   } else if (!this.currentCategory) {
    this.renderDefaultCategoryGrid();
   }
   }

   this.renderPopularMakes();
   this.renderRecentSearches();

  }
  } catch (err) {
  } finally {
  if (makeLoadingEl) makeLoadingEl.classList.add('hidden');
  }
 },

 onMakeChange(makeHandle) {
  this.currentMake = makeHandle || null;
  this.currentModel = null;
  this.currentModelName = null;

  if (makeHandle && this.sessionTracker) {
  try {
   const makeData = this.allMakes.find(m => m.handle === makeHandle);
   this.sessionTracker.track('select_make', { handle: makeHandle, name: makeData?.name || makeHandle });
  } catch(e) {}
  }

  if (this._scopedMakes && makeHandle) {
  const scopedMake = this._scopedMakes.get(makeHandle);
  this.currentMakeName = scopedMake ? scopedMake.name : makeHandle;

  if (this.modelTomSelect) {
   this.modelTomSelect.clear();
   this.modelTomSelect.clearOptions();
   this.modelTomSelect.addOption({ value: '', text: '-- Select Model --' });
   if (scopedMake) {
   Array.from(scopedMake.models.values())
    .sort((a, b) => a.name.localeCompare(b.name))
    .forEach(m => {
    this.modelTomSelect.addOption({ value: m.handle, text: m.name });
    });
   }
   this.modelTomSelect.enable();
  }

  if (this.categoryProducts) {
   const filtered = this.categoryProducts.filter(p =>
   (p.compatible_models || []).some(cm => {
    const cmMake = cm.make_handle || this.slugify(cm.manufacturer || cm.make || '');
    return cmMake === makeHandle;
   })
   );
   this.filteredProducts = filtered;
   this.els.resultCount.textContent = filtered.length;
   this.els.products.innerHTML = filtered.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
   requestAnimationFrame(() => this.initCarousels());
  }

  this.updateSearchButtonState();
  this.updateBackButton();
  return;
  }

  const makeData = this.allMakes.find(m => m.handle === makeHandle);
  this.currentMakeName = makeData?.name || null;

  if (makeHandle) {
  this.currentCategory = null;
  this.currentCategoryName = null;
  this.categoryProducts = null;
  this.restoreMakeModelFull();
  if (this.makeTomSelect) this.makeTomSelect.setValue(makeHandle, true);
  if (this.allCategories && this.allCategories.length > 0) {
   this.renderCategories(this.allCategories);
  }
  }

  if (this.modelTomSelect) {
  this.modelTomSelect.clear();
  this.modelTomSelect.clearOptions();
  this.modelTomSelect.addOption({ value: '', text: '-- Select Model --' });
  this.modelTomSelect.disable();
  }

  if (makeHandle) {
  this.loadModels(makeHandle);
  }

  this.updateSearchButtonState();
 },

 async loadModels(makeHandle) {
  if (this.makeModelsCache[makeHandle]) {
  this.populateModelSelect(this.makeModelsCache[makeHandle]);
  return;
  }

  const modelLoadingEl = document.getElementById('pf-model-loading');
  if (modelLoadingEl) modelLoadingEl.classList.remove('hidden');
  try {
  let modelsUrl = `${this.apiBaseUrl}/models?make_handle=${encodeURIComponent(makeHandle)}`;
  if (this.currentProductCategory) modelsUrl += `&product_category=${this.currentProductCategory}`;
  const response = await apiFetch(modelsUrl);
  const data = await response.json();

  if (data.models && Array.isArray(data.models)) {
   data.models.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
   this.makeModelsCache[makeHandle] = data.models;
   this.populateModelSelect(data.models);
  }
  } catch (err) {
  } finally {
  if (modelLoadingEl) modelLoadingEl.classList.add('hidden');
  }
 },

 populateModelSelect(models) {
  if (this.modelTomSelect) {
  this.modelTomSelect.clearOptions();
  this.modelTomSelect.addOption({ value: '', text: '-- Select Model --' });
  models.forEach(model => {
   this.modelTomSelect.addOption({
   value: model.handle,
   text: model.name,
   name: model.name
   });
  });
  this.modelTomSelect.enable();

  if (this.currentModel) {
   const modelData = models.find(m => m.handle === this.currentModel);
   if (modelData) {
   this.currentModelName = modelData.name;
   }
   this.modelTomSelect.setValue(this.currentModel, true);
   this.updateSearchButtonState();
   this.loadProducts();
  }
  }
 },

 onModelChange(modelHandle) {
  this.currentModel = modelHandle || null;

  if (modelHandle && this.sessionTracker) {
  try {
   const models = this.makeModelsCache[this.currentMake] || [];
   const modelData = models.find(m => m.handle === modelHandle);
   this.sessionTracker.track('select_model', { handle: modelHandle, name: modelData?.name || modelHandle });
  } catch(e) {}
  }

  if (this._categoryFilterMode && this._scopedMakes && this.currentMake && modelHandle) {
  const scopedMake = this._scopedMakes.get(this.currentMake);
  if (scopedMake) {
   const scopedModel = scopedMake.models.get(modelHandle);
   this.currentModelName = scopedModel ? scopedModel.name : modelHandle;
  }

  if (this.categoryProducts) {
   const filtered = this.categoryProducts.filter(p =>
   (p.compatible_models || []).some(cm => {
    const cmMake = cm.make_handle || this.slugify(cm.manufacturer || cm.make || '');
    const cmModel = cm.model_handle || cm.handle || this.slugify(cm.model || cm.name || '');
    return cmMake === this.currentMake && cmModel === modelHandle;
   })
   );
   this.filteredProducts = filtered;
   this.els.resultCount.textContent = filtered.length;
   this.els.products.innerHTML = filtered.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
   requestAnimationFrame(() => this.initCarousels());
  }

  this.updateSearchButtonState();
  this.updateBackButton();
  return;
  }

  const models = this.makeModelsCache[this.currentMake] || [];
  const modelData = models.find(m => m.handle === modelHandle);
  this.currentModelName = modelData?.name || null;

  if (modelHandle) {
  this.currentCategory = null;
  this.currentCategoryName = null;
  this.categoryProducts = [];
  if (this.allCategories && this.allCategories.length > 0) {
   this.renderCategories(this.allCategories);
  }
  }

  this.updateSearchButtonState();
 },

 updateSearchButtonState() {
  if (this.els.searchBtn) {
  const hasOem = this.els.oemInput && this.els.oemInput.value.trim().length >= 3;
  const hasSerial = this.els.serialInput && this.els.serialInput.value.trim().length >= 3;
  this.els.searchBtn.disabled = !this.currentMake && !hasOem && !hasSerial;
  }
 },

 async onSearchSubmit() {
  if (this.currentMake && this.currentModel) {
   const collectionHandle = this.currentMake + '-' + this.currentModel;
   window.location.href = '/collections/' + collectionHandle;
   return;
  }

  if (this._categoryFilterMode && this.categoryProducts) {
  if (!this.currentMake) return;
  const makeHandle = this.currentMake;
  const modelHandle = this.currentModel;

  const filtered = this.categoryProducts.filter(p =>
   (p.compatible_models || []).some(cm => {
   const cmMake = cm.make_handle || this.slugify(cm.manufacturer || cm.make || '');
   if (cmMake !== makeHandle) return false;
   if (modelHandle) {
    const cmModel = cm.model_handle || cm.handle || this.slugify(cm.model || cm.name || '');
    return cmModel === modelHandle;
   }
   return true;
   })
  );
  this.filteredProducts = filtered;
  this.els.resultCount.textContent = filtered.length;
  this.els.products.innerHTML = filtered.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());
  this.updateBackButton();
  this.updateUrl();
  return;
  }

  const oemQuery = this.els.oemInput ? this.els.oemInput.value.trim() : '';
  const serialQuery = this.els.serialInput ? this.els.serialInput.value.trim() : '';
  if (!this.currentMake && (oemQuery.length >= 3 || serialQuery.length >= 3)) {
  const query = oemQuery || serialQuery;
  this.onQuickSearch(query);
  return;
  }

  if (!this.currentMake) return;
  this.updateUrl();
  if (!this.currentModel) {
   const makeName = this.currentMakeName || this.currentMake;
   if (!this.makeModelsCache[this.currentMake]) {
    await this.loadModels(this.currentMake);
   }
   this.showBrowseModels(this.currentMake, makeName);
   return;
  }
  this.loadProducts();
 },

 async onQuickSearch(query) {
  query = query.trim();
  this.currentSearchQuery = query;

  if (query && query.length >= 2 && this.sessionTracker) {
  try { this.sessionTracker.track('search', { query: query }); } catch(e) {}
  }

  if (query && query.length >= 2) {
  this.saveRecentSearch({ type: 'search', query: query });
  }

  if (!query) {
  this.hideSearchResults();
  this.updateUrl();
  if (this.currentCategory) {
  } else if (!this.currentMake || !this.currentModel) {
   this.showMakes();
  }
  return;
  }

  if (query.length < 2) return;

  this.currentMake = null;
  this.currentMakeName = null;
  this.currentModel = null;
  this.currentModelName = null;
  this.currentCategory = null;
  this.currentCategoryName = null;
  this.currentParentCategory = null;
  this.currentParentCategoryName = null;
  this.categoryAncestors = [];

  this.updateUrl();
  this.showLoading(`Searching for "${query}"...`);

  try {
  const [titleRes, oemRes] = await Promise.all([
   apiFetch(`${this.apiBaseUrl}/search?q=${encodeURIComponent(query)}&limit=50`).then(r => r.json()).catch(() => ({ products: [] })),
   (query.length >= 5 && /^[A-Za-z0-9\-]+$/.test(query))
   ? apiFetch(`${this.apiBaseUrl}/search-oem?q=${encodeURIComponent(query)}&limit=20`).then(r => r.json()).catch(() => ({ products: [] }))
   : Promise.resolve({ products: [] })
  ]);
  const titleProducts = titleRes.products || [];
  const oemProducts = oemRes.products || [];
  const seen = new Set(titleProducts.map(p => p.id));
  const merged = [...titleProducts, ...oemProducts.filter(p => !seen.has(p.id))];
  await this.attachLivePrices(merged);
  this.hideLoading();
  this.renderSearchProductResults(query, merged);
  } catch (e) {
  this.hideLoading();
  this.renderSearchProductResults(query, []);
  }
 },

 onResultsFilter(query) {
  query = query.trim();
  this.currentFilterQuery = query;

  if (!this.allProducts || this.allProducts.length === 0) {
  this.els.quickSearchInput.value = query;
  this.onQuickSearch(query);
  return;
  }

  const inTilesView = this.categoryTiles && this.currentCategory && !this.currentMake;

  if (inTilesView) {
  if (!query) {
   this.filteredTiles = [...this.categoryTiles];
   this.els.filterCount.style.display = 'none';
  } else {
   const queryLower = query.toLowerCase();
   const terms = queryLower.split(/\s+/).filter(t => t.length > 0);
   this.filteredTiles = this.categoryTiles.filter(tile => {
   const searchText = `${tile.make} ${tile.model}`.toLowerCase();
   return terms.every(term => searchText.includes(term));
   });
   this.els.filterCount.style.display = 'inline';
   this.els.filteredCount.textContent = this.filteredTiles.length;
   this.els.totalCount.textContent = this.categoryTiles.length;
  }
  this.renderFilteredTiles();
  return;
  }

  if (this.activeTypeTab !== null && this.activeTypeTab !== undefined) {
  this.applyTypeFilter();
  return;
  }

  if (!query) {
  this.filteredProducts = [...this.allProducts];
  this.els.filterCount.style.display = 'none';
  } else {
  const queryLower = query.toLowerCase();
  const terms = queryLower.split(/\s+/).filter(t => t.length > 0);
  this.filteredProducts = this.allProducts.filter(product => {
   const searchText = [
   product.title || '',
   product.sku || '',
   product.vendor || '',
   product.product_type || '',
   product.body_html ? product.body_html.replace(/<[^>]*>/g, '') : ''
   ].join(' ').toLowerCase();
   return terms.every(term => searchText.includes(term));
  });
  this.els.filterCount.style.display = 'inline';
  this.els.filteredCount.textContent = this.filteredProducts.length;
  this.els.totalCount.textContent = this.allProducts.length;
  }

  this.renderFilteredProducts();
 },

 renderFilteredTiles() {
  const tiles = this.filteredTiles;
  this.els.resultCount.textContent = tiles.length;
  if (tiles.length === 0) {
  this.els.products.innerHTML = '<div class="pf-no-filter-results"><p>No equipment matches your filter. <a href="javascript:void(0)" onclick="partsFinderApp.clearResultsFilter()">Clear filter</a></p></div>';
  return;
  }
  this.els.products.innerHTML = tiles.map(mm => `
  <div class="pf-model-card" onclick="partsFinderApp.selectCategoryModel('${mm.makeHandle}', '${mm.modelHandle}', '${this.escapeHtml(mm.make)}', '${this.escapeHtml(mm.model)}')">
   <div class="pf-equipment-card-make">${this.escapeHtml(mm.make)}</div>
   <div class="pf-model-card-name">${this.escapeHtml(mm.model)}</div>
   <div class="pf-model-card-count">${mm.productCount} product${mm.productCount !== 1 ? 's' : ''}</div>
   <div class="pf-equipment-card-action">View Products &rarr;</div>
  </div>
  `).join('');
  this.staggerChildren(this.els.products, '.pf-model-card', 30);
 },

 renderFilteredProducts() {
  const products = this.filteredProducts;
  this.els.resultCount.textContent = products.length;
  if (products.length === 0) {
  this.els.products.innerHTML = '<div class="pf-no-filter-results"><p>No products match your filter. <a href="javascript:void(0)" onclick="partsFinderApp.clearResultsFilter()">Clear filter</a></p></div>';
  return;
  }
  if (this.funnelStep === 'products' && this.funnelSelections.type) {
  let html = this.renderFunnelBreadcrumb();
  html += '<div style="display:flex;flex-wrap:wrap;gap:15px;padding:0 0 16px;">';
  html += products.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  } else {
  this.els.products.classList.add('pf-grid-view');
  this.els.products.style.display = 'flex';
  this.els.products.innerHTML = products.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  }
  this.staggerChildren(this.els.products, '.pf-card', 40);
  requestAnimationFrame(() => this.initCarousels());
 },

 clearResultsFilter() {
  this.currentFilterQuery = '';
  if (this.els.resultsFilterInput) this.els.resultsFilterInput.value = '';
  if (this.els.filterCount) this.els.filterCount.style.display = 'none';
  this.filteredProducts = [...this.allProducts];
  if (this.categoryTiles) this.filteredTiles = [...this.categoryTiles];
  if (this.currentCategory && !this.currentMake) {
  this.renderCategoryProducts(this.allProducts);
  } else {
  this.renderProducts(this.allProducts);
  }
 },

 showSearchLoading(query) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.products.style.display = 'none';
  this.els.resultsHeader.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.loading.style.display = 'block';
  this.els.loadingText.textContent = `Searching for "${query}"...`;
 },

 renderSearchResults(query, equipmentResults, productResults = []) {
  const hasEquipment = equipmentResults && equipmentResults.length > 0;
  const hasProducts = productResults && productResults.length > 0;
  const hasAnyResults = hasEquipment || hasProducts;

  this.allSearchEquipment = equipmentResults || [];
  this.allSearchProducts = productResults || [];
  this.filteredSearchEquipment = [...this.allSearchEquipment];
  this.filteredSearchProducts = [...this.allSearchProducts];

  if (this.els.searchFilterInput) this.els.searchFilterInput.value = '';
  if (this.els.searchFilterCount) this.els.searchFilterCount.style.display = 'none';

  this.els.loading.style.display = 'none';
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.products.style.display = 'none';
  this.els.resultsHeader.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'block';
  this.els.searchQuery.textContent = query;

  if (!hasAnyResults) {
  this.els.equipmentSection.style.display = 'none';
  this.els.productSection.style.display = 'none';
  this.els.searchNoResults.style.display = 'block';
  return;
  }

  this.els.searchNoResults.style.display = 'none';
  this.renderSearchEquipment(this.filteredSearchEquipment);
  this.renderSearchProducts(this.filteredSearchProducts);
 },

 renderSearchEquipment(equipmentResults) {
  if (equipmentResults && equipmentResults.length > 0) {
  this.els.equipmentSection.style.display = 'block';
  this.els.equipmentResults.innerHTML = equipmentResults.map(r => `
   <div class="pf-equipment-card" onclick="partsFinderApp.selectEquipmentFromSearch('${r.makeHandle}', '${r.modelHandle}', '${this.escapeHtml(r.make)}', '${this.escapeHtml(r.model)}')">
   <div class="pf-equipment-card-make">${this.escapeHtml(r.make)}</div>
   <div class="pf-equipment-card-model">${this.escapeHtml(r.model)}</div>
   ${r.productCount ? `<div class="pf-equipment-card-count">${r.productCount} product${r.productCount !== 1 ? 's' : ''} available</div>` : ''}
   <div class="pf-equipment-card-action">View Products &rarr;</div>
   </div>
  `).join('');
  } else {
  this.els.equipmentSection.style.display = 'none';
  }
 },

 renderSearchProducts(productResults) {
  if (productResults && productResults.length > 0) {
  this.els.productSection.style.display = 'block';
  this.els.productResults.innerHTML = productResults.map(p => `
  <div class="pf-card mainsearch-product-box">
   <a href="${p.url || '#'}" class="pf-search-product-card">
   <div class="pf-search-product-image featured-product-image">
    <img src="${p.featured_image || this.defaultImage}" alt="${this.escapeHtml(p.title)}" loading="lazy" onerror="this.src='${this.defaultImage}'">
   </div>
   <div class="pf-search-product-info">
    <h3 class="pf-search-product-title">${this.escapeHtml(p.title)}</h3>
    ${p.vendor ? `<div class="pf-search-product-vendor">by ${this.escapeHtml(p.vendor)}</div>` : ''}
   </div>
   </a>
   <div class="pf-card-actions featured-product-btn justify-content-between align-items-center">
   ${p.price ? `<div class="pf-search-product-price price">${p.price}</div>` : ''}
   </div>
   </div>
  `).join('');
  } else {
  this.els.productSection.style.display = 'none';
  }
 },

 onSearchResultsFilter(query) {
  query = query.trim();
  if (!this.allSearchEquipment && !this.allSearchProducts) return;
  const allEquipment = this.allSearchEquipment || [];
  const allProducts = this.allSearchProducts || [];
  const totalItems = allEquipment.length + allProducts.length;

  if (!query) {
  this.filteredSearchEquipment = [...allEquipment];
  this.filteredSearchProducts = [...allProducts];
  if (this.els.searchFilterCount) this.els.searchFilterCount.style.display = 'none';
  } else {
  const queryLower = query.toLowerCase();
  const terms = queryLower.split(/\s+/).filter(t => t.length > 0);
  this.filteredSearchEquipment = allEquipment.filter(eq => {
   const searchText = [eq.make || '', eq.model || ''].join(' ').toLowerCase();
   return terms.every(term => searchText.includes(term));
  });
  this.filteredSearchProducts = allProducts.filter(product => {
   const searchText = [product.title || '', product.vendor || '', product.product_type || ''].join(' ').toLowerCase();
   return terms.every(term => searchText.includes(term));
  });
  const filteredCount = this.filteredSearchEquipment.length + this.filteredSearchProducts.length;
  if (this.els.searchFilterCount) {
   this.els.searchFilterCount.style.display = 'inline';
   this.els.searchFilteredCount.textContent = filteredCount;
   this.els.searchTotalCount.textContent = totalItems;
  }
  }

  const hasResults = this.filteredSearchEquipment.length > 0 || this.filteredSearchProducts.length > 0;
  if (!hasResults && query) {
  this.els.equipmentSection.style.display = 'none';
  this.els.productSection.style.display = 'none';
  this.els.searchNoResults.style.display = 'block';
  this.els.searchNoResults.innerHTML = `<p>No matches found for "${this.escapeHtml(query)}". <a href="javascript:void(0)" onclick="partsFinderApp.clearSearchFilter()">Clear filter</a></p>`;
  } else {
  this.els.searchNoResults.style.display = 'none';
  this.renderSearchEquipment(this.filteredSearchEquipment);
  this.renderSearchProducts(this.filteredSearchProducts);
  }
 },

 clearSearchFilter() {
  if (this.els.searchFilterInput) this.els.searchFilterInput.value = '';
  if (this.els.searchFilterCount) this.els.searchFilterCount.style.display = 'none';
  this.filteredSearchEquipment = [...(this.allSearchEquipment || [])];
  this.filteredSearchProducts = [...(this.allSearchProducts || [])];
  this.els.searchNoResults.style.display = 'none';
  this.renderSearchEquipment(this.filteredSearchEquipment);
  this.renderSearchProducts(this.filteredSearchProducts);
 },

 hideSearchResults() {
  this.els.searchResults.style.display = 'none';
  this.els.equipmentSection.style.display = 'none';
  this.els.productSection.style.display = 'none';
  this.currentSearchQuery = '';
  if (this.els.searchFilterInput) this.els.searchFilterInput.value = '';
  if (this.els.searchFilterCount) this.els.searchFilterCount.style.display = 'none';
  this.allSearchEquipment = [];
  this.allSearchProducts = [];
  this.filteredSearchEquipment = [];
  this.filteredSearchProducts = [];
 },

 clearSearch() {
  this.els.quickSearchInput.value = '';
  this.currentSearchQuery = '';
  this.hideSearchResults();
  this.categoryProducts = null;
  this._categoryFilterMode = false;
  this._scopedMakes = null;
  this.restoreMakeModelFull();
  this.updateUrl();
  if (this.currentCategory) {
  this.selectCategory(this.currentCategory, this.currentCategoryName);
  } else if (this.currentMake && this.currentModel) {
  this.loadProducts();
  } else {
  this.showMakes();
  }
 },

 async selectEquipmentFromSearch(makeHandle, modelHandle, makeName, modelName) {
  if (makeHandle && modelHandle) {
   const collectionHandle = makeHandle + '-' + modelHandle;
   window.location.href = '/collections/' + collectionHandle;
   return;
  }
  this.els.quickSearchInput.value = '';
  this.currentSearchQuery = '';
  this.hideSearchResults();
  this.currentMake = makeHandle;
  this.currentMakeName = makeName;
  this.currentModel = modelHandle;
  this.currentModelName = modelName;
  if (this.makeTomSelect) this.makeTomSelect.setValue(makeHandle, true);
  await this.loadModels(makeHandle);
  if (this.modelTomSelect) this.modelTomSelect.setValue(modelHandle, true);
  this.updateUrl();
  this.loadProducts();
 },

 async attachLivePrices(products) {
  if (!Array.isArray(products) || products.length === 0) return products;
  const cache = this._livePriceCache || (this._livePriceCache = {});
  const TTL = 60000;
  const now = Date.now();
  const fmt = (cents) => '$' + (Math.round(cents) / 100).toFixed(2);

  await Promise.all(products.map(async (p) => {
   if (!p || !p.handle) return;
   const cached = cache[p.handle];
   if (cached && (now - cached.at) < TTL) {
    p.price = cached.price;
    p._priceSource = 'shopify-live-cache';
    return;
   }
   try {
    const r = await fetch('/products/' + encodeURIComponent(p.handle) + '.js', {
     headers: { 'Accept': 'application/json' }
    });
    if (!r.ok) return; // 404 / unpublished — keep portal price as fallback
    const sp = await r.json();
    const variants = sp.variants || [];
    let v = null;
    if (p.variant_id) v = variants.find(x => String(x.id) === String(p.variant_id));
    if (!v) v = variants[0];
    if (!v) return;
    const cents = typeof v.price === 'number' ? v.price : parseInt(v.price, 10);
    if (!isFinite(cents)) return;
    const formatted = fmt(cents);
    cache[p.handle] = { at: Date.now(), price: formatted };
    p.price = formatted;
    p._priceSource = 'shopify-live';
   } catch (e) {
   }
  }));

  return products;
 },

 async loadProducts() {
  if (!this.currentMake) return;

  this.showLoading();
  if (this.els.clearFilters) this.els.clearFilters.style.display = 'block';

  if (this.currentMake && this.currentModel) {
   this.saveRecentSearch({
    type: 'make-model',
    makeHandle: this.currentMake,
    modelHandle: this.currentModel,
    name: (this.currentMakeName || this.currentMake) + ' ' + (this.currentModelName || this.currentModel)
   });
  }

  try {
  let url = `${this.apiBaseUrl}/products?make_handle=${encodeURIComponent(this.currentMake)}`;
  if (this.currentModel) {
   url += `&model_handle=${encodeURIComponent(this.currentModel)}`;
  }
  if (this.currentProductCategory) {
   url += `&product_category=${this.currentProductCategory}`;
  }
  const response = await apiFetch(url);
  const data = await response.json();
  this.hideLoading();
  if (data.products && Array.isArray(data.products) && data.products.length > 0) {
   await this.attachLivePrices(data.products);
   this.allProducts = data.products;
   this.renderProducts(data.products);

   if (!this.currentModel && this.modelTomSelect) {
   this.pulseModelSelect();
   }
  } else {
   this.allProducts = [];
   this.showEmpty();
  }
  } catch (err) {
  this.hideLoading();
  this.showEmpty();
  }
 },

 pulseModelSelect() {
  const wrapper = this.modelTomSelect.wrapper;
  if (!wrapper) return;
  wrapper.classList.add('pf-pulse-hint');
  setTimeout(() => wrapper.classList.remove('pf-pulse-hint'), 3000);
 },

 _setEtVis(v){['pf-equipment-types','pf-mobile-equipment-types'].forEach(i=>{const e=document.getElementById(i);if(e){e.style.display=v?'':'none';const p=e.previousElementSibling;if(p)p.style.display=v?'':'none';}});},

 async loadEquipmentTypes() {
  const container = document.getElementById('pf-equipment-types');
  const mobileContainer = document.getElementById('pf-mobile-equipment-types');
  if (!container) return;

  try {
   const apiBase = this.apiBaseUrl.replace('/compatibility', '');
   const response = await apiFetch(`${apiBase}/equipment-categories/equipment-types`);
   const data = await response.json();

   if (data.success && data.equipment_types && data.equipment_types.length > 0) {
    this.equipmentTypes = data.equipment_types;
    this._setEtVis(true);

    if (this.currentCategory && !this.currentMake && !this.currentSearchQuery) {
     for (const group of data.equipment_types) {
      const found = (group.types || []).find(t => t.handle === this.currentCategory);
      if (found) {
       this._equipmentTypeResolved = true;
       this.selectEquipmentType(found.handle, found.name);
       break;
      }
     }
    }
    const html = data.equipment_types.map(group => {
     if (!group.types || group.types.length === 0) return '';
     const groupId = `et-${(group.handle || '').replace(/[^a-z0-9]/g, '-')}`;
     const isExpanded = this._expandedCategories && this._expandedCategories[groupId];
     let h = `<div class="pf-category-group" data-category-id="${groupId}">`;
     h += `<div class="pf-category-card">`;
     const safeIndustry = group.industry.replace(/'/g, "\\'");
     h += `<div style="display:flex;align-items:center;flex:1;gap:8px;cursor:pointer;" onclick="partsFinderApp.toggleCategoryExpand('${groupId}'); partsFinderApp.setBrowseMode('equipment'); partsFinderApp.showEquipmentTypeGroup('${safeIndustry}');">`;
     h += `<span class="pf-category-name">${group.industry}</span>`;
     h += `<span class="pf-category-toggle ${isExpanded ? 'expanded' : ''}">&rsaquo;</span>`;
     h += `</div>`;
     h += `</div>`;
     h += `<div class="pf-subcategories ${isExpanded ? 'expanded' : ''}" id="pf-subcats-${groupId}">`;
     h += group.types.map(type => {
      const safeName = (type.name || '').replace(/'/g, "\\'");
      const typeId = type.id || type.handle;
      return `<div class="pf-category-card" style="padding-left:24px;" onclick="partsFinderApp.selectEquipmentType('${type.handle}', '${safeName}')">
       <div style="display:flex;align-items:center;flex:1;gap:8px;">
        <span class="pf-category-name">${type.name}</span>
        <span style="font-size:11px;color:#888;">${type.product_count}</span>
       </div>
      </div>`;
     }).join('');
     h += `</div></div>`;
     return h;
    }).join('');

    container.innerHTML = html;
    if (mobileContainer) mobileContainer.innerHTML = html;
    const section = document.getElementById('pf-equipment-types-section');
    const mobileSection = document.getElementById('pf-mobile-equipment-types-section');
    if (section) section.style.display = '';
    if (mobileSection) mobileSection.style.display = '';
    const etBtn = document.getElementById('pf-browse-btn-equipment');
    if (etBtn) etBtn.style.display = '';
   } else {
    container.innerHTML = '';
    if (mobileContainer) mobileContainer.innerHTML = '';
    this._setEtVis(false);
   }
  } catch (err) {
   container.innerHTML = '';
   this._setEtVis(false);
  }
 },

 selectEquipmentType(typeHandle, typeName) {
  let catId = null;
  if (this.equipmentTypes) {
   for (const group of this.equipmentTypes) {
    const found = (group.types || []).find(t => t.handle === typeHandle);
    if (found && found.id) { catId = found.id; break; }
   }
  }

  this.currentMake = null;
  this.currentMakeName = null;
  this.currentModel = null;
  this.currentModelName = null;
  this.currentSearchQuery = '';
  if (this.els.quickSearchInput) this.els.quickSearchInput.value = '';
  this.funnelStep = null;
  this.funnelSelections = { type: null, tread: null, width: null, size: null };

  this.currentCategory = catId || typeHandle;
  this.currentCategoryName = typeName;
  this.currentParentCategory = null;
  this.currentParentCategoryName = null;

  if (this.makeTomSelect) this.makeTomSelect.clear(true);
  if (this.modelTomSelect) this.modelTomSelect.clear(true);

  this.updateUrl();
  const url = new URL(window.location.href);
  url.searchParams.set('category', typeHandle);
  window.history.replaceState({}, '', url.toString());

  this.loadCategoryProducts();
 },

 async loadCategories() {
  const container = document.getElementById('pf-categories');
  if (!container) return;

  try {
  const apiBase = this.apiBaseUrl.replace('/compatibility', '');
  const response = await apiFetch(`${apiBase}/equipment-categories/tree`);
  const data = await response.json();

  if (data.success && data.categories && data.categories.length > 0) {
   this.allCategories = data.categories;

   if (this.currentCategory) {
   this.expandParentOfCategory(this.currentCategory);
   }

   this.renderCategories(data.categories);

   if (this.currentCategory) {
   const cat = this.findCategoryInTree(this.currentCategory);
   if (cat && cat.children && cat.children.length > 0) {
    this.renderSubcategoryTiles(cat);
   } else if (cat) {
    this.loadCategoryProducts();
   }
   } else if (!this.currentMake && !this.currentSearchQuery) {
   this.renderDefaultCategoryGrid();
   }
  } else {
   container.innerHTML = '<div class="pf-category-loading">No categories available</div>';
  }
  } catch (err) {
  container.innerHTML = '';
  }
 },

 async loadStorefrontConfig() {
  try {
  const apiBase = this.apiBaseUrl.replace('/compatibility', '');
  const response = await apiFetch(`${apiBase}/storefront-config`);
  const data = await response.json();
  if (data.stock_alerts) {
   this.stockAlerts = data.stock_alerts;
  }
  if (data.volume_discounts) {
   this.volumeDiscounts = data.volume_discounts;
  }
  } catch (err) {
  }
 },

 async loadTreadTypeImages() {
  try {
  const apiBase = this.apiBaseUrl.replace('/compatibility', '');
  const response = await apiFetch(`${apiBase}/tread-types`);
  const data = await response.json();
  if (data.tread_types) {
   this._dynamicTreadTypes = data.tread_types.sort((a, b) => (a.sort || 99) - (b.sort || 99));
   this.treadSortOrder = {};
   data.tread_types.forEach((tt, i) => {
   const img = (tt.images && tt.images.length > 0) ? tt.images[0] : tt.image_data || null;
   const baseAliases = [tt.name];
   if (tt.name.endsWith(' Tread')) baseAliases.push(tt.name.slice(0, -6));
   else if (tt.name.endsWith(' Tread ')) baseAliases.push(tt.name.slice(0, -7));
   const nameAliases = [...new Set([...baseAliases, ...baseAliases.map(n => n.toLowerCase())])];
   if (img) {
    nameAliases.forEach(n => { if (n && !this.treadTypeImages[n]) this.treadTypeImages[n] = img; });
    (tt.keywords || []).forEach(kw => {
     if (kw && !this.treadTypeImages[kw]) this.treadTypeImages[kw] = img;
     if (kw) this.treadTypeImages[kw.toLowerCase()] = this.treadTypeImages[kw.toLowerCase()] || img;
    });
    (tt.suffixes || []).forEach(s => { if (s && !this.treadTypeImages[s]) this.treadTypeImages[s] = img; });
   }
   if (tt.color) {
    nameAliases.forEach(n => { if (n && !this.treadBadgeColors[n]) this.treadBadgeColors[n] = tt.color; });
    (tt.keywords || []).forEach(kw => {
     if (kw && !this.treadBadgeColors[kw]) this.treadBadgeColors[kw] = tt.color;
     if (kw) this.treadBadgeColors[kw.toLowerCase()] = this.treadBadgeColors[kw.toLowerCase()] || tt.color;
    });
    (tt.suffixes || []).forEach(s => { if (s && !this.treadBadgeColors[s]) this.treadBadgeColors[s] = tt.color; });
   }
   nameAliases.forEach(n => { if (n) this.treadSortOrder[n] = tt.sort != null ? tt.sort : i; });
   this.treadSortOrder[tt.name] = tt.sort != null ? tt.sort : i;
   });
  }
  } catch (err) {
  }
  try {
  const sd = await apiFetch(`${this.apiBaseUrl}/search?q=rubber+track&limit=200`).then(r => r.json());
  this._browseSampleProducts = sd.products || [];
  this._browseSampleProducts.forEach(p => {
   const img = p.featured_image || (p.images && p.images[0]);
   if (!img || img === this.defaultImage) return;
   const tn = this.classifyTread(p);
   if (tn && !this.treadTypeImages[tn]) {
    this.treadTypeImages[tn] = img;
    if (!this.treadTypeImages[tn + ' Tread']) this.treadTypeImages[tn + ' Tread'] = img;
    if (!this.treadTypeImages[tn.replace(/ Tread$/, '')]) this.treadTypeImages[tn.replace(/ Tread$/, '')] = img;
    if (!this.treadTypeImages[tn.toLowerCase()]) this.treadTypeImages[tn.toLowerCase()] = img;
   }
  });
  if (this.browseMode === 'tread' && this.els.makesGrid) this._renderTreadTiles(this.els.makesGrid);
  if (this.funnelStep === 'treads' && this.els.products) {
   const treadGroups = this.groupByTread(this.allProducts || []);
   if (treadGroups.length > 1) {
    this.renderFunnelTreadCards(treadGroups, this.funnelSelections && this.funnelSelections.type || 'Tracks');
   }
  }
  } catch(e) {}
 },

 renderCategories(categories) {
  const container = document.getElementById('pf-categories');
  if (!container) return;
  container.innerHTML = categories.map(cat => this.renderCategoryItem(cat)).join('');

  const mobileCats = document.getElementById('pf-mobile-categories');
  if (mobileCats && this._mobileInited) {
  mobileCats.innerHTML = categories.map(cat => this.renderMobileCategoryItem(cat)).join('');
  }
 },

 renderCategoryItem(cat, depth) {
  depth = depth || 0;
  const isActive = this.currentCategory === cat.handle || this.currentCategory === cat.id;
  const hasChildren = cat.children && cat.children.length > 0;
  const isExpanded = hasChildren && this.isCategoryExpanded(cat);
  const safeName = (cat.display_name || cat.name || '').replace(/'/g, "\\'");

  let html = `<div class="pf-category-group" data-category-id="${cat.id}">`;

  html += `<div class="pf-category-card ${isActive ? 'active' : ''}"${depth > 0 ? ' style="padding-left:' + (12 + depth * 12) + 'px"' : ''}>`;
  html += `<div style="display:flex;align-items:center;flex:1;gap:8px;" onclick="partsFinderApp.selectCategory('${cat.handle || cat.id}', '${safeName}')">`;
  html += `<span class="pf-category-name">${cat.display_name || cat.name}</span>`;
  html += `</div>`;

  if (hasChildren) {
  html += `<span class="pf-category-toggle ${isExpanded ? 'expanded' : ''}" onclick="event.stopPropagation(); partsFinderApp.toggleCategoryExpand('${cat.id}')" title="Expand subcategories">&rsaquo;</span>`;
  }
  html += `</div>`;

  if (hasChildren) {
  html += `<div class="pf-subcategories ${isExpanded ? 'expanded' : ''}" id="pf-subcats-${cat.id}">`;
  html += cat.children.map(child => this.renderCategoryItem(child, depth + 1)).join('');
  html += `</div>`;
  }

  html += `</div>`;
  return html;
 },

 isCategoryExpanded(cat) {
  return !!this._expandedCategories[cat.id];
 },

 toggleCategoryExpand(categoryId) {
  const subContainer = document.getElementById(`pf-subcats-${categoryId}`);
  const group = document.querySelector(`[data-category-id="${categoryId}"]`);
  const toggle = group ? group.querySelector('.pf-category-toggle') : null;
  if (subContainer) {
  const isExpanded = subContainer.classList.contains('expanded');
  subContainer.classList.toggle('expanded');
  if (toggle) toggle.classList.toggle('expanded');
  this._expandedCategories[categoryId] = !isExpanded;
  }
 },

 expandParentOfCategory(categoryHandle) {
  if (!this.allCategories) return;
  const _expand = (cats) => {
  for (const cat of cats) {
   if (cat.handle === categoryHandle || cat.id === categoryHandle) return true;
   if (cat.children && _expand(cat.children)) {
   this._expandedCategories[cat.id] = true;
   return true;
   }
  }
  return false;
  };
  _expand(this.allCategories);
 },

 findCategoryInTree(handleOrId) {
  if (!this.allCategories) return null;
  const _find = (cats) => {
  for (const cat of cats) {
   if (cat.handle === handleOrId || cat.id === handleOrId) return cat;
   if (cat.children) {
   const found = _find(cat.children);
   if (found) return found;
   }
  }
  return null;
  };
  return _find(this.allCategories);
 },

 findParentCategory(handleOrId) {
  if (!this.allCategories) return null;
  const _findParent = (cats) => {
  for (const cat of cats) {
   if (cat.children) {
   if (cat.children.some(c => c.handle === handleOrId || c.id === handleOrId)) return cat;
   const found = _findParent(cat.children);
   if (found) return found;
   }
  }
  return null;
  };
  return _findParent(this.allCategories);
 },

 findCategoryAncestors(handleOrId) {
  if (!this.allCategories) return [];
  const _find = (cats, path) => {
  for (const cat of cats) {
   if (cat.handle === handleOrId || cat.id === handleOrId) return path;
   if (cat.children) {
   const found = _find(cat.children, [...path, cat]);
   if (found) return found;
   }
  }
  return null;
  };
  return _find(this.allCategories, []) || [];
 },

 getCategoryDisplayName() {
  const parts = (this.categoryAncestors || []).map(a => a.display_name || a.name);
  if (this.currentCategoryName) parts.push(this.currentCategoryName);
  return parts.join(' > ') || this.currentCategoryName || this.currentCategory;
 },

 selectCategory(categoryHandle, categoryName) {
  this.currentMake = null;
  this.currentMakeName = null;
  this.currentModel = null;
  this.currentModelName = null;
  this.currentSearchQuery = '';
  if (this.els.quickSearchInput) this.els.quickSearchInput.value = '';

  this.funnelStep = null;
  this.funnelSelections = { type: null, tread: null, width: null, size: null };
  this._pendingFunnel = null;
  this.browseMode = null;
  this.browseMfr = null;
  this.browseMfrName = null;
  this.browseModel = null;
  this.browseModelName = null;

  this.currentCategory = categoryHandle;
  this.currentCategoryName = categoryName;

  this.categoryAncestors = this.findCategoryAncestors(categoryHandle);
  const parentCat = this.categoryAncestors.length > 0 ? this.categoryAncestors[this.categoryAncestors.length - 1] : null;
  this.currentParentCategory = parentCat ? (parentCat.handle || parentCat.id) : null;
  this.currentParentCategoryName = parentCat ? (parentCat.display_name || parentCat.name) : null;

  this.expandParentOfCategory(categoryHandle);

  if (this.makeTomSelect) this.makeTomSelect.clear(true);
  if (this.modelTomSelect) this.modelTomSelect.clear(true);
  this.renderCategories(this.allCategories);

  this.updateUrl();

  const cat = this.findCategoryInTree(this.currentCategory);
  if (cat && cat.children && cat.children.length > 0) {
  this.renderSubcategoryTiles(cat);
  } else {
  this.loadCategoryProducts();
  }
 },

 renderSubcategoryTiles(parentCat) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.resultsHeader.style.display = 'block';
  this.els.products.style.display = 'flex';
  this.els.products.classList.add('pf-grid-view');
  if (this.els.clearFilters) this.els.clearFilters.style.display = 'block';

  const displayName = parentCat.display_name || parentCat.name;
  this.els.resultCount.textContent = parentCat.children.length;
  this.els.searchTitle.textContent = displayName;

  this.categoryTiles = null;
  this.filteredTiles = null;
  this.allProducts = [];
  this.filteredProducts = [];
  if (this.els.resultsFilterInput) this.els.resultsFilterInput.value = '';
  if (this.els.filterCount) this.els.filterCount.style.display = 'none';

  this.els.products.innerHTML = parentCat.children.map(child => {
  const safeName = (child.display_name || child.name || '').replace(/'/g, "\\'");
  const imgHtml = child.image_url ? `<img src="${child.image_url}" alt="${this.escapeHtml(child.display_name || child.name)}" loading="lazy" onerror="this.style.display='none'">` : '';
  return `<div class="pf-model-card pf-category-tile" onclick="partsFinderApp.selectCategory('${child.handle || child.id}', '${safeName}')">${imgHtml}<div class="pf-model-card-name">${child.display_name || child.name}</div><div class="pf-equipment-card-action">Browse &rarr;</div></div>`;
  }).join('');
  this.staggerChildren(this.els.products, '.pf-category-tile', 50);

  this.loadCategoryProductsSilent(parentCat);
  this.updateFilterChips();
  this.scrollToTop();
 },

 async loadCategoryProductsSilent(cat) {
  try {
  const apiBase = this.apiBaseUrl.replace('/compatibility', '');
  const catId = cat ? cat.id : this.currentCategory;
  const response = await apiFetch(`${apiBase}/equipment-categories/${catId}/products`);
  const data = await response.json();
  if (data.success && data.products) {
   await this.attachLivePrices(data.products);
   this.allProducts = data.products;
  }
  } catch (err) {
  }
 },

 async loadCategoryProducts() {
  if (!this.currentCategory) return;

  this.showLoading('Loading products...');
  if (this.els.clearFilters) this.els.clearFilters.style.display = 'block';

  const cat = this.findCategoryInTree(this.currentCategory);
  if (cat) {
  this.currentCategoryName = cat.display_name || cat.name;
  }

  try {
  const apiBase = this.apiBaseUrl.replace('/compatibility', '');
  const catId = cat ? cat.id : this.currentCategory;
  const response = await apiFetch(`${apiBase}/equipment-categories/${catId}/products`);
  const data = await response.json();

  this.hideLoading();

  if (data.success && data.products && data.products.length > 0) {
   await this.attachLivePrices(data.products);
   this.allProducts = data.products;
   this.renderCategoryProducts(data.products);
  } else {
   this.allProducts = [];
   this.showEmpty();
  }
  } catch (err) {
  this.hideLoading();
  this.showEmpty();
  }
 },

 renderCategoryProducts(products) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.resultsHeader.style.display = 'block';
  this.els.products.style.display = 'flex';
  this.els.products.classList.add('pf-grid-view');

  this.filteredProducts = [...products];
  this.currentFilterQuery = '';
  if (this.els.resultsFilterInput) this.els.resultsFilterInput.value = '';
  if (this.els.filterCount) this.els.filterCount.style.display = 'none';

  const displayName = this.getCategoryDisplayName();

  if (products.length === 0) {
  this.els.products.innerHTML = '';
  this.showEmpty();
  return;
  }

  this.categoryProducts = products;
  this.categoryTiles = null;
  this.filteredTiles = null;
  this.allProducts = products;

  this.els.resultCount.textContent = products.length;
  this.els.searchTitle.textContent = displayName;

  if (this.restoreBrowseFromUrl(products)) {
  this.scopeMakeModelToProducts(products);
  this.updateFilterChips();
  return;
  }
  if (this.restoreFunnelFromUrl()) {
  this.scopeMakeModelToProducts(products);
  this.updateFilterChips();
  return;
  }

  const manufacturers = this.groupByManufacturer(products);
  const hasSizes = this.shouldShowTrackFunnel(products);
  const hasManufacturers = manufacturers.length >= 2;

  this._hasBrowseSizes = hasSizes;
  this._hasBrowseManufacturers = hasManufacturers;

  if (hasSizes) {
  this.browseMode = 'tread';
  this.buildTypeTabs(products);
  this.funnelSelections = { type: 'Tracks', tread: null, width: null, size: null };
  this.activeTypeTab = 'Tracks';

  const treadGroups = this.groupByTread(products);
  if (treadGroups.length > 1) {
   this.funnelStep = 'treads';
   this.renderFunnelTreadCards(treadGroups, 'Tracks');
  } else {
   this.browseMode = 'size';
   const trackProducts = products.filter(p => {
    const pType = (p.product_type || p.type || '').trim();
    return pType === 'Tracks' || pType === 'TWA' || (p.normalized_dimensions && p.normalized_dimensions.size_key);
   });
   const sizeGroups = this.groupBySize(trackProducts);
   const widthGroups = this.groupSizesByWidth(sizeGroups);
   if (Object.keys(widthGroups).length > 1) {
    this.funnelStep = 'widths';
    this.renderFunnelWidthCards(widthGroups, trackProducts.length);
   } else if (sizeGroups.length > 0) {
    this.funnelStep = 'sizes';
    this.renderFunnelSizeCards(sizeGroups);
   } else {
    this.funnelStep = 'products';
    this.showFunnelProducts(products);
   }
  }
  this.injectBrowseToggle(this.browseMode);
  this.updateFunnelUrl();
  this.scopeMakeModelToProducts(products);
  this.updateFilterChips();
  this.scrollToTop();
  return;
  }

  this.browseMode = hasManufacturers ? 'products' : null;
  this.markBestValue(products);
  this.els.products.innerHTML = products.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());
  if (hasManufacturers) this.injectBrowseToggle('products');

  this.scopeMakeModelToProducts(products);

  this.updateFilterChips();
  this.scrollToTop();
 },

 shouldShowTrackFunnel(products) {
  if (!products || products.length < 2) return false;

  const catName = (this.currentCategoryName || '').toLowerCase();

  if (catName.includes('tire') || catName.includes('solid') || catName.includes('pneumatic')) {
  return false;
  }

  if (catName.includes('track') && !catName.includes('undercarriage')) {
  return true;
  }

  const withDims = products.filter(p =>
  p.normalized_dimensions && p.normalized_dimensions.size_key
  ).length;
  if (withDims < 2) return false;

  const trackCount = products.filter(p => {
  const type = (p.product_type || p.type || '').trim();
  return type === 'Tracks' || type === 'TWA';
  }).length;
  return trackCount >= products.length * 0.6;
 },

 groupByManufacturer(products) {
  const mfrMap = {};
  products.forEach(product => {
  const models = product.compatible_models || [];
  models.forEach(cm => {
   const mfr = (cm.manufacturer || cm.make || '').trim();
   if (!mfr) return;
   const mfrHandle = cm.make_handle || this.slugify(mfr);
   const model = (cm.model || cm.name || '').trim();
   const modelHandle = cm.model_handle || cm.handle || this.slugify(model);

   if (!mfrMap[mfrHandle]) {
   mfrMap[mfrHandle] = { name: mfr, handle: mfrHandle, models: {}, productIds: new Set() };
   }
   mfrMap[mfrHandle].productIds.add(product.id || product.handle);

   if (model) {
   if (!mfrMap[mfrHandle].models[modelHandle]) {
    mfrMap[mfrHandle].models[modelHandle] = { name: model, handle: modelHandle, productIds: new Set() };
   }
   mfrMap[mfrHandle].models[modelHandle].productIds.add(product.id || product.handle);
   }
  });
  });

  return Object.values(mfrMap)
  .map(mfr => ({
   name: mfr.name,
   handle: mfr.handle,
   productCount: mfr.productIds.size,
   models: Object.values(mfr.models)
   .map(m => ({ name: m.name, handle: m.handle, count: m.productIds.size }))
   .sort((a, b) => a.name.localeCompare(b.name))
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
 },

 injectBrowseToggle(activeMode) {
  const existing = document.getElementById('pf-browse-toggle');
  if (existing) existing.remove();

  const products = this.categoryProducts || this.allProducts || [];
  const manufacturers = this.groupByManufacturer(products);
  const mfrCount = manufacturers.length;
  const hasSizes = this._hasBrowseSizes;

  const toggle = document.createElement('div');
  toggle.id = 'pf-browse-toggle';
  toggle.className = 'pf-browse-toggle';

  let btns = '';

  if (hasSizes) {
  btns += `<button class="pf-browse-toggle-btn ${activeMode === 'size' ? 'active' : ''}" data-mode="size" onclick="partsFinderApp.switchBrowseMode('size')">By Size</button>`;
  const treadCount = this.groupByTread(products).length;
  btns += `<button class="pf-browse-toggle-btn ${activeMode === 'tread' ? 'active' : ''}" data-mode="tread" onclick="partsFinderApp.switchBrowseMode('tread')">By Tread <span class="pf-browse-toggle-count">${treadCount}</span></button>`;
  }
  btns += `<button class="pf-browse-toggle-btn ${activeMode === 'manufacturer' ? 'active' : ''}" data-mode="manufacturer" onclick="partsFinderApp.switchBrowseMode('manufacturer')">By Manufacturer <span class="pf-browse-toggle-count">${mfrCount}</span></button>`;
  btns += `<button class="pf-browse-toggle-btn ${activeMode === 'products' ? 'active' : ''}" data-mode="products" onclick="partsFinderApp.switchBrowseMode('products')">All Products</button>`;

  toggle.innerHTML = `<div class="pf-browse-toggle-track">${btns}</div>`;
  this.els.products.insertBefore(toggle, this.els.products.firstChild);
 },

 switchBrowseMode(mode) {
  if (mode === this.browseMode) return;

  const btns = document.querySelectorAll('.pf-browse-toggle-btn');
  btns.forEach(btn => btn.classList.toggle('active', btn.dataset.mode === mode));

  if (mode === 'size') {
  this.selectBrowseBySize();
  } else if (mode === 'tread') {
  this.selectBrowseByTread();
  } else if (mode === 'manufacturer') {
  this.selectBrowseByManufacturer();
  } else if (mode === 'products') {
  this.selectBrowseAllProducts();
  }
 },

 selectBrowseBySize() {
  this.browseMode = 'size';
  this.browseMfr = null;
  this.browseMfrName = null;
  this.browseModel = null;
  this.browseModelName = null;
  this.funnelStep = null;
  this.funnelSelections = { type: 'Tracks', tread: null, width: null, size: null };
  this.activeTypeTab = 'Tracks';

  const products = this.categoryProducts || this.allProducts || [];
  this.buildTypeTabs(products);

  const trackProducts = products.filter(p => {
   const pType = (p.product_type || p.type || '').trim();
   return pType === 'Tracks' || pType === 'TWA' || (p.normalized_dimensions && p.normalized_dimensions.size_key);
  });
  const sizeGroups = this.groupBySize(trackProducts);
  const widthGroups = this.groupSizesByWidth(sizeGroups);

  this.transitionContent(() => {
  if (Object.keys(widthGroups).length > 1) {
   this.funnelStep = 'widths';
   this.renderFunnelWidthCards(widthGroups, trackProducts.length);
  } else if (sizeGroups.length > 0) {
   this.funnelStep = 'sizes';
   this.renderFunnelSizeCards(sizeGroups);
  } else {
   this.funnelStep = 'products';
   this.showFunnelProducts(products);
  }
  this.injectBrowseToggle('size');
  });
  this.updateFunnelUrl();
  this.updateFilterChips();
 },

 selectBrowseByTread() {
  this.browseMode = 'tread';
  this.browseMfr = null;
  this.browseMfrName = null;
  this.browseModel = null;
  this.browseModelName = null;
  this.funnelStep = null;
  this.funnelSelections = { type: 'Tracks', tread: null, width: null, size: null };
  this.activeTypeTab = 'Tracks';

  const products = this.categoryProducts || this.allProducts || [];
  this.buildTypeTabs(products);
  const treadGroups = this.groupByTread(products);

  this.transitionContent(() => {
  if (treadGroups.length > 1) {
   this.funnelStep = 'treads';
   this.renderFunnelTreadCards(treadGroups, 'Tracks');
  } else if (treadGroups.length === 1) {
   const [singleTread, singleTreadProducts] = treadGroups[0];
   this.funnelSelections.tread = singleTread;
   this.activeTreadTab = singleTread;
   const sizeGroups = this.groupBySize(singleTreadProducts);
   this.funnelStep = 'sizes';
   this.renderFunnelSizeCards(sizeGroups);
  } else {
   this.funnelStep = 'products';
   this.showFunnelProducts(products);
  }
  this.injectBrowseToggle('tread');
  });
  this.updateFunnelUrl();
  this.updateFilterChips();
 },

 selectBrowseByManufacturer() {
  const products = this.categoryProducts || this.allProducts || [];
  const manufacturers = this.groupByManufacturer(products);
  this.browseMode = 'manufacturer';
  this.browseMfr = null;
  this.browseMfrName = null;
  this.browseModel = null;
  this.browseModelName = null;
  this.funnelStep = null;
  this.funnelSelections = { type: null, tread: null, width: null, size: null };
  this._mfrLetterFilter = null;
  this._mfrTileLetterFilter = null;
  this.hideTypeTabs();

  this.transitionContent(() => {
  this.renderManufacturerCards(manufacturers, products);
  this.injectBrowseToggle('manufacturer');
  });
  this.updateBrowseUrl();
  this.updateFilterChips();
 },

 selectBrowseAllProducts() {
  this.browseMode = 'products';
  this.browseMfr = null;
  this.browseMfrName = null;
  this.browseModel = null;
  this.browseModelName = null;
  this.funnelStep = null;
  this.funnelSelections = { type: null, tread: null, width: null, size: null };
  this.hideTypeTabs();

  const products = this.categoryProducts || this.allProducts || [];
  this.markBestValue(products);
  this.transitionContent(() => {
  this.els.products.classList.add('pf-grid-view');
  this.els.products.style.display = 'flex';
  this.els.products.innerHTML = products.map((p, idx) => this.renderCategoryProductCard(p, idx)).join('');
  if (this._hasBrowseManufacturers) this.injectBrowseToggle('products');
  requestAnimationFrame(() => this.initCarousels());
  });
  this.updateBrowseUrl();
  this.updateFilterChips();
 },

 renderManufacturerCards(manufacturers, products) {
  let html = this.renderBrowseBreadcrumb();

  if (!this._mfrLetterFilter) {
  const letterMap = {};
  manufacturers.forEach(mfr => {
   const letter = mfr.name.charAt(0).toUpperCase();
   if (!letterMap[letter]) letterMap[letter] = 0;
   letterMap[letter]++;
  });
  html += '<div class="pf-funnel-grid pf-mfr-letter-grid">';
  Object.keys(letterMap).sort().forEach(letter => {
   const count = letterMap[letter];
   html += `<div class="pf-funnel-card pf-letter-bucket-card" onclick="partsFinderApp.selectMfrLetter('${letter}')">
    <div class="pf-letter-bucket-char">${letter}</div>
    <div class="pf-funnel-card-count">${count}</div>
    <div class="pf-funnel-card-label">brand${count !== 1 ? 's' : ''}</div>
    <div class="pf-funnel-card-action">Browse &rarr;</div>
   </div>`;
  });
  html += '</div>';
  } else {
  const filtered = manufacturers.filter(m => m.name.charAt(0).toUpperCase() === this._mfrLetterFilter);
  html += `<div style="padding:0 4px 12px;display:flex;align-items:center;gap:12px;">
   <button class="pf-back-btn" onclick="partsFinderApp.clearMfrLetterFilter()">&larr; All Brands</button>
   <span style="font-size:22px;font-weight:800;color:#4fc3f7;">${this._mfrLetterFilter}</span>
  </div>`;
  html += '<div class="pf-funnel-grid">';
  filtered.forEach(mfr => {
   const safeName = mfr.name.replace(/'/g, "\\'");
   const safeHandle = mfr.handle.replace(/'/g, "\\'");
   const initial = mfr.name.charAt(0).toUpperCase();
   html += `<div class="pf-funnel-card pf-mfr-card" onclick="partsFinderApp.selectBrowseMfr('${safeHandle}', '${safeName}')">
    <div class="pf-mfr-card-initial">${initial}</div>
    <div class="pf-funnel-card-count">${mfr.productCount}</div>
    <div class="pf-funnel-card-label">product${mfr.productCount !== 1 ? 's' : ''}</div>
    <div class="pf-funnel-card-name">${this.escapeHtml(mfr.name)}</div>
    <div class="pf-funnel-card-sublabel">${mfr.models.length} model${mfr.models.length !== 1 ? 's' : ''}</div>
    <div class="pf-funnel-card-action">View models &rarr;</div>
   </div>`;
  });
  html += '</div>';
  }

  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  this.staggerChildren(this.els.products, '.pf-funnel-card', 30);
 },

 selectMfrLetter(letter) {
  this._mfrLetterFilter = letter;
  const products = this.categoryProducts || this.allProducts || [];
  const manufacturers = this.groupByManufacturer(products);
  this.renderManufacturerCards(manufacturers, products);
  this.injectBrowseToggle('manufacturer');
 },

 clearMfrLetterFilter() {
  this._mfrLetterFilter = null;
  const products = this.categoryProducts || this.allProducts || [];
  const manufacturers = this.groupByManufacturer(products);
  this.renderManufacturerCards(manufacturers, products);
  this.injectBrowseToggle('manufacturer');
 },

 selectBrowseMfr(mfrHandle, mfrName) {
  this.browseMfr = mfrHandle;
  this.browseMfrName = mfrName;
  this.browseModel = null;
  this.browseModelName = null;

  const products = this.categoryProducts || this.allProducts || [];
  const mfrProducts = products.filter(p =>
  (p.compatible_models || []).some(cm => {
   const h = cm.make_handle || this.slugify(cm.manufacturer || cm.make || '');
   return h === mfrHandle;
  })
  );

  const modelMap = {};
  mfrProducts.forEach(p => {
  (p.compatible_models || []).forEach(cm => {
   const h = cm.make_handle || this.slugify(cm.manufacturer || cm.make || '');
   if (h !== mfrHandle) return;
   const model = (cm.model || cm.name || '').trim();
   const modelHandle = cm.model_handle || cm.handle || this.slugify(model);
   if (!model) return;
   if (!modelMap[modelHandle]) modelMap[modelHandle] = { name: model, handle: modelHandle, productIds: new Set() };
   modelMap[modelHandle].productIds.add(p.id || p.handle);
  });
  });

  const models = Object.values(modelMap)
  .map(m => ({ name: m.name, handle: m.handle, count: m.productIds.size }))
  .sort((a, b) => a.name.localeCompare(b.name));

  this.transitionContent(() => this.renderModelCards(models, mfrName, mfrProducts));
  this.updateBrowseUrl();
  this.updateFilterChips();
 },

 renderModelCards(models, mfrName, mfrProducts) {
  let html = this.renderBrowseBreadcrumb();

  html += '<div class="pf-funnel-grid">';
  const safeHandle = (this.browseMfr || '').replace(/'/g, "\\'");
  const safeName = (mfrName || '').replace(/'/g, "\\'");
  html += `<div class="pf-funnel-card pf-model-browse-all" onclick="partsFinderApp.selectBrowseModelAll('${safeHandle}', '${safeName}')"><div class="pf-funnel-card-count">${mfrProducts.length}</div><div class="pf-funnel-card-label">product${mfrProducts.length!==1?'s':''}</div><div class="pf-funnel-card-name">All ${this.escapeHtml(mfrName)}</div><div class="pf-funnel-card-action">View all products</div></div>`;

  models.forEach(model => {
  const safeModelName = model.name.replace(/'/g, "\\'");
  const safeModelHandle = model.handle.replace(/'/g, "\\'");
  html += `<div class="pf-funnel-card pf-model-card-browse" onclick="partsFinderApp.selectBrowseModel('${safeHandle}', '${safeModelHandle}', '${safeName}', '${safeModelName}')"><div class="pf-funnel-card-count">${model.count}</div><div class="pf-funnel-card-label">product${model.count!==1?'s':''}</div><div class="pf-funnel-card-name">${this.escapeHtml(model.name)}</div><div class="pf-funnel-card-action">View products &rarr;</div></div>`;
  });

  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  this.staggerChildren(this.els.products, '.pf-funnel-card', 30);
 },

 selectBrowseModelAll(mfrHandle, mfrName) {
  this.browseMfr = mfrHandle;
  this.browseMfrName = mfrName;
  this.browseModel = '__all__';
  this.browseModelName = 'All ' + mfrName;

  const products = this.categoryProducts || this.allProducts || [];
  const mfrProducts = products.filter(p =>
  (p.compatible_models || []).some(cm => {
   const h = cm.make_handle || this.slugify(cm.manufacturer || cm.make || '');
   return h === mfrHandle;
  })
  );

  this.filteredProducts = mfrProducts;
  this.transitionContent(() => {
  let html = this.renderBrowseBreadcrumb();
  html += '<div style="display:flex;flex-wrap:wrap;gap:15px;padding:0 0 16px;">';
  this.markBestValue(mfrProducts);
  html += mfrProducts.map((p, idx) => this.renderCategoryProductCard(p, idx)).join('');
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  requestAnimationFrame(() => this.initCarousels());
  });

  this.els.resultCount.textContent = mfrProducts.length;
  this.updateBrowseUrl();
  this.updateFilterChips();
 },

 selectBrowseModel(mfrHandle, modelHandle, mfrName, modelName) {
  this.browseMfr = mfrHandle;
  this.browseMfrName = mfrName;
  this.browseModel = modelHandle;
  this.browseModelName = modelName;

  const products = this.categoryProducts || this.allProducts || [];
  const modelProducts = products.filter(p =>
  (p.compatible_models || []).some(cm => {
   const mh = cm.make_handle || this.slugify(cm.manufacturer || cm.make || '');
   const modelH = cm.model_handle || cm.handle || this.slugify(cm.model || cm.name || '');
   return mh === mfrHandle && modelH === modelHandle;
  })
  );

  this.filteredProducts = modelProducts;
  this.transitionContent(() => {
  let html = this.renderBrowseBreadcrumb();
  html += '<div style="display:flex;flex-wrap:wrap;gap:15px;padding:0 0 16px;">';
  this.markBestValue(modelProducts);
  html += modelProducts.map((p, idx) => this.renderCategoryProductCard(p, idx)).join('');
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  requestAnimationFrame(() => this.initCarousels());
  });

  this.els.resultCount.textContent = modelProducts.length;
  this.updateBrowseUrl();
  this.updateFilterChips();
 },

 renderBrowseBreadcrumb() {
  const crumbs = [];
  const displayName = this.currentCategoryName || this.currentCategory;

  crumbs.push(`<span class="pf-funnel-breadcrumb-item" onclick="partsFinderApp.browseBackToSelect()">${this.escapeHtml(displayName)}</span>`);

  if (this.browseMode === 'manufacturer') {
  crumbs.push(`<span class="pf-funnel-breadcrumb-sep">›</span>`);
  if (this.browseMfr) {
   crumbs.push(`<span class="pf-funnel-breadcrumb-item" onclick="partsFinderApp.selectBrowseByManufacturer()">By Manufacturer</span>`);
  } else {
   crumbs.push(`<span class="pf-funnel-breadcrumb-current">By Manufacturer</span>`);
  }
  }

  if (this.browseMfr && this.browseMfrName) {
  crumbs.push(`<span class="pf-funnel-breadcrumb-sep">›</span>`);
  if (this.browseModel) {
   crumbs.push(`<span class="pf-funnel-breadcrumb-item" onclick="partsFinderApp.selectBrowseMfr('${(this.browseMfr || '').replace(/'/g, "\\'")}', '${(this.browseMfrName || '').replace(/'/g, "\\'")}')">${this.escapeHtml(this.browseMfrName)}</span>`);
  } else {
   crumbs.push(`<span class="pf-funnel-breadcrumb-current">${this.escapeHtml(this.browseMfrName)}</span>`);
  }
  }

  if (this.browseModel && this.browseModelName) {
  crumbs.push(`<span class="pf-funnel-breadcrumb-sep">›</span>`);
  crumbs.push(`<span class="pf-funnel-breadcrumb-current">${this.escapeHtml(this.browseModelName)}</span>`);
  }

  return `<div class="pf-funnel-breadcrumb">${crumbs.join('')}</div>`;
 },

 browseBackToSelect() {
  this.browseMfr = null;
  this.browseMfrName = null;
  this.browseModel = null;
  this.browseModelName = null;

  const products = this.categoryProducts || this.allProducts || [];
  const hasSizes = this._hasBrowseSizes;
  const hasManufacturers = this._hasBrowseManufacturers;

  if (hasManufacturers && hasSizes) {
  this.selectBrowseByManufacturer();
  } else if (hasManufacturers) {
  this.browseMode = 'manufacturer';
  const manufacturers = this.groupByManufacturer(products);
  this.transitionContent(() => this.renderManufacturerCards(manufacturers, products));
  } else {
  this.browseMode = null;
  this.markBestValue(products);
  this.els.products.classList.add('pf-grid-view');
  this.els.products.style.display = 'flex';
  this.els.products.innerHTML = products.map((p, idx) => this.renderCategoryProductCard(p, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());
  }

  this.els.resultCount.textContent = products.length;
  this.updateBrowseUrl();
  this.updateFilterChips();
  this.scrollToTop();
 },

 updateBrowseUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('ftype');
  url.searchParams.delete('ftread');
  url.searchParams.delete('fwidth');
  url.searchParams.delete('fsize');

  if (this.browseMode && this.browseMode !== 'select') {
  url.searchParams.set('browse', this.browseMode);
  } else {
  url.searchParams.delete('browse');
  }

  if (this.browseMfr) {
  url.searchParams.set('bmfr', this.browseMfr);
  } else {
  url.searchParams.delete('bmfr');
  }

  if (this.browseModel && this.browseModel !== '__all__') {
  url.searchParams.set('bmodel', this.browseModel);
  } else if (this.browseModel === '__all__') {
  url.searchParams.set('bmodel', 'all');
  } else {
  url.searchParams.delete('bmodel');
  }

  history.pushState({}, '', url.toString());
 },

 restoreBrowseFromUrl(products) {
  const url = new URL(window.location.href);
  const browse = url.searchParams.get('browse');
  const bmfr = url.searchParams.get('bmfr');
  const bmodel = url.searchParams.get('bmodel');

  if (!browse && !bmfr) return false;

  const manufacturers = this.groupByManufacturer(products);
  this._hasBrowseManufacturers = manufacturers.length >= 2;
  this._hasBrowseSizes = this.shouldShowTrackFunnel(products);

  if (browse === 'all' || browse === 'products') {
  this.browseMode = 'products';
  this.markBestValue(products);
  this.els.products.classList.add('pf-grid-view');
  this.els.products.style.display = 'flex';
  this.els.products.innerHTML = products.map((p, idx) => this.renderCategoryProductCard(p, idx)).join('');
  if (this._hasBrowseManufacturers) this.injectBrowseToggle('products');
  requestAnimationFrame(() => this.initCarousels());
  return true;
  }

  if (browse === 'tread') {
  this.selectBrowseByTread();
  return true;
  }

  if (browse === 'manufacturer' || bmfr) {
  this.browseMode = 'manufacturer';

  if (bmfr && bmodel) {
   const mfr = manufacturers.find(m => m.handle === bmfr);
   if (!mfr) return false;
   this.browseMfr = bmfr;
   this.browseMfrName = mfr.name;

   if (bmodel === 'all') {
   this.selectBrowseModelAll(bmfr, mfr.name);
   } else {
   const model = mfr.models.find(m => m.handle === bmodel);
   if (model) {
    this.selectBrowseModel(bmfr, bmodel, mfr.name, model.name);
   } else {
    this.selectBrowseMfr(bmfr, mfr.name);
   }
   }
   if (this._hasBrowseSizes) this.injectBrowseToggle('manufacturer');
   return true;
  }

  if (bmfr) {
   const mfr = manufacturers.find(m => m.handle === bmfr);
   if (!mfr) return false;
   this.selectBrowseMfr(bmfr, mfr.name);
   if (this._hasBrowseSizes) this.injectBrowseToggle('manufacturer');
   return true;
  }

  this.renderManufacturerCards(manufacturers, products);
  if (this._hasBrowseSizes) this.injectBrowseToggle('manufacturer');
  return true;
  }

  return false;
 },

 renderSearchProductResults(query, products) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.resultsHeader.style.display = 'block';
  this.els.products.style.display = 'flex';
  this.els.products.classList.add('pf-grid-view');
  if (this.els.clearFilters) this.els.clearFilters.style.display = 'block';

  this.filteredProducts = [...products];
  this.currentFilterQuery = '';
  if (this.els.resultsFilterInput) this.els.resultsFilterInput.value = '';
  if (this.els.filterCount) this.els.filterCount.style.display = 'none';

  if (products.length === 0) {
  this.els.products.innerHTML = '';
  this.els.resultsHeader.style.display = 'none';
  this.showEmpty();
  return;
  }

  this.categoryProducts = products;
  this.categoryTiles = null;
  this.filteredTiles = null;
  this.allProducts = products;

  this.els.resultCount.textContent = products.length;
  this.els.searchTitle.textContent = `"${query}"`;

  this.els.products.innerHTML = products.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());

  this.scopeMakeModelToProducts(products);
  this.updateFilterChips();
  this.scrollToTop();
 },

 scopeMakeModelToProducts(products) {
  if (!this.makeTomSelect) return;

  const makeMap = new Map();
  products.forEach(product => {
  (product.compatible_models || []).forEach(cm => {
   const make = cm.manufacturer || cm.make || '';
   const model = cm.model || cm.name || '';
   const makeHandle = cm.make_handle || this.slugify(make);
   const modelHandle = cm.model_handle || cm.handle || this.slugify(model);
   if (!make) return;

   if (!makeMap.has(makeHandle)) {
   makeMap.set(makeHandle, { name: make, handle: makeHandle, models: new Map() });
   }
   if (model) {
   makeMap.get(makeHandle).models.set(modelHandle, { name: model, handle: modelHandle });
   }
  });
  });

  this._scopedMakes = makeMap;

  this.makeTomSelect.clear(true);
  this.makeTomSelect.clearOptions();
  this.makeTomSelect.addOption({ value: '', text: '-- Select Make --' });

  Array.from(makeMap.values())
  .sort((a, b) => a.name.localeCompare(b.name))
  .forEach(make => {
   this.makeTomSelect.addOption({ value: make.handle, text: make.name });
  });

  if (this.modelTomSelect) {
  this.modelTomSelect.clear(true);
  this.modelTomSelect.clearOptions();
  this.modelTomSelect.addOption({ value: '', text: '-- Select Model --' });
  this.modelTomSelect.disable();
  }

  this._categoryFilterMode = true;
  this.syncMobileFromDesktop();
 },

 restoreMakeModelFull() {
  if (!this.makeTomSelect || !this.allMakes) return;
  this._scopedMakes = null;
  this._categoryFilterMode = false;

  this.makeTomSelect.clear(true);
  this.makeTomSelect.clearOptions();
  this.makeTomSelect.addOption({ value: '', text: '-- Select Make --' });
  this.allMakes.forEach(make => {
  this.makeTomSelect.addOption({ value: make.handle, text: make.name });
  });

  if (this.modelTomSelect) {
  this.modelTomSelect.clear(true);
  this.modelTomSelect.clearOptions();
  this.modelTomSelect.addOption({ value: '', text: '-- Select Model --' });
  this.modelTomSelect.disable();
  }
  this.syncMobileFromDesktop();
 },

 selectCategoryModel(makeHandle, modelHandle, makeName, modelName) {
  if (makeHandle && modelHandle) {
   const collectionHandle = makeHandle + '-' + modelHandle;
   window.location.href = '/collections/' + collectionHandle;
   return;
  }
  this.categoryTiles = null;
  this.filteredTiles = null;
  const filteredProducts = (this.categoryProducts || []).filter(product => {
  const compatModels = product.compatible_models || [];
  return compatModels.some(cm => {
   const cmMake = cm.manufacturer || cm.make || '';
   const cmModel = cm.model || cm.name || '';
   const cmMakeHandle = cm.make_handle || this.slugify(cmMake);
   const cmModelHandle = cm.model_handle || cm.handle || this.slugify(cmModel);
   return cmMakeHandle === makeHandle && cmModelHandle === modelHandle;
  });
  });
  this.currentMake = makeHandle;
  this.currentMakeName = makeName;
  this.currentModel = modelHandle;
  this.currentModelName = modelName;
  this.updateUrl();
  this.renderFilteredCategoryProducts(filteredProducts, makeName, modelName);
 },

 renderFilteredCategoryProducts(products, makeName, modelName) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.resultsHeader.style.display = 'block';
  this.els.products.style.display = 'flex';
  this.els.products.classList.add('pf-grid-view');

  const displayCategory = this.getCategoryDisplayName();
  this.els.resultCount.textContent = products.length;
  this.els.searchTitle.textContent = `${makeName} ${modelName} - ${displayCategory}`;

  if (products.length === 0) {
  this.els.products.innerHTML = '';
  this.showEmpty();
  return;
  }

  this.els.products.innerHTML = products.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());
  this.updateFilterChips();
  this.scrollToTop();
 },

 renderCategoryProductCard(product, idx) {
  const cardId = `pf-card-${idx}`;
  const title = product.title || 'Product';
  const price = product.price || '';
  const url = product.url || (product.handle ? `/products/${product.handle}` : '#');
  const sku = product.sku || '';
  const variantId = product.variant_id || '';
  let images = [];
  if (product.images && Array.isArray(product.images)) {
  product.images.forEach(img => {
   if (img && img !== this.defaultImage) {
   const norm = (u) => u.replace(/^https?:\/\//, '').replace(/\?.*$/, '');
   if (!images.some(existing => norm(existing) === norm(img))) images.push(img);
   }
  });
  }
  if (images.length === 0 && product.featured_image && product.featured_image !== this.defaultImage) {
  images.push(product.featured_image);
  }
  if (images.length === 0) images.push(this.defaultImage);
  const hasMultiple = images.length > 1;

  const isBestValue = product._bestValue || false;
  const vd = this.volumeDiscounts || {};
  const priceNum = parseFloat((price || '').replace(/[^0-9.]/g, ''));
  const treadType = this.classifyTread ? this.classifyTread(product) : null;
  const titleLower = (product.title || '').toLowerCase();
  const isNonMarking = titleLower.includes('non-marking') || titleLower.includes('non marking') || titleLower.includes('nonmarking') || ((product.normalized_dimensions || {}).suffix || '').toUpperCase().includes('NM');
  const pType = (product.product_type || product.type || '').trim();
  const isTrack = pType === 'Tracks' || pType === 'TWA';

  return `
  <div class="pf-card mainsearch-product-box" id="${cardId}">
   <a href="${url}" class="pf-card-link">
   <div class="pf-card-image featured-product-image" style="position:relative;">
    ${isBestValue ? '<div class="pf-best-value-badge">Best Value</div>' : ''}
    ${hasMultiple ? `
    <div class="pf-carousel" id="${cardId}-carousel">
     ${images.map((img, i) => `
     <div class="pf-carousel-slide ${i === 0 ? 'active' : ''}">
      <img src="${img}" alt="${title}" onerror="this.src='${this.defaultImage}';">
     </div>
     `).join('')}
     <button class="pf-carousel-nav prev" onclick="event.preventDefault(); event.stopPropagation(); partsFinderApp.carouselPrev('${cardId}-carousel');">&lsaquo;</button>
     <button class="pf-carousel-nav next" onclick="event.preventDefault(); event.stopPropagation(); partsFinderApp.carouselNext('${cardId}-carousel');">&rsaquo;</button>
     <div class="pf-carousel-dots">
     ${images.map((_, i) => `<button class="pf-carousel-dot${i === 0 ? ' active' : ''}" onclick="event.preventDefault(); event.stopPropagation(); partsFinderApp.carouselGoTo('${cardId}-carousel', ${i})"></button>`).join('')}
     </div>
    </div>
    ` : `
    <img src="${images[0]}" alt="${title}" loading="lazy" onerror="this.src='${this.defaultImage}';">
    `}
   </div>
   <div class="pf-card-content">
    <h3 class="pf-card-title">${title}</h3>
    ${sku ? `<div class="pf-card-sku">SKU: ${sku}</div>` : ''}
    ${isTrack && treadType ? `<div class="pf-card-tread-badge">${this.escapeHtml(treadType)}${isNonMarking ? ' · Non-Marking' : ''}</div>` : ''}
    <span class="pf-free-shipping-badge">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm1.5-9H17V12h4.46L19.5 9.5zM6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3z"/></svg>
    Free Shipping no hidden fees
    </span>
    ${(() => {
    const oem = (product.compatible_models || []).flatMap(cm => cm.oem_part_numbers || []).filter((v, i, a) => a.indexOf(v) === i);
    const serialCount = (product.compatible_models || []).reduce((sum, cm) => sum + (cm.serial_break_entries || []).length, 0);
    let html = '';
    if (oem.length > 0) html += `<div class="pf-card-oem"><span class="pf-card-oem-label">OEM </span><span class="pf-card-oem-value">${oem.join(', ')}</span></div>`;
    if (serialCount > 0) html += `<button class="pf-card-serial-toggle" onclick="event.preventDefault(); event.stopPropagation(); partsFinderApp.showCompatModal(${idx});">${serialCount} serial range${serialCount > 1 ? 's' : ''}</button>`;
    return html;
    })()}
   </div>
   </a>
   ${(product.compatible_models && product.compatible_models.length > 0) ? `
   <div style="padding: 0 12px;">
    <button class="pf-compat-btn" onclick="event.preventDefault(); event.stopPropagation(); partsFinderApp.showCompatModal(${idx});" title="Compatible Equipment">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"/></svg>
    Compatibility
    </button>
   </div>
   ` : ''}
   ${vd.promo_message ? `<div class="pf-promo-banner">${vd.promo_message}${vd.promo_code ? `<span class="pf-promo-code">${vd.promo_code}</span>` : ''}</div>` : ''}
   ${this.renderVolumeTiers(variantId, title, priceNum, product.total_inventory)}
   ${this.renderStockActions(product, variantId, price, url, title)}
  </div>
  `;
 },

 renderVolumeTiers(variantId, title, priceNum, inv) {
  const vd = this.volumeDiscounts || {};
  if (!vd.enabled || !vd.tiers || vd.tiers.length === 0) return '';
  if (inv !== undefined && inv !== null && inv <= 2) return '';
  if (!variantId || !priceNum || isNaN(priceNum)) return '';
  const safeTitle = title.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;');
  let html = '<div class="pf-volume-tiers">';
  html += '<div class="pf-volume-header">Buy More, Save More</div>';
  vd.tiers.forEach(tier => {
  const saved = (priceNum * tier.qty * tier.discount_pct / 100).toFixed(2);
  html += `<button class="pf-volume-tier-btn" onclick="event.stopPropagation(); partsFinderApp.addToCartQty('${variantId}', '${safeTitle}', ${tier.qty})">
   <span>${tier.label}</span>
   <span class="pf-vol-save">Save $${saved}</span>
  </button>`;
  });
  html += '</div>';
  return html;
 },

 markBestValue(products) {
  const vd = this.volumeDiscounts || {};
  if (!vd.best_value_badge) return products;
  const groups = {};
  products.forEach(p => {
  const dims = p.normalized_dimensions;
  const sk = (dims && (dims.full_size_key || dims.size_key)) || '_all';
  if (!groups[sk]) groups[sk] = [];
  groups[sk].push(p);
  });
  Object.values(groups).forEach(group => {
  if (group.length < 2) return;
  let lowestPrice = Infinity;
  let bestProduct = null;
  group.forEach(p => {
   const pNum = parseFloat((p.price || '').replace(/[^0-9.]/g, ''));
   if (pNum && pNum < lowestPrice && p.total_inventory > 0) {
   lowestPrice = pNum;
   bestProduct = p;
   }
  });
  if (bestProduct) bestProduct._bestValue = true;
  });
  return products;
 },

 async addToCartQty(variantId, title, qty) {
  if (this.sessionTracker) {
  try { this.sessionTracker.track('add_to_cart_volume', { variant_id: variantId, title: title, qty: qty }); } catch(e) {}
  }
  const numericId = parseInt(variantId, 10);
  if (!numericId) { this.showToast('Unable to add — missing product variant'); return; }
  try {
  const response = await fetch('/cart/add.js', {
   method: 'POST',
   headers: { 'Content-Type': 'application/json' },
   body: JSON.stringify({ id: numericId, quantity: qty })
  });
  if (response.ok) {
   try {
   const cartResp = await fetch('/cart.js');
   const cart = await cartResp.json();
   document.querySelectorAll('.cart-count, .cart-count-bubble span, [data-cart-count]').forEach(el => {
    el.textContent = cart.item_count;
   });
   } catch(e) {}
   alert(`Added ${qty}x ${title} to your cart!`);
  }
  } catch (err) {
  }
 },

 _outOfStockMessages: [
  'Call for Availability',
  'Call to Confirm Stock',
  'Check Availability',
  'Call for Pricing &amp; Stock',
  'Speak to a Specialist'
 ],
 _lastUnitMessages: [
  'Last One &mdash; Call to Order',
  'Only 1 Left &mdash; Call Now',
  'Final Unit &mdash; Call to Reserve',
  'Almost Gone &mdash; Call to Secure',
  'Last in Stock &mdash; Act Fast'
 ],
 _finalTwoMessages: [
  'Final 2 Units &mdash; Call to Reserve',
  'Only 2 Left &mdash; Call Now',
  'Almost Gone &mdash; Call to Secure',
  '2 Remaining &mdash; Don\'t Miss Out',
  'Going Fast &mdash; Call to Lock In'
 ],
 _lowStockMessages: [
  'Limited Stock &mdash; Order Now',
  'Selling Fast &mdash; Order Now',
  'Low Inventory &mdash; Don\'t Wait',
  'Only a Few Left',
  'Running Low &mdash; Order Today'
 ],
 _pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
 },

 renderStockActions(product, variantId, price, url, title) {
  const inv = product.total_inventory;
  const sa = this.stockAlerts || {};
  const threshold = sa.low_stock_threshold || 5;
  const phoneNum = sa.phone_number || '18665168473';
  const phoneDisplay = sa.phone_display || '(866) 516-8473';
  const enabled = sa.enabled !== false;
  const cartSvg = '<svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.79641 9.375C7.79641 10.4062 8.63174 11.25 9.6527 11.25H11.509V13.125C11.509 14.1562 12.3443 15 13.3653 15C14.3862 15 15.2216 14.1562 15.2216 13.125V11.25H17.0779C18.0988 11.25 18.9341 10.4062 18.9341 9.375C18.9341 8.34375 18.0988 7.5 17.0779 7.5H15.2216V5.625C15.2216 4.59375 14.3862 3.75 13.3653 3.75C12.3443 3.75 11.509 4.59375 11.509 5.625V7.5H9.6527C8.63174 7.5 7.79641 8.34375 7.79641 9.375ZM7.79641 22.5C6.2557 22.5 5.01198 23.7563 5.01198 25.3125C5.01198 26.8687 6.2557 28.125 7.79641 28.125C9.33713 28.125 10.5808 26.8687 10.5808 25.3125C10.5808 23.7563 9.33713 22.5 7.79641 22.5ZM29.1437 0H27.1204C25.2084 0 23.5934 1.48125 23.4264 3.4125L23.3892 3.75H19.8623C18.8413 3.75 18.006 4.59375 18.006 5.625C18.006 6.65625 18.8413 7.5 19.8623 7.5H23.018L22.0898 16.1437C21.9784 17.1 21.1988 17.8125 20.2521 17.8125H7.87067C7.03534 17.8125 6.29282 17.25 6.07007 16.425L3.71258 7.5H6.86827C7.88923 7.5 8.72456 6.65625 8.72456 5.625C8.72456 4.59375 7.88923 3.75 6.86827 3.75H3.71258C1.28085 3.75 -0.501189 6.09375 0.129949 8.475L2.48743 17.4C3.13713 19.8562 5.34612 21.5813 7.87067 21.5813H20.2521C23.0922 21.5813 25.4868 19.425 25.7838 16.575L26.9347 5.83125L27.1204 3.76875H29.1437C30.1647 3.76875 31 2.925 31 1.89375C31 0.8625 30.1647 0 29.1437 0ZM20.2335 22.5C18.6928 22.5 17.4491 23.7563 17.4491 25.3125C17.4491 26.8687 18.6928 28.125 20.2335 28.125C21.7743 28.125 23.018 26.8687 23.018 25.3125C23.018 23.7563 21.7743 22.5 20.2335 22.5Z" fill="black"/></svg>';
  const safeTitle = title.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;');
  const phoneSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>';

  if (enabled && inv !== undefined && inv !== null && inv <= 0) {
  const badgeText = this._pickRandom(this._outOfStockMessages);
  return `
   <div class="pf-card-actions featured-product-btn" style="flex-direction:column;gap:6px;align-items:stretch;">
   ${price ? `<div class="pf-card-price price">${price}</div>` : ''}
   <span class="pf-stock-badge pf-stock-badge--red"><span class="pf-stock-badge-dot"></span>${badgeText}</span>
   <a href="tel:${phoneNum}" class="pf-call-btn" onclick="event.stopPropagation(); try { partsFinderApp.sessionTracker && partsFinderApp.sessionTracker.track('call_click', { title: '${safeTitle}' }); } catch(e) {}">
    ${phoneSvg}
    ${phoneDisplay}
   </a>
   </div>`;
  }

  if (enabled && inv !== undefined && inv !== null && inv <= 2) {
  const badgeText = inv === 1
   ? this._pickRandom(this._lastUnitMessages)
   : this._pickRandom(this._finalTwoMessages);
  return `
   <div class="pf-card-actions featured-product-btn" style="flex-direction:column;gap:6px;align-items:stretch;">
   ${price ? `<div class="pf-card-price price">${price}</div>` : ''}
   <span class="pf-stock-badge pf-stock-badge--red"><span class="pf-stock-badge-dot"></span>${badgeText}</span>
   <a href="tel:${phoneNum}" class="pf-call-btn" onclick="event.stopPropagation(); try { partsFinderApp.sessionTracker && partsFinderApp.sessionTracker.track('call_click', { title: '${safeTitle}' }); } catch(e) {}">
    ${phoneSvg}
    ${phoneDisplay}
   </a>
   ${variantId ? `<button class="pf-stock-modal-cart" onclick="event.stopPropagation(); partsFinderApp.showLowStockModal('${variantId}', '${safeTitle}')"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style="vertical-align:middle;margin-right:3px;opacity:0.5"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg> Add to Cart Anyway</button>` : ''}
   </div>`;
  }

  if (enabled && inv !== undefined && inv !== null && inv > 2 && inv <= threshold) {
  const badgeText = this._pickRandom(this._lowStockMessages);
  return `
   <div class="pf-card-actions featured-product-btn justify-content-between align-items-center">
   <div style="display:flex;flex-direction:column;gap:3px;">
    ${price ? `<div class="pf-card-price price">${price}</div>` : ''}
    <span class="pf-stock-badge pf-stock-badge--yellow"><span class="pf-stock-badge-dot"></span>${badgeText}</span>
   </div>
   <div class="pf-card-action-btns">
    ${variantId ? `<button class="pf-add-cart" onclick="event.stopPropagation(); partsFinderApp.addToCart('${variantId}', '${safeTitle}')">${cartSvg}</button>` : `<a href="${url}" class="pf-view-btn">${cartSvg}</a>`}
   </div>
   </div>`;
  }

  const stockBadge = (enabled && inv !== undefined && inv !== null && inv > threshold)
  ? `<span class="pf-stock-badge pf-stock-badge--green"><span class="pf-stock-badge-dot"></span>In Stock</span>`
  : '';
  return `
  <div class="pf-card-actions featured-product-btn justify-content-between align-items-center">
   <div style="display:flex;flex-direction:column;gap:3px;">
   ${price ? `<div class="pf-card-price price">${price}</div>` : ''}
   ${stockBadge}
   </div>
   <div class="pf-card-action-btns">
   ${variantId ? `<button class="pf-add-cart" onclick="event.stopPropagation(); partsFinderApp.addToCart('${variantId}', '${safeTitle}')">${cartSvg}</button>` : `<a href="${url}" class="pf-view-btn">${cartSvg}</a>`}
   </div>
  </div>`;
 },

 renderProducts(products) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.resultsHeader.style.display = 'block';
  this.els.products.style.display = 'flex';
  this.els.products.classList.add('pf-grid-view');

  this.filteredProducts = [...products];
  this.currentFilterQuery = '';
  this.activeTypeTab = null;
  if (this.els.resultsFilterInput) this.els.resultsFilterInput.value = '';
  if (this.els.filterCount) this.els.filterCount.style.display = 'none';

  const displayMake = this.currentMakeName || this.currentMake;
  const displayModel = this.currentModelName || this.currentModel;
  this.els.resultCount.textContent = products.length;
  this.els.searchTitle.textContent = displayModel ? `${displayMake} ${displayModel}` : displayMake;

  this.buildTypeTabs(products);
  this.updateMobilePanelTitle();

  if (this.currentMake || this.currentModel) {
  const label = displayModel ? `${displayMake} ${displayModel}` : displayMake;
  if (this.els.filteredBannerLabel) this.els.filteredBannerLabel.textContent = label;
  if (this.els.filteredBanner) this.els.filteredBanner.style.display = 'block';
  } else {
  if (this.els.filteredBanner) this.els.filteredBanner.style.display = 'none';
  }

  if (products.length === 0) {
  this.els.products.innerHTML = '';
  this.showEmpty();
  return;
  }

  this.markBestValue(products);

  if (this.restoreFunnelFromUrl()) return;

  const typeGroups = this.groupProductsByType(products);
  const typeNames = Object.keys(typeGroups);
  if (typeNames.length > 1) {
  this.funnelStep = 'types';
  this.funnelSelections = { type: null, tread: null, width: null, size: null };
  this.hideTypeTabs();
  this.renderFunnelTypeCards(typeGroups, products.length);
  this.scrollToTop();
  return;
  }

  const singleType = typeNames[0];
  if ((singleType === 'Tracks' || singleType === 'TWA') && products.length > 4) {
  const treadGroups = this.groupByTread(products);
  if (treadGroups.length > 1) {
   this.funnelStep = 'treads';
   this.funnelSelections = { type: singleType, tread: null, width: null, size: null };
   this.activeTypeTab = singleType;
   this.categoryProducts = products;
   this._hasBrowseSizes = true;
   this.renderFunnelTreadCards(treadGroups, singleType);
   this.injectBrowseToggle('tread');
   this.scrollToTop();
   return;
  }
  }

  this.funnelStep = 'products';
  if (this.activeTypeTab) {
  this.applyTypeFilter();
  this.scrollToTop();
  return;
  }

  this.els.products.innerHTML = products.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());
  this.scrollToTop();
 },

 groupProductsByType(products) {
  const groups = {};
  products.forEach(product => {
  let type = product.product_type || product.type || 'Other';
  if (type && typeof type === 'string') type = type.trim();
  if (!type || type === '') type = 'Other';
  if (!groups[type]) groups[type] = [];
  groups[type].push(product);
  });
  return groups;
 },

 classifyTread(product) {
  if (product.tread_type) return product.tread_type;

  return null;
 },

 treadSortOrder: {
  'Multi Bar': 0, 'Block': 1, 'C Pattern': 2, 'Z Pattern': 3,
  'S Lug': 4, 'D2 Lug': 5, 'Diamond': 6, 'Straight Bar': 7,
  'Snow': 8, 'Standard': 9
 },

 treadBadgeColors: {
  'Multi Bar': '#3b82f6', 'Block': '#8b5cf6', 'C Pattern': '#f97316',
  'Z Pattern': '#ec4899', 'S Lug': '#06b6d4', 'D2 Lug': '#6366f1',
  'Diamond': '#eab308', 'Straight Bar': '#84cc16', 'Snow': '#22c55e',
  'Standard': '#9ca3af', 'Other': '#6b7280'
 },

 groupByTread(products) {
  const groups = {};
  products.forEach(p => {
  const tread = this.classifyTread(p);
  if (!tread) return;
  if (!groups[tread]) groups[tread] = [];
  groups[tread].push(p);
  });
  const order = this.treadSortOrder;
  return Object.entries(groups).sort((a, b) => (order[a[0]] ?? 99) - (order[b[0]] ?? 99));
 },

 groupBySize(products) {
  const groups = {};
  products.forEach(p => {
  const dims = p.normalized_dimensions;
  if (!dims || !dims.size_key) return;
  const baseKey = dims.size_key;
  const suffix = ((dims && dims.suffix) || '').toUpperCase();
  const title = (p.title || '').toLowerCase();
  const isNonMarking = suffix.includes('NM') || title.includes('non-marking') || title.includes('non marking') || title.includes('nonmarking');
  const hasK = suffix === 'K' || suffix.startsWith('K') || suffix.endsWith('K');
  let groupKey = baseKey;
  let groupLabel = null;
  if (isNonMarking) { groupKey = baseKey + ' NM'; groupLabel = 'Non-Marking'; }
  else if (hasK) { groupKey = baseKey + 'K'; }
  if (!groups[groupKey]) groups[groupKey] = { products: [], width: dims && dims.width, pitch: dims && dims.pitch, links: dims && dims.links, suffix: isNonMarking ? 'NM' : hasK ? 'K' : (dims && dims.suffix), label: groupLabel };
  groups[groupKey].products.push(p);
  });
  return Object.entries(groups).sort((a, b) => {
  const wa = a[1].width || 0, wb = b[1].width || 0;
  return wa - wb || a[0].localeCompare(b[0]);
  });
 },

 renderFunnelBreadcrumb() {
  const displayMake = this.currentMakeName || this.currentMake;
  const displayModel = this.currentModelName || this.currentModel;
  const crumbs = [];

  let rootLabel;
  if (this.currentCategory && !displayMake) {
  rootLabel = this.currentCategoryName || this.currentCategory;
  } else {
  rootLabel = displayModel ? `${displayMake} ${displayModel}` : (displayMake || 'All Products');
  }

  crumbs.push(`<span class="pf-funnel-breadcrumb-item" onclick="partsFinderApp.funnelBackTo('types')">${this.escapeHtml(rootLabel)}</span>`);

  if (this.funnelSelections.type) {
  crumbs.push(`<span class="pf-funnel-breadcrumb-sep">›</span>`);
  if (this.funnelStep === 'treads' || this.funnelStep === 'widths' || this.funnelStep === 'sizes' || this.funnelStep === 'products') {
   crumbs.push(`<span class="pf-funnel-breadcrumb-item" onclick="partsFinderApp.funnelBackTo('treads')">${this.escapeHtml(this.funnelSelections.type)}</span>`);
  }
  }
  if (this.funnelSelections.tread) {
  crumbs.push(`<span class="pf-funnel-breadcrumb-sep">›</span>`);
  if (this.funnelStep === 'widths' || this.funnelStep === 'sizes' || this.funnelStep === 'products') {
   crumbs.push(`<span class="pf-funnel-breadcrumb-item" onclick="partsFinderApp.funnelBackTo('widths')">${this.escapeHtml(this.funnelSelections.tread)}</span>`);
  }
  }
  if (this.funnelSelections.width) {
  crumbs.push(`<span class="pf-funnel-breadcrumb-sep">›</span>`);
  if (this.funnelStep === 'sizes' || this.funnelStep === 'products') {
   crumbs.push(`<span class="pf-funnel-breadcrumb-item" onclick="partsFinderApp.funnelBackTo('sizes')">${this.funnelSelections.width}mm (${this.mmToInches(this.funnelSelections.width)}")</span>`);
  }
  }
  if (this.funnelSelections.size) {
  crumbs.push(`<span class="pf-funnel-breadcrumb-sep">›</span>`);
  crumbs.push(`<span class="pf-funnel-breadcrumb-current">${this.escapeHtml(this.funnelSelections.size)}</span>`);
  }
  return `<div class="pf-funnel-breadcrumb">${crumbs.join('')}</div>`;
 },

 renderFunnelTypeCards(typeGroups, totalCount) {
  const types = Object.keys(typeGroups).sort((a, b) => {
  if (a === 'Tracks') return -1;
  if (b === 'Tracks') return 1;
  return a.localeCompare(b);
  });
  const displayMake = this.currentMakeName || this.currentMake;
  const displayModel = this.currentModelName || this.currentModel;
  const label = displayModel ? `${displayMake} ${displayModel}` : displayMake;

  let html = `<div class="pf-funnel-breadcrumb"><span class="pf-funnel-breadcrumb-current">${this.escapeHtml(label)} — ${totalCount} Products</span></div>`;
  html += '<div class="pf-funnel-grid">';
  types.forEach(type => {
  const count = typeGroups[type].length;
  const safeType = type.replace(/'/g, "\\'");
  html += `<div class="pf-funnel-card" onclick="partsFinderApp.selectFunnelType('${safeType}')">
   <div class="pf-funnel-card-count">${count}</div>
   <div class="pf-funnel-card-label">product${count !== 1 ? 's' : ''}</div>
   <div class="pf-funnel-card-name">${this.escapeHtml(type)}</div>
   <div class="pf-funnel-card-action">Browse</div>
  </div>`;
  });
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  this.staggerChildren(this.els.products, '.pf-funnel-card', 60);
 },

 renderFunnelTreadCards(treadGroups, typeName) {
  const colors = this.treadBadgeColors;
  const images = this.treadTypeImages || {};
  let html = this.renderFunnelBreadcrumb();
  html += '<div class="pf-funnel-grid">';
  treadGroups.forEach(([tread, products]) => {
  const safeTread = tread.replace(/'/g, "\\'");
  const color = colors[tread] || colors[tread.toLowerCase()] || '#6b7280';
  const img = images[tread] || images[tread.toLowerCase()] || images[tread + ' Tread'] || images[tread.replace(/ Tread$/, '')];
  const sizeCount = this.groupBySize(products).length;
  const displayCount = sizeCount > 0 ? sizeCount : products.length;
  const countLabel = sizeCount > 0 ? `size${sizeCount !== 1 ? 's' : ''}` : `product${products.length !== 1 ? 's' : ''}`;
  const imgHtml = img
   ? `<img src="${img}" alt="${this.escapeHtml(tread)}" class="pf-funnel-card-img" onerror="this.onerror=null;this.src='${this.defaultImage}';" />`
   : `<div class="pf-funnel-card-img-placeholder" style="background:${color};"><span>${this.escapeHtml(tread.charAt(0))}</span></div>`;
  html += `<div class="pf-funnel-card pf-funnel-card--tread" onclick="partsFinderApp.selectFunnelTread('${safeTread}')">
   ${imgHtml}
   <div class="pf-funnel-card-count">${displayCount}</div>
   <div class="pf-funnel-card-label">${countLabel}</div>
   <div class="pf-funnel-card-name"><span class="pf-funnel-card-dot" style="background:${color};"></span>${this.escapeHtml(tread)}</div>
   <div class="pf-funnel-card-action">View tracks</div>
  </div>`;
  });
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  this.staggerChildren(this.els.products, '.pf-funnel-card', 60);
 },

 pickSizeWinner(products) {
  if (!products || products.length === 0) return null;
  if (products.length === 1) return products[0];

  const flagged = products.find(p => p.is_best_margin);
  if (flagged) return flagged;

  const withStock = products.filter(p => (p.total_inventory || 0) > 0);
  const pool = withStock.length > 0 ? withStock : products;

  let best = pool[0];
  let bestPrice = Infinity;
  pool.forEach(p => {
  const pNum = parseFloat((p.price || '').replace(/[^0-9.]/g, ''));
  if (pNum && pNum < bestPrice) {
   bestPrice = pNum;
   best = p;
  }
  });
  return best;
 },

 renderFunnelSizeCards(sizeGroups, pitchFilter, linksFilter) {
  const isFilterUpdate = this._lastSizeGroups === sizeGroups;
  const showFilters = sizeGroups.length >= 8;

  const afterPitch = pitchFilter
   ? sizeGroups.filter(([sizeKey, data]) => String(data.pitch) === pitchFilter)
   : sizeGroups;

  const filteredGroups = linksFilter
   ? afterPitch.filter(([sizeKey, data]) => String(data.links) === linksFilter)
   : afterPitch;

  if (isFilterUpdate && showFilters) {
   this._updateDimTabs('pitch', pitchFilter, sizeGroups, afterPitch);
   this._updateDimTabs('links', linksFilter, afterPitch, filteredGroups);

   const grid = document.getElementById('pf-size-cards-grid');
   if (grid) {
    grid.style.transition = 'opacity 0.15s ease';
    grid.style.opacity = '0';
    setTimeout(() => {
     grid.innerHTML = this._buildSizeCardsHtml(filteredGroups);
     grid.querySelectorAll('.pf-card').forEach((card, i) => {
      card.style.animationDelay = (i * 50) + 'ms';
     });
     grid.style.opacity = '1';
    }, 160);
    this.els.resultCount.textContent = filteredGroups.length;
    return;
   }
  }

  let html = this.renderFunnelBreadcrumb();

  const pitchCounts = {};
  sizeGroups.forEach(([sizeKey, data]) => {
   const p = data.pitch || '?';
   pitchCounts[p] = (pitchCounts[p] || 0) + 1;
  });
  const distinctPitches = Object.keys(pitchCounts).filter(p => p !== '?').sort((a, b) => parseInt(a) - parseInt(b));

  if (distinctPitches.length > 1 && showFilters) {
   const activePitch = pitchFilter || null;
   html += `<div class="pf-dim-filter" id="pf-dim-filter-pitch">`;
   html += `<span class="pf-dim-label">Pitch</span>`;
   html += `<div class="pf-dim-scroll-wrap">`;
   html += `<button class="pf-dim-arrow" onclick="partsFinderApp.scrollDimFilter(this,-1)">&lsaquo;</button>`;
   html += `<div class="pf-dim-scroll">`;
   html += `<button class="pf-dim-tab${!activePitch ? ' active' : ''}" onclick="partsFinderApp.filterByDim('pitch',null)">All <span class="pf-dim-tab-count">(${sizeGroups.length})</span></button>`;
   distinctPitches.forEach(pitch => {
    const count = pitchCounts[pitch];
    html += `<button class="pf-dim-tab${activePitch === pitch ? ' active' : ''}" data-val="${pitch}" onclick="partsFinderApp.filterByDim('pitch','${pitch}')">${pitch} <span class="pf-dim-tab-count">(${count})</span></button>`;
   });
   html += `</div>`;
   html += `<button class="pf-dim-arrow" onclick="partsFinderApp.scrollDimFilter(this,1)">&rsaquo;</button>`;
   html += `</div></div>`;
  }

  const linksCounts = {};
  afterPitch.forEach(([sizeKey, data]) => {
   const l = data.links || '?';
   linksCounts[l] = (linksCounts[l] || 0) + 1;
  });
  const distinctLinks = Object.keys(linksCounts).filter(l => l !== '?').sort((a, b) => parseInt(a) - parseInt(b));

  if (distinctLinks.length > 1 && showFilters) {
   const activeLinks = linksFilter || null;
   html += `<div class="pf-dim-filter" id="pf-dim-filter-links">`;
   html += `<span class="pf-dim-label">Links</span>`;
   html += `<div class="pf-dim-scroll-wrap">`;
   html += `<button class="pf-dim-arrow" onclick="partsFinderApp.scrollDimFilter(this,-1)">&lsaquo;</button>`;
   html += `<div class="pf-dim-scroll">`;
   html += `<button class="pf-dim-tab${!activeLinks ? ' active' : ''}" onclick="partsFinderApp.filterByDim('links',null)">All <span class="pf-dim-tab-count">(${afterPitch.length})</span></button>`;
   distinctLinks.forEach(links => {
    const count = linksCounts[links];
    html += `<button class="pf-dim-tab${activeLinks === links ? ' active' : ''}" data-val="${links}" onclick="partsFinderApp.filterByDim('links','${links}')">${links} <span class="pf-dim-tab-count">(${count})</span></button>`;
   });
   html += `</div>`;
   html += `<button class="pf-dim-arrow" onclick="partsFinderApp.scrollDimFilter(this,1)">&rsaquo;</button>`;
   html += `</div></div>`;
  }

  html += `<div id="pf-size-cards-grid" style="display:flex;flex-wrap:wrap;gap:15px;padding:0 0 16px;transition:opacity 0.15s ease,transform 0.15s ease;">`;
  html += this._buildSizeCardsHtml(filteredGroups);
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  this.els.resultCount.textContent = filteredGroups.length;
  this._lastSizeGroups = sizeGroups;
  this.initDimScrollArrows();
  this.staggerChildren(this.els.products, '#pf-size-cards-grid > .pf-card', 50);
  this.staggerChildren(this.els.products, '.pf-dim-filter', 30);
 },

 _buildSizeCardsHtml(groups) {
  let html = '';
  groups.forEach(([sizeKey, data]) => {
  const winner = this.pickSizeWinner(data.products);
  if (!winner) return;

  const sizeLabel = data.label ? `${sizeKey.replace(' NM', '')} — ${data.label}` : sizeKey;
  const dimLabel = data.width ? `${data.width}mm (${this.mmToInches(data.width)}") × ${data.pitch || '?'} × ${data.links || '?'} links` : '';

  const title = winner.title || 'Product';
  const price = winner.price || '';
  const url = winner.url || (winner.handle ? `/products/${winner.handle}` : '#');
  const sku = winner.sku || '';
  const variantId = winner.variant_id || '';
  let images = [];
  if (winner.images && Array.isArray(winner.images)) {
   winner.images.forEach(img => {
   if (img && img !== this.defaultImage) {
    const norm = (u) => u.replace(/^https?:\/\//, '').replace(/\?.*$/, '');
    if (!images.some(existing => norm(existing) === norm(img))) images.push(img);
   }
   });
  }
  if (images.length === 0 && winner.featured_image && winner.featured_image !== this.defaultImage) {
   images.push(winner.featured_image);
  }
  if (images.length === 0) images.push(this.defaultImage);
  const imgSrc = images[0];

  const inv = winner.total_inventory || 0;
  const inStock = inv > 0;
  const priceNum = parseFloat((price || '').replace(/[^0-9.]/g, ''));
  const vd = this.volumeDiscounts || {};

  html += `
  <div class="pf-card mainsearch-product-box" style="position:relative;">
   <div class="pf-size-badge">${this.escapeHtml(sizeLabel)}</div>
   ${dimLabel ? `<div class="pf-size-dims-badge">${dimLabel}</div>` : ''}
   <a href="${url}" class="pf-card-link">
   <div class="pf-card-image featured-product-image">
    <img src="${imgSrc}" alt="${this.escapeHtml(title)}" loading="lazy" onerror="this.src='${this.defaultImage}';">
   </div>
   <div class="pf-card-content">
    <h3 class="pf-card-title">${this.escapeHtml(title)}</h3>
    ${sku ? `<div class="pf-card-sku">SKU: ${sku}</div>` : ''}
    <span class="pf-free-shipping-badge">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm1.5-9H17V12h4.46L19.5 9.5zM6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4h3z"/></svg>
    Free Shipping no hidden fees
    </span>
   </div>
   </a>
   ${(winner.compatible_models && winner.compatible_models.length > 0) ? `
   <div style="padding: 0 12px;">
    <button class="pf-compat-btn" onclick="event.preventDefault(); event.stopPropagation(); partsFinderApp.showCompatForProduct('${winner.handle}');" title="Compatible Equipment">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"/></svg>
    Compatibility
    </button>
   </div>
   ` : ''}
   ${this.renderStockActions(winner, variantId, price, url, title)}
  </div>`;
  });
  return html;
 },

 showCompatForProduct(handle) {
  const products = this.allProducts || [];
  const idx = products.findIndex(p => p.handle === handle);
  if (idx >= 0) this.showCompatModal(idx);
 },

 _updateDimTabs(dim, activeVal, sourceGroups, filteredResult) {
  const bar = document.getElementById('pf-dim-filter-' + dim);
  if (!bar) return;

  if (dim === 'links') {
   const linksCounts = {};
   sourceGroups.forEach(([sk, d]) => {
    const l = d.links || '?';
    linksCounts[l] = (linksCounts[l] || 0) + 1;
   });
   const distinctLinks = Object.keys(linksCounts).filter(l => l !== '?').sort((a, b) => parseInt(a) - parseInt(b));
   if (distinctLinks.length <= 1) { bar.style.display = 'none'; return; }
   bar.style.display = '';
   const scroll = bar.querySelector('.pf-dim-scroll');
   if (!scroll) return;
   let tabsHtml = `<button class="pf-dim-tab${!activeVal ? ' active' : ''}" onclick="partsFinderApp.filterByDim('links',null)">All <span class="pf-dim-tab-count">(${sourceGroups.length})</span></button>`;
   distinctLinks.forEach(links => {
    tabsHtml += `<button class="pf-dim-tab${activeVal === links ? ' active' : ''}" data-val="${links}" onclick="partsFinderApp.filterByDim('links','${links}')">${links} <span class="pf-dim-tab-count">(${linksCounts[links]})</span></button>`;
   });
   scroll.innerHTML = tabsHtml;
   return;
  }

  bar.querySelectorAll('.pf-dim-tab').forEach(tab => {
   const val = tab.getAttribute('data-val');
   const isAll = !val;
   if (isAll) {
    tab.classList.toggle('active', !activeVal);
   } else {
    tab.classList.toggle('active', val === activeVal);
   }
  });
 },

 filterByDim(dim, value) {
  if (dim === 'pitch') {
   this.activePitchFilter = value || null;
   this.activeLinksFilter = null;
  } else if (dim === 'links') {
   this.activeLinksFilter = value || null;
  }
  if (this._lastSizeGroups) {
   this.renderFunnelSizeCards(this._lastSizeGroups, this.activePitchFilter, this.activeLinksFilter);
   this.initDimScrollArrows();
  }
 },

 scrollDimFilter(btn, direction) {
  const wrap = btn.closest('.pf-dim-scroll-wrap');
  const scroll = wrap && wrap.querySelector('.pf-dim-scroll');
  if (scroll) scroll.scrollBy({ left: direction * 160, behavior: 'smooth' });
 },

 initDimScrollArrows() {
  requestAnimationFrame(() => {
   document.querySelectorAll('.pf-dim-scroll').forEach(scroll => {
    const wrap = scroll.closest('.pf-dim-scroll-wrap');
    if (!wrap) return;
    const arrows = wrap.querySelectorAll('.pf-dim-arrow');
    const left = arrows[0], right = arrows[1];
    if (!left || !right) return;
    const update = () => {
     const hasOverflow = scroll.scrollWidth > scroll.clientWidth + 4;
     left.classList.toggle('visible', hasOverflow && scroll.scrollLeft > 4);
     right.classList.toggle('visible', hasOverflow && scroll.scrollLeft < scroll.scrollWidth - scroll.clientWidth - 4);
    };
    update();
    scroll.addEventListener('scroll', update);
   });
  });
 },

 staggerChildren(container, selector, baseDelay) {
  if (!container) return;
  const delay = baseDelay || 40;
  requestAnimationFrame(() => {
   const items = container.querySelectorAll(selector);
   items.forEach((el, i) => {
    el.style.animationDelay = (i * delay) + 'ms';
   });
  });
 },

 transitionContent(renderFn) {
  const el = this.els.products;
  if (!el || !el.innerHTML.trim()) { renderFn(); return; }
  el.style.transition = 'opacity 0.12s ease, transform 0.12s ease';
  el.style.opacity = '0';
  el.style.transform = 'translateY(6px)';
  setTimeout(() => {
   renderFn();
   el.style.opacity = '1';
   el.style.transform = 'translateY(0)';
   setTimeout(() => { el.style.transition = ''; el.style.transform = ''; }, 350);
  }, 130);
 },

 selectFunnelType(type) {
  this.funnelSelections.type = type;
  this.activeTypeTab = type;

  if (type && this.sessionTracker) {
  try { this.sessionTracker.track('select_type', { type: type }); } catch(e) {}
  }

  this.els.typeTabs.style.display = 'block';
  this.els.typeTabsScroll.querySelectorAll('.pf-type-tab').forEach(btn => {
  const btnText = btn.textContent.trim().replace(/\d+$/, '').trim();
  btn.classList.toggle('active', btnText === type);
  });

  const products = (this.allProducts || []).filter(p => {
  const pType = (p.product_type || p.type || 'Other').trim();
  return pType === type;
  });

  this.categoryProducts = products;
  this._hasBrowseSizes = this.shouldShowTrackFunnel(products);

  if ((type === 'Tracks' || type === 'TWA') && products.length > 0) {
  const treadGroups = this.groupByTread(products);
  if (treadGroups.length > 1) {
   this.funnelStep = 'treads';
   this.updateFunnelUrl();
   this.transitionContent(() => { this.renderFunnelTreadCards(treadGroups, type); this.injectBrowseToggle('tread'); });
   this.scrollToTop();
   return;
  }
  }

  this.funnelStep = 'products';
  this.funnelSelections.tread = null;
  this.funnelSelections.size = null;
  this.updateFunnelUrl();
  this.transitionContent(() => { this.showFunnelProducts(products); this.injectBrowseToggle('products'); });
 },

 selectFunnelTread(tread) {
  this.funnelSelections.tread = tread;
  this.funnelSelections.width = null;
  this.activePitchFilter = null;
  this.activeLinksFilter = null;
  this.activeTreadTab = tread;

  const type = this.funnelSelections.type;
  const products = (this.allProducts || []).filter(p => {
  const pType = (p.product_type || p.type || 'Other').trim();
  return pType === type && this.classifyTread(p) === tread;
  });

  const sizeGroups = this.groupBySize(products);
  if (sizeGroups.length > 0) {
  const widthGroups = this.groupSizesByWidth(sizeGroups);
  if (Object.keys(widthGroups).length > 1) {
   this.funnelStep = 'widths';
   this.updateFunnelUrl();
   this.transitionContent(() => this.renderFunnelWidthCards(widthGroups, products.length));
   this.scrollToTop();
   return;
  }
  this.funnelStep = 'sizes';
  this.updateFunnelUrl();
  this.transitionContent(() => this.renderFunnelSizeCards(sizeGroups));
  this.scrollToTop();
  return;
  }

  this.funnelStep = 'products';
  this.funnelSelections.size = null;
  this.updateFunnelUrl();
  this.showFunnelProducts(products);
 },

 groupSizesByWidth(sizeGroups) {
  const widths = {};
  sizeGroups.forEach(([sizeKey, data]) => {
  const w = data.width;
  if (!w) return;
  if (!widths[w]) widths[w] = { sizes: [], totalProducts: 0 };
  widths[w].sizes.push([sizeKey, data]);
  widths[w].totalProducts += data.products.length;
  });
  return widths;
 },

 renderFunnelWidthCards(widthGroups, totalCount) {
  let html = this.renderFunnelBreadcrumb();
  html += '<div class="pf-funnel-grid">';
  const sortedWidths = Object.keys(widthGroups).sort((a, b) => {
  const na = parseInt(a) || 0, nb = parseInt(b) || 0;
  return na - nb;
  });
  sortedWidths.forEach(width => {
  const group = widthGroups[width];
  const sizeCount = group.sizes.length;
  const productCount = group.totalProducts;
  const safeWidth = String(width).replace(/'/g, "\\'");
  html += `<div class="pf-funnel-card" onclick="partsFinderApp.selectFunnelWidth('${safeWidth}')">
   <div class="pf-funnel-card-count">${width}mm <span style="font-size:0.7em;opacity:0.7">(${this.mmToInches(width)}")</span></div>
   <div class="pf-funnel-card-label">${sizeCount} size${sizeCount !== 1 ? 's' : ''}</div>
   <div class="pf-funnel-card-action">Browse</div>
  </div>`;
  });
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  this.els.resultCount.textContent = sortedWidths.length + ' widths';
  this.staggerChildren(this.els.products, '.pf-funnel-card', 60);
 },

 selectFunnelWidth(width) {
  this.funnelSelections.width = width;
  this.activePitchFilter = null;
  this.activeLinksFilter = null;
  this._activeSizeTreadFilter = null;
  const type = this.funnelSelections.type;
  const tread = this.funnelSelections.tread;
  const widthNum = parseInt(width) || 0;

  const products = (this.allProducts || []).filter(p => {
  const pType = (p.product_type || p.type || 'Other').trim();
  if (pType !== type) return false;
  if (tread && this.classifyTread(p) !== tread) return false;
  const dims = p.normalized_dimensions;
  return dims && dims.width == widthNum;
  });

  this._widthProducts = products;
  this.funnelStep = 'products';
  this.updateFunnelUrl();
  this.transitionContent(() => {
   [this.els.browseMakes,this.els.browseModels,this.els.empty,this.els.searchResults].forEach(e=>{if(e)e.style.display='none';});
   this.els.resultsHeader.style.display='block';
   this.els.products.style.display='flex';
   this.els.products.classList.add('pf-grid-view');
   this.filteredProducts=[...products];
   if(this.els.resultCount)this.els.resultCount.textContent=products.length;
   if(this.els.searchTitle)this.els.searchTitle.textContent=widthNum+'mm Tracks';
   if(this.els.filteredBanner)this.els.filteredBanner.style.display='none';
   this.buildTypeTabs(products);
   if(!products.length){this.showEmpty();return;}
   this.markBestValue(products);
   this.els.products.innerHTML=products.map((p,i)=>this.renderCategoryProductCard(p,i)).join('');
   requestAnimationFrame(()=>this.initCarousels());
   this.scrollToTop();
  });
 },

 _showMakesGrid(){[this.els.loading,this.els.products,this.els.resultsHeader,this.els.empty,this.els.searchResults,this.els.browseModels].forEach(e=>{if(e)e.style.display='none';});if(this.els.browseMakes)this.els.browseMakes.style.display='block';},

 renderFunnelSizeCardsWithTreadFilter(sizeGroups, allWidthProducts) {
  if (this.funnelSelections.tread || !allWidthProducts) {
   this.renderFunnelSizeCards(sizeGroups);
   return;
  }

  const treadGroups = this.groupByTread(allWidthProducts);
  if (treadGroups.length <= 1) {
   this.renderFunnelSizeCards(sizeGroups);
   return;
  }

  const colors = this.treadBadgeColors;
  let treadHtml = '<div class="pf-size-tread-filter" id="pf-size-tread-filter">';
  treadHtml += `<button class="pf-size-tread-btn active" data-tread="" onclick="partsFinderApp.filterSizesByTread(null)">All Treads <span class="pf-browse-toggle-count">${allWidthProducts.length}</span></button>`;
  treadGroups.forEach(([tread, prods]) => {
   const color = colors[tread] || '#6b7280';
   treadHtml += `<button class="pf-size-tread-btn" data-tread="${this.escapeHtml(tread)}" onclick="partsFinderApp.filterSizesByTread('${tread.replace(/'/g, "\\'")}')">
    <span class="pf-size-tread-dot" style="background:${color};"></span>${this.escapeHtml(tread)} <span class="pf-browse-toggle-count">${prods.length}</span></button>`;
  });
  treadHtml += '</div>';

  this._widthSizeGroups = sizeGroups;
  this.renderFunnelSizeCards(sizeGroups);

  const breadcrumb = this.els.products.querySelector('.pf-funnel-breadcrumb');
  if (breadcrumb) {
   breadcrumb.insertAdjacentHTML('afterend', treadHtml);
  } else {
   this.els.products.insertAdjacentHTML('afterbegin', treadHtml);
  }
 },

 filterSizesByTread(tread) {
  this._activeSizeTreadFilter = tread;

  document.querySelectorAll('.pf-size-tread-btn').forEach(btn => {
   const btnTread = btn.getAttribute('data-tread');
   btn.classList.toggle('active', btnTread === (tread || ''));
  });

  const products = this._widthProducts || [];
  const filtered = tread ? products.filter(p => this.classifyTread(p) === tread) : products;
  const sizeGroups = this.groupBySize(filtered);

  const grid = document.getElementById('pf-size-cards-grid');
  if (grid) {
   grid.style.transition = 'opacity 0.15s ease';
   grid.style.opacity = '0';
   setTimeout(() => {
    grid.innerHTML = this._buildSizeCardsHtml(sizeGroups);
    grid.querySelectorAll('.pf-card').forEach((card, i) => {
     card.style.animationDelay = (i * 50) + 'ms';
    });
    grid.style.opacity = '1';
   }, 160);
   this.els.resultCount.textContent = sizeGroups.length;
  }
 },

 selectFunnelSize(sizeKey) {
  this.funnelSelections.size = sizeKey;
  this.funnelStep = 'products';

  const type = this.funnelSelections.type;
  const tread = this.funnelSelections.tread || this._activeSizeTreadFilter;
  let products = (this.allProducts || []).filter(p => {
  const pType = (p.product_type || p.type || 'Other').trim();
  if (pType !== type) return false;
  if (tread && this.classifyTread(p) !== tread) return false;
  const dims = p.normalized_dimensions;
  const baseKey = dims && dims.size_key ? dims.size_key : 'Unknown Size';
  const suffix = ((dims && dims.suffix) || '').toUpperCase();
  const title = (p.title || '').toLowerCase();
  const isNM = suffix.includes('NM') || title.includes('non-marking') || title.includes('non marking') || title.includes('nonmarking');
  const hasK = suffix === 'K' || suffix.startsWith('K') || suffix.endsWith('K');
  let gk = baseKey;
  if (isNM) gk = baseKey + ' NM';
  else if (hasK) gk = baseKey + 'K';
  return gk === sizeKey;
  });

  this.updateFunnelUrl();
  this.transitionContent(() => this.showFunnelProducts(products));
 },

 showFunnelProducts(products) {
  this.markBestValue(products);
  this.filteredProducts = products;
  this.els.resultCount.textContent = products.length;

  const displayMake = this.currentMakeName || this.currentMake;
  const displayModel = this.currentModelName || this.currentModel;
  let rootLabel;
  if (this.currentCategory && !displayMake) {
  rootLabel = this.currentCategoryName || this.currentCategory;
  } else {
  rootLabel = displayModel ? `${displayMake} ${displayModel}` : displayMake;
  }
  const parts = [rootLabel];
  if (this.funnelSelections.type) parts.push(this.funnelSelections.type);
  if (this.funnelSelections.tread) parts.push(this.funnelSelections.tread);
  if (this.funnelSelections.width) parts.push(this.funnelSelections.width + 'mm (' + this.mmToInches(this.funnelSelections.width) + '")' );
  if (this.funnelSelections.size) parts.push(this.funnelSelections.size);
  this.els.searchTitle.textContent = parts.filter(Boolean).join(' — ');

  if (this.funnelSelections.type === 'Tracks' || this.funnelSelections.type === 'TWA') {
  const trackProducts = (this.allProducts || []).filter(p => {
   const pType = (p.product_type || p.type || 'Other').trim();
   return pType === this.funnelSelections.type;
  });
  this.buildTreadTabs(trackProducts);
  if (this.funnelSelections.tread) {
   this.els.treadTabsScroll.querySelectorAll('.pf-tread-tab').forEach(btn => {
   const btnText = btn.textContent.trim().replace(/\d+$/, '').trim();
   btn.classList.toggle('active', btnText === this.funnelSelections.tread);
   });
  }
  }

  let html = this.renderFunnelBreadcrumb();
  html += '<div style="display:flex;flex-wrap:wrap;gap:15px;padding:0 0 16px;">';
  html += products.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  html += '</div>';
  this.els.products.classList.remove('pf-grid-view');
  this.els.products.style.display = 'block';
  this.els.products.innerHTML = html;
  this.staggerChildren(this.els.products, '.pf-card', 40);
  requestAnimationFrame(() => this.initCarousels());
  this.scrollToTop();
 },

 funnelBackTo(step) {
  if (step === 'types') {
  this.activeTreadTab = null;

  if (this.currentCategory && !this.currentMake && this.shouldShowTrackFunnel(this.allProducts || [])) {
   this.funnelSelections = { type: 'Tracks', tread: null, width: null, size: null };
   this.activeTypeTab = 'Tracks';
   this.hideTreadTabs();

   if (this.browseMode === 'tread') {
   const treadGroups = this.groupByTread(this.allProducts || []);
   if (treadGroups.length > 1) {
    this.funnelStep = 'treads';
    this.transitionContent(() => { this.renderFunnelTreadCards(treadGroups, 'Tracks'); this.injectBrowseToggle('tread'); });
   } else {
    this.funnelStep = 'products';
    this.transitionContent(() => this.showFunnelProducts(this.allProducts || []));
   }
   } else {
   const trackProducts = (this.allProducts || []).filter(p => {
    const pType = (p.product_type || p.type || '').trim();
    return pType === 'Tracks' || pType === 'TWA' || (p.normalized_dimensions && p.normalized_dimensions.size_key);
   });
   const sizeGroups = this.groupBySize(trackProducts);
   const widthGroups = this.groupSizesByWidth(sizeGroups);
   if (Object.keys(widthGroups).length > 1) {
    this.funnelStep = 'widths';
    this.transitionContent(() => { this.renderFunnelWidthCards(widthGroups, trackProducts.length); this.injectBrowseToggle('size'); });
   } else {
    this.funnelStep = 'products';
    this.transitionContent(() => this.showFunnelProducts(this.allProducts || []));
   }
   }
   return;
  }

  this.funnelSelections = { type: null, tread: null, width: null, size: null };
  this.activeTypeTab = null;
  this.hideTypeTabs();
  const typeGroups = this.groupProductsByType(this.allProducts || []);
  const typeNames = Object.keys(typeGroups);
  if (typeNames.length > 1) {
   this.funnelStep = 'types';
   this.transitionContent(() => this.renderFunnelTypeCards(typeGroups, (this.allProducts || []).length));
  } else {
   this.funnelStep = 'products';
   this.transitionContent(() => this.showFunnelProducts(this.allProducts || []));
  }
  } else if (step === 'treads') {
  this.funnelSelections.tread = null;
  this.funnelSelections.width = null;
  this.funnelSelections.size = null;
  this.activeTreadTab = null;
  this.hideTreadTabs();
  const type = this.funnelSelections.type;
  const products = (this.allProducts || []).filter(p => {
   const pType = (p.product_type || p.type || 'Other').trim();
   return pType === type;
  });
  const treadGroups = this.groupByTread(products);
  if (treadGroups.length > 1) {
   this.funnelStep = 'treads';
   this.transitionContent(() => this.renderFunnelTreadCards(treadGroups, type));
  } else {
   this.funnelStep = 'products';
   this.transitionContent(() => this.showFunnelProducts(products));
  }
  } else if (step === 'widths') {
  this.funnelSelections.width = null;
  this.funnelSelections.size = null;
  if (this.funnelSelections.tread) {
   this.transitionContent(() => this.selectFunnelTread(this.funnelSelections.tread));
  } else {
   const trackProducts = (this.allProducts || []).filter(p => {
   const pType = (p.product_type || p.type || '').trim();
   return pType === 'Tracks' || pType === 'TWA' || (p.normalized_dimensions && p.normalized_dimensions.size_key);
   });
   const sizeGroups = this.groupBySize(trackProducts);
   const widthGroups = this.groupSizesByWidth(sizeGroups);
   this.funnelStep = 'widths';
   this.transitionContent(() => { this.renderFunnelWidthCards(widthGroups, trackProducts.length); this.injectBrowseToggle(this.browseMode || 'size'); });
  }
  } else if (step === 'sizes') {
  this.funnelSelections.size = null;
  const type = this.funnelSelections.type;
  const tread = this.funnelSelections.tread;
  const width = this.funnelSelections.width;
  const widthNum = width ? parseInt(width) : null;
  const products = (this.allProducts || []).filter(p => {
   const pType = (p.product_type || p.type || 'Other').trim();
   if (pType !== type) return false;
   if (tread && this.classifyTread(p) !== tread) return false;
   if (widthNum) {
   const dims = p.normalized_dimensions;
   if (!dims || dims.width != widthNum) return false;
   }
   return true;
  });
  const sizeGroups = this.groupBySize(products);
  if (sizeGroups.length > 1) {
   this.funnelStep = 'sizes';
   this.transitionContent(() => this.renderFunnelSizeCards(sizeGroups));
  } else {
   this.funnelStep = 'products';
   this.transitionContent(() => this.showFunnelProducts(products));
  }
  }
  this.updateFunnelUrl();
  this.scrollToTop();
 },

 buildTypeTabs(products) {
  const groups = this.groupProductsByType(products);
  const types = Object.keys(groups).sort((a, b) => {
  if (a === 'Tracks') return -1;
  if (b === 'Tracks') return 1;
  return a.localeCompare(b);
  });

  if (types.length <= 1) {
  this.els.typeTabs.style.display = 'none';
  this.els.mobileTypeTabs.style.display = 'none';
  this.activeTypeTab = null;
  return;
  }

  const defaultType = types[0];

  let html = `<button class="pf-type-tab" onclick="partsFinderApp.selectTypeTab(null)">All <span class="pf-type-tab-count">${products.length}</span></button>`;
  types.forEach(type => {
  const safeType = type.replace(/'/g, "\\'");
  const isDefault = type === defaultType;
  html += `<button class="pf-type-tab${isDefault ? ' active' : ''}" onclick="partsFinderApp.selectTypeTab('${safeType}')">${this.escapeHtml(type)} <span class="pf-type-tab-count">${groups[type].length}</span></button>`;
  });
  this.els.typeTabsScroll.innerHTML = html;
  this.els.typeTabs.style.display = 'block';

  let mobileHtml = `<button class="pf-mobile-type-tab" onclick="partsFinderApp.selectTypeTab(null); partsFinderApp.closeMobileFilters();">All <span class="pf-mobile-type-tab-count">${products.length}</span></button>`;
  types.forEach(type => {
  const safeType = type.replace(/'/g, "\\'");
  const isDefault = type === defaultType;
  mobileHtml += `<button class="pf-mobile-type-tab${isDefault ? ' active' : ''}" onclick="partsFinderApp.selectTypeTab('${safeType}'); partsFinderApp.closeMobileFilters();">${this.escapeHtml(type)} <span class="pf-mobile-type-tab-count">${groups[type].length}</span></button>`;
  });
  this.els.mobileTypeTabsList.innerHTML = mobileHtml;
  this.els.mobileTypeTabs.style.display = 'block';

  this.activeTypeTab = defaultType;

  if (defaultType === 'Tracks' || defaultType === 'TWA') {
  this.buildTreadTabs(groups[defaultType] || []);
  } else {
  this.hideTreadTabs();
  }
 },

 selectTypeTab(type) {
  this.activeTypeTab = type;
  this.activeTreadTab = null;

  if (type && this.sessionTracker) {
  try { this.sessionTracker.track('select_type', { type: type }); } catch(e) {}
  }

  this.els.typeTabsScroll.querySelectorAll('.pf-type-tab').forEach(btn => {
  const btnText = btn.textContent.trim().replace(/\d+$/, '').trim();
  btn.classList.toggle('active', type === null ? btnText === 'All' : btnText === type);
  });
  this.els.mobileTypeTabsList.querySelectorAll('.pf-mobile-type-tab').forEach(btn => {
  const btnText = btn.textContent.trim().replace(/\d+$/, '').trim();
  btn.classList.toggle('active', type === null ? btnText === 'All' : btnText === type);
  });

  if (type === null && this.funnelStep) {
  this.funnelBackTo('types');
  return;
  }

  if (type && this.funnelStep) {
  this.selectFunnelType(type);
  return;
  }

  if (type === 'Tracks' || type === 'TWA') {
  const trackProducts = (this.allProducts || []).filter(p => {
   const pType = (p.product_type || p.type || 'Other').trim();
   return pType === type;
  });
  this.buildTreadTabs(trackProducts);
  } else {
  this.hideTreadTabs();
  }

  this.applyTypeFilter();
 },

 buildTreadTabs(trackProducts) {
  const treadGroups = this.groupByTread(trackProducts);
  if (treadGroups.length <= 1) {
  this.hideTreadTabs();
  return;
  }

  const colors = this.treadBadgeColors;
  let html = `<button class="pf-tread-tab active" onclick="partsFinderApp.selectTreadTab(null)">All <span class="pf-tread-tab-count">${trackProducts.length}</span></button>`;
  treadGroups.forEach(([tread, products]) => {
  const safeTread = tread.replace(/'/g, "\\'");
  const color = colors[tread] || '#6b7280';
  html += `<button class="pf-tread-tab" onclick="partsFinderApp.selectTreadTab('${safeTread}')"><span class="pf-tread-tab-dot" style="background:${color};"></span>${this.escapeHtml(tread)} <span class="pf-tread-tab-count">${products.length}</span></button>`;
  });
  this.els.treadTabsScroll.innerHTML = html;
  this.els.treadTabs.style.display = 'block';

  requestAnimationFrame(() => this.updateTreadScrollArrows());
  this.els.treadTabsScroll.addEventListener('scroll', () => this.updateTreadScrollArrows());

  let mobileHtml = `<button class="pf-mobile-tread-tab active" onclick="partsFinderApp.selectTreadTab(null); partsFinderApp.closeMobileFilters();">All <span class="pf-mobile-tread-tab-count">${trackProducts.length}</span></button>`;
  treadGroups.forEach(([tread, products]) => {
  const safeTread = tread.replace(/'/g, "\\'");
  const color = colors[tread] || '#6b7280';
  mobileHtml += `<button class="pf-mobile-tread-tab" onclick="partsFinderApp.selectTreadTab('${safeTread}'); partsFinderApp.closeMobileFilters();"><span class="pf-tread-tab-dot" style="background:${color};"></span>${this.escapeHtml(tread)} <span class="pf-mobile-tread-tab-count">${products.length}</span></button>`;
  });
  this.els.mobileTreadTabsList.innerHTML = mobileHtml;
  this.els.mobileTreadTabs.style.display = 'block';
 },

 updateTreadScrollArrows() {
  const scroll = this.els.treadTabsScroll;
  const left = document.getElementById('pf-tread-scroll-left');
  const right = document.getElementById('pf-tread-scroll-right');
  if (!scroll || !left || !right) return;
  const hasOverflow = scroll.scrollWidth > scroll.clientWidth + 4;
  left.classList.toggle('visible', hasOverflow && scroll.scrollLeft > 8);
  right.classList.toggle('visible', hasOverflow && scroll.scrollLeft < scroll.scrollWidth - scroll.clientWidth - 8);
 },

 scrollTreadTabs(direction) {
  const scroll = this.els.treadTabsScroll;
  if (!scroll) return;
  scroll.scrollBy({ left: direction * 200, behavior: 'smooth' });
 },

 selectTreadTab(tread) {
  this.activeTreadTab = tread;

  if (tread && this.sessionTracker) {
  try { this.sessionTracker.track('select_tread', { tread: tread }); } catch(e) {}
  }

  this.els.treadTabsScroll.querySelectorAll('.pf-tread-tab').forEach(btn => {
  const btnText = btn.textContent.trim().replace(/\d+$/, '').trim();
  btn.classList.toggle('active', tread === null ? btnText === 'All' : btnText === tread);
  });
  this.els.mobileTreadTabsList.querySelectorAll('.pf-mobile-tread-tab').forEach(btn => {
  const btnText = btn.textContent.trim().replace(/\d+$/, '').trim();
  btn.classList.toggle('active', tread === null ? btnText === 'All' : btnText === tread);
  });

  const existingReset = document.getElementById('pf-tread-reset-btn');
  if (tread) {
  if (!existingReset) {
   const btn = document.createElement('button');
   btn.id = 'pf-tread-reset-btn';
   btn.className = 'pf-tread-reset';
   btn.innerHTML = '&times; Clear tread filter';
   btn.onclick = () => this.selectTreadTab(null);
   this.els.treadTabsScroll.parentElement.appendChild(btn);
  }
  } else if (existingReset) {
  existingReset.remove();
  }

  if (this.funnelStep && tread) {
  this.selectFunnelTread(tread);
  return;
  } else if (this.funnelStep && !tread) {
  this.funnelBackTo('treads');
  return;
  }

  this.applyTypeFilter();
 },

 hideTreadTabs() {
  this.activeTreadTab = null;
  if (this.els.treadTabs) this.els.treadTabs.style.display = 'none';
  if (this.els.mobileTreadTabs) this.els.mobileTreadTabs.style.display = 'none';
 },

 applyTypeFilter() {
  let base = this.allProducts || [];

  if (this.activeTypeTab) {
  base = base.filter(p => {
   const pType = (p.product_type || p.type || 'Other').trim();
   return pType === this.activeTypeTab;
  });
  }

  if (this.activeTreadTab) {
  base = base.filter(p => this.classifyTread(p) === this.activeTreadTab);
  }

  const query = this.currentFilterQuery || '';
  if (query) {
  const terms = query.toLowerCase().split(/\s+/).filter(t => t.length > 0);
  base = base.filter(product => {
   const searchText = [
   product.title || '', product.sku || '', product.vendor || '',
   product.product_type || '',
   product.body_html ? product.body_html.replace(/<[^>]*>/g, '') : ''
   ].join(' ').toLowerCase();
   return terms.every(term => searchText.includes(term));
  });
  }

  this.filteredProducts = base;
  this.els.resultCount.textContent = base.length;

  if (query) {
  this.els.filterCount.style.display = 'inline';
  this.els.filteredCount.textContent = base.length;
  this.els.totalCount.textContent = (this.allProducts || []).length;
  }

  this.renderFilteredProducts();
 },

 hideTypeTabs() {
  this.els.typeTabs.style.display = 'none';
  this.els.mobileTypeTabs.style.display = 'none';
  this.activeTypeTab = null;
  this.hideTreadTabs();
 },

 slugify(str) {
  return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
 },

 showCompatModal(idx) {
  const products = this.filteredProducts || this.categoryProducts || [];
  const product = products[idx];
  if (!product) return;

  const models = product.compatible_models || [];
  if (models.length === 0) return;

  const byMake = {};
  models.forEach(cm => {
  const make = cm.manufacturer || cm.make || 'Unknown';
  const makeHandle = cm.make_handle || this.slugify(make);
  const model = cm.model || cm.name || '';
  const modelHandle = cm.model_handle || cm.handle || this.slugify(model);
  if (!byMake[make]) byMake[make] = { handle: makeHandle, models: [] };
  if (model) byMake[make].models.push({
   name: model,
   handle: modelHandle,
   oem_part_numbers: cm.oem_part_numbers || [],
   serial_break_entries: cm.serial_break_entries || []
  });
  });

  let listHtml = '';
  Object.keys(byMake).sort().forEach(make => {
  const makeData = byMake[make];
  const modelList = makeData.models.sort((a, b) => a.name.localeCompare(b.name));
  const safeMake = make.replace(/'/g, "\\'");
  const safeMakeHandle = makeData.handle.replace(/'/g, "\\'");
  listHtml += `<div class="pf-compat-make">
   <a href="/pages/parts-finder?make=${encodeURIComponent(safeMakeHandle)}" class="pf-compat-make-name" onclick="event.preventDefault(); partsFinderApp.navigateToMakeModel('${safeMakeHandle}', null, '${safeMake}', null);">
   ${this.escapeHtml(make)} <span class="pf-compat-make-arrow">&rarr;</span>
   </a>
   <div class="pf-compat-models">${modelList.map((m, mi) => {
   const safeModel = m.name.replace(/'/g, "\\'");
   const safeModelHandle = m.handle.replace(/'/g, "\\'");
   const serialId = `serial-${safeMakeHandle}-${mi}`;
   const oemBadges = (m.oem_part_numbers || []).map(oem => `<span class="pf-compat-oem-badge">${this.escapeHtml(oem)}</span>`).join('');
   const serialEntries = (m.serial_break_entries || []).filter(e => e.serial_breaks);

   let serialHtml = '';
   if (serialEntries.length > 0) {
    serialHtml = `<div class="pf-compat-model-details"><div class="pf-compat-serial-list">`;
    serialHtml += `<button class="pf-compat-serial-toggle" onclick="event.preventDefault(); event.stopPropagation(); this.classList.toggle('open'); document.getElementById('${serialId}').classList.toggle('open');"><span class="arrow">&#9654;</span> ${serialEntries.length} serial range${serialEntries.length > 1 ? 's' : ''}</button>`;
    serialHtml += `<div class="pf-compat-serial-entries" id="${serialId}">`;
    serialHtml += `<div class="pf-serial-badges">`;
    serialEntries.forEach(e => {
    const noteAttr = e.confirming_note ? ` title="${this.escapeHtml(e.confirming_note)}"` : '';
    serialHtml += `<span class="pf-serial-badge" data-serial="${this.escapeHtml(e.serial_breaks.toLowerCase())}"${noteAttr}>${this.escapeHtml(e.serial_breaks)}</span>`;
    });
    serialHtml += `</div></div></div></div>`;
   }

   return `<div class="pf-compat-model-wrapper"><div class="pf-compat-model-header"><a href="/pages/parts-finder?make=${encodeURIComponent(safeMakeHandle)}&model=${encodeURIComponent(safeModelHandle)}" class="pf-compat-model-tag" onclick="event.preventDefault(); partsFinderApp.navigateToMakeModel('${safeMakeHandle}', '${safeModelHandle}', '${safeMake}', '${safeModel}');">${this.escapeHtml(m.name)}</a>${oemBadges ? `<span class="pf-compat-oem-list">${oemBadges}</span>` : ''}</div>${serialHtml}</div>`;
   }).join('')}</div>
  </div>`;
  });

  const title = product.title || 'Product';
  const modalHtml = `
  <div class="pf-compat-modal-overlay" id="pf-compat-modal" onclick="if(event.target===this) partsFinderApp.closeCompatModal();">
   <div class="pf-compat-modal">
   <div class="pf-compat-modal-header">
    <h3>Compatible Equipment</h3>
    <button class="pf-compat-modal-close" onclick="partsFinderApp.closeCompatModal();">&times;</button>
   </div>
   <div class="pf-compat-modal-title">${this.escapeHtml(title)}</div>
   <div class="pf-compat-search">
    <input type="text" placeholder="Filter by model, OEM, or serial..." oninput="partsFinderApp.filterCompatModal(this.value);" autocomplete="off">
   </div>
   <div class="pf-compat-modal-body" id="pf-compat-modal-body">${listHtml}</div>
   </div>
  </div>
  `;

  const existing = document.getElementById('pf-compat-modal');
  if (existing) existing.remove();

  document.body.insertAdjacentHTML('beforeend', modalHtml);
  document.body.style.overflow = 'hidden';
 },

 navigateToMakeModel(makeHandle, modelHandle, makeName, modelName) {
  this.closeCompatModal();
  this.currentCategory = null;
  this.currentCategoryName = null;
  this.currentParentCategory = null;
  this.currentParentCategoryName = null;
  this.categoryAncestors = [];
  this.categoryProducts = null;
  this._categoryFilterMode = false;
  this._scopedMakes = null;
  this.currentMake = makeHandle;
  this.currentMakeName = makeName;
  this.currentModel = modelHandle || null;
  this.currentModelName = modelName || null;
  this.restoreMakeModelFull();
  if (this.makeTomSelect) this.makeTomSelect.setValue(makeHandle, true);
  this.loadModels(makeHandle);
  this.updateUrl();
  this.loadProducts();
 },

 closeCompatModal() {
  const modal = document.getElementById('pf-compat-modal');
  if (modal) modal.remove();
  document.body.style.overflow = '';
 },

 filterCompatModal(query) {
  const body = document.getElementById('pf-compat-modal-body');
  if (!body) return;
  const q = query.trim().toLowerCase();

  body.querySelectorAll('.pf-compat-make').forEach(makeEl => {
  let makeVisible = false;
  makeEl.querySelectorAll('.pf-compat-model-wrapper').forEach(wrapper => {
   if (!q) {
   wrapper.style.display = '';
   wrapper.querySelectorAll('.pf-serial-badge').forEach(b => { b.classList.remove('highlight', 'dimmed'); });
   wrapper.querySelectorAll('.pf-compat-oem-badge').forEach(b => { b.classList.remove('highlight', 'dimmed'); });
   wrapper.querySelectorAll('.pf-compat-serial-toggle').forEach(t => t.classList.remove('open'));
   wrapper.querySelectorAll('.pf-compat-serial-entries').forEach(e => e.classList.remove('open'));
   makeVisible = true;
   return;
   }

   const modelTag = wrapper.querySelector('.pf-compat-model-tag');
   const modelName = modelTag ? modelTag.textContent.toLowerCase() : '';
   const modelMatch = modelName.includes(q);

   let oemMatch = false;
   wrapper.querySelectorAll('.pf-compat-oem-badge').forEach(b => {
   const match = b.textContent.toLowerCase().includes(q);
   b.classList.toggle('highlight', match);
   b.classList.toggle('dimmed', !match && !modelMatch);
   if (match) oemMatch = true;
   });

   let serialMatch = false;
   wrapper.querySelectorAll('.pf-serial-badge').forEach(b => {
   const match = (b.dataset.serial || '').includes(q);
   b.classList.toggle('highlight', match);
   b.classList.toggle('dimmed', !match && !modelMatch);
   if (match) serialMatch = true;
   });

   if (serialMatch) {
   wrapper.querySelectorAll('.pf-compat-serial-toggle').forEach(t => t.classList.add('open'));
   wrapper.querySelectorAll('.pf-compat-serial-entries').forEach(e => e.classList.add('open'));
   }

   const anyMatch = modelMatch || oemMatch || serialMatch;
   wrapper.style.display = anyMatch ? '' : 'none';
   if (anyMatch) makeVisible = true;
  });
  makeEl.style.display = makeVisible ? '' : 'none';
  });
 },

 showLoading(message) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.products.style.display = 'none';
  this.els.resultsHeader.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.loading.style.display = 'block';
  this.els.loadingText.textContent = message || 'Loading products...';
  this.hideTypeTabs();
 },

 hideLoading() { this.els.loading.style.display = 'none'; },

 showMakes() {
  this.els.loading.style.display = 'none';
  this.els.products.style.display = 'none';
  this.els.products.innerHTML = '';
  this.els.products.classList.remove('pf-grid-view');
  this.els.resultsHeader.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.browseMakes.style.display = 'block';
  if (this.els.filteredBanner) this.els.filteredBanner.style.display = 'none';
  this.allProducts = [];
  this.filteredProducts = [];
  this.categoryProducts = null;
  this.categoryTiles = null;
  this.filteredTiles = null;
  this.funnelStep = null;
  this.funnelSelections = { type: null, tread: null, width: null, size: null };
  this.hideTypeTabs();
  this.updateMobilePanelTitle();
  this.updateFilterChips();
  this.renderDefaultCategoryGrid();
  this.scrollToTop();
 },

 _browseMode: 'category',
 _mfrTileLetterFilter: null,

 setBrowseMode(mode) {
  this._browseMode = mode;
  this._mfrTileLetterFilter = null;
  document.querySelectorAll('.pf-browse-mode-btn').forEach(btn => {
   btn.classList.toggle('active', btn.dataset.mode === mode);
   if (btn.dataset.mode === mode) {
    btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
   }
  });
  this.renderDefaultCategoryGrid();
 },

 renderDefaultCategoryGrid() {
  const grid = this.els.makesGrid;
  if (!grid) return;

  switch (this._browseMode) {
   case 'equipment':
    this._renderEquipmentTypeTiles(grid);
    break;
   case 'category':
    this._renderCategoryTiles(grid);
    break;
   case 'manufacturer':
    this._renderManufacturerTiles(grid);
    break;
   case 'size':
    this._renderSizeTiles(grid);
    break;
   case 'tread':
    this._renderTreadTiles(grid);
    break;
   default:
    this._renderCategoryTiles(grid);
  }
 },

 _pm(m){return`<p style="color:#888;text-align:center;padding:40px">${m}</p>`;},

 _renderEquipmentTypeTiles(grid) {
  if (!this.equipmentTypes || this.equipmentTypes.length === 0) { grid.innerHTML = ''; return; }
  grid.innerHTML = this.equipmentTypes.map(group => {
   const safeName = (group.industry || '').replace(/'/g, "\\'");
   const typeCount = (group.types || []).length;
   const productCount = (group.types || []).reduce((sum, t) => sum + (t.product_count || 0), 0);
   return `<div class="pf-model-card pf-category-tile" onclick="partsFinderApp.showEquipmentTypeGroup('${safeName}')"><div class="pf-model-card-name">${group.industry}</div><div class="pf-model-card-count">${typeCount} type${typeCount!==1?'s':''} &middot; ${productCount} products</div><div class="pf-equipment-card-action">Browse &rarr;</div></div>`;
  }).join('');
  this.staggerChildren(grid, '.pf-category-tile', 50);
 },

 showEquipmentTypeGroup(industryName) {
  if (!this.equipmentTypes) return;
  const group = this.equipmentTypes.find(g => g.industry === industryName);
  if (!group || !group.types) return;

  this._showMakesGrid();
  this.closeMobileFilters();

  const grid = this.els.makesGrid;
  let html = `<div style="padding:0 8px 12px;"><button class="pf-back-btn" onclick="partsFinderApp.setBrowseMode('equipment')">&larr; All Equipment Types</button><h3 style="color:#fff;margin:8px 0 4px;font-size:16px;">${group.industry}</h3></div>`;
  html += group.types.map(type => {
   const safeName = (type.name || '').replace(/'/g, "\\'");
   return `<div class="pf-model-card pf-category-tile" onclick="partsFinderApp.selectEquipmentType('${type.handle}', '${safeName}')"><div class="pf-model-card-name">${type.name}</div><div class="pf-model-card-count">${type.product_count} product${type.product_count!==1?'s':''} &middot; ${type.model_count} model${type.model_count!==1?'s':''}</div><div class="pf-equipment-card-action">View Products &rarr;</div></div>`;
  }).join('');
  grid.innerHTML = html;
  this.staggerChildren(grid, '.pf-category-tile', 50);
 },

 _renderCategoryTiles(grid) {
  if (!this.allCategories || this.allCategories.length === 0) {
   grid.innerHTML = this._pm('Loading categories...');
   return;
  }
  grid.innerHTML = this.allCategories.map(cat => {
   const safeName = (cat.display_name || cat.name || '').replace(/'/g, "\\'");
   return `<div class="pf-model-card pf-category-tile" onclick="partsFinderApp.selectCategory('${cat.handle || cat.id}', '${safeName}')"><div class="pf-model-card-name">${cat.display_name || cat.name}</div><div class="pf-model-card-count">${cat.children&&cat.children.length>0?`${cat.children.length} subcategor${cat.children.length!==1?'ies':'y'}`:''}&nbsp;</div><div class="pf-equipment-card-action">Browse &rarr;</div></div>`;
  }).join('');
  this.staggerChildren(grid, '.pf-category-tile', 50);
 },

 _renderManufacturerTiles(grid) {
  if (!this.allMakes || this.allMakes.length === 0) {
   grid.innerHTML = this._pm('Loading manufacturers...');
   return;
  }
  if (!this._mfrTileLetterFilter) {
   const letterMap = {};
   this.allMakes.forEach(make => {
    const letter = (make.name || '?').charAt(0).toUpperCase();
    letterMap[letter] = (letterMap[letter] || 0) + 1;
   });
   grid.style.gridTemplateColumns = 'repeat(auto-fill,minmax(110px,1fr))';
   grid.innerHTML = Object.keys(letterMap).sort().map(letter => {
    const count = letterMap[letter];
    return `<div class="pf-funnel-card pf-letter-bucket-card" onclick="partsFinderApp.selectMfrTileLetter('${letter}')"><div class="pf-letter-bucket-char">${letter}</div><div class="pf-funnel-card-count">${count}</div><div class="pf-funnel-card-label">brand${count!==1?'s':''}</div><div class="pf-funnel-card-action">Browse &rarr;</div></div>`;
   }).join('');
  } else {
   grid.style.gridTemplateColumns = '';
   const filtered = this.allMakes.filter(m => (m.name || '').charAt(0).toUpperCase() === this._mfrTileLetterFilter);
   let html = `<div style="padding:0 4px 12px;display:flex;align-items:center;gap:12px;"><button class="pf-back-btn" onclick="partsFinderApp.clearMfrTileLetterFilter()">&larr; All Brands</button><span style="font-size:22px;font-weight:800;color:#4fc3f7;">${this._mfrTileLetterFilter}</span></div>`;
   html += filtered.map(make => {
    const safeName = (make.name || '').replace(/'/g, "\\'");
    return `<div class="pf-model-card pf-category-tile" onclick="partsFinderApp.selectMakeFromBrowse('${make.handle}', '${safeName}')"><div class="pf-model-card-name">${make.name}</div><div class="pf-model-card-count">${make.product_count} product${make.product_count!==1?'s':''}</div><div class="pf-equipment-card-action">Browse &rarr;</div></div>`;
   }).join('');
   grid.innerHTML = html;
  }
  this.staggerChildren(grid, '.pf-category-tile, .pf-letter-bucket-card', 40);
 },

 selectMfrTileLetter(letter) {
  this._mfrTileLetterFilter = letter;
  if (this.els.makesGrid) this._renderManufacturerTiles(this.els.makesGrid);
 },

 clearMfrTileLetterFilter() {
  this._mfrTileLetterFilter = null;
  if (this.els.makesGrid) this._renderManufacturerTiles(this.els.makesGrid);
 },

 _renderSizeTiles(grid) {
  grid.innerHTML = this._pm('Loading sizes...');
  apiFetch(`${this.apiBaseUrl}/track-widths`).then(r => r.json()).then(data => {
   const widths = (data.widths || []).filter(w => w > 0);
   if (!widths.length) { grid.innerHTML = this._pm('No sizes found.'); return; }
   grid.innerHTML = widths.map(w => `<div class="pf-model-card pf-category-tile" onclick="partsFinderApp.searchBySize(${w})"><div class="pf-model-card-name" style="font-size:20px;font-weight:800;">${w}mm</div><div class="pf-model-card-count">${this.mmToInches(w)}"</div><div class="pf-equipment-card-action">Browse &rarr;</div></div>`).join('');
   this.staggerChildren(grid, '.pf-category-tile', 40);
  }).catch(() => { grid.innerHTML = this._pm('Could not load sizes.'); });
 },

 _renderTreadTiles(grid) {
  const treads = this._dynamicTreadTypes || [];
  if (treads.length === 0) {
   grid.innerHTML = this._pm('Loading tread types...');
   return;
  }
  const treadImageMap = Object.assign({}, this.treadTypeImages || {});
  (this.allProducts || []).forEach(p => {
   const img = p.featured_image || (p.images && p.images[0]);
   if (!img || img === this.defaultImage) return;
   const tn = this.classifyTread(p);
   if (tn && !treadImageMap[tn]) treadImageMap[tn] = img;
  });
  grid.innerHTML = treads.map(tt => {
   const safeName = (tt.name || '').replace(/'/g, "\\'");
   const imgSrc = treadImageMap[tt.name] || treadImageMap[tt.name.replace(/ Tread$/, '')] || treadImageMap[tt.name.toLowerCase()] || treadImageMap[tt.name.replace(/ Tread$/, '').toLowerCase()] || null;
   return `<div class="pf-model-card pf-category-tile" onclick="partsFinderApp.searchByTread('${safeName}')">${imgSrc?`<img src="${imgSrc}" alt="${this.escapeHtml(tt.name)}" style="width:80px;height:80px;object-fit:contain;margin:0 auto 8px;display:block;border-radius:8px" loading="lazy" onerror="this.onerror=null;this.src=partsFinderApp.defaultImage;">`:''}<div class="pf-model-card-name">${this.escapeHtml(tt.name)}</div><div class="pf-equipment-card-action">Browse &rarr;</div></div>`;
  }).join('');
  this.staggerChildren(grid, '.pf-category-tile', 50);
 },

 async _getTrackProducts(){
  if(!this._trackProducts){
   try{
    const d=await apiFetch(`${this.apiBaseUrl}/track-products`).then(r=>r.json());
    this._trackProducts=(d.products||[]);
   }catch(e){this._trackProducts=[];}
  }
  await this.attachLivePrices(this._trackProducts);
  return this._trackProducts;
 },

 async searchByTread(treadName) {
  this.showLoading();
  try {
   const products = (await this._getTrackProducts()).filter(p => this.classifyTread(p) === treadName);
   this.hideLoading();
   if (!products.length) { this.showEmpty(); return; }
   this.currentCategoryName = treadName + ' Tracks';
   this.currentCategory = 'browse-tread';
   this.currentMake = this.currentModel = null;
   this.renderCategoryProducts(products);
  } catch(e) { this.hideLoading(); this.showEmpty(); }
 },

 async searchBySize(w) {
  this.showLoading();
  try {
   const d = await apiFetch(`${this.apiBaseUrl}/track-products?width=${w}`).then(r => r.json());
   const products = d.products || [];
   await this.attachLivePrices(products);
   this.hideLoading();
   if (!products.length) { this.showEmpty(); return; }
   this.currentCategoryName = w + 'mm Rubber Tracks';
   this.currentCategory = 'browse-size';
   this.currentMake = this.currentModel = null;
   this.renderCategoryProducts(products);
  } catch(e) { this.hideLoading(); this.showEmpty(); }
 },

 async selectMakeFromBrowse(makeHandle, makeName) {
  this.currentMake = makeHandle;
  this.currentMakeName = makeName;
  this.currentModel = null;
  this.currentModelName = null;

  if (this.sessionTracker) {
  try { this.sessionTracker.track('select_make', { handle: makeHandle, name: makeName }); } catch(e) {}
  }

  if (this.makeTomSelect) this.makeTomSelect.setValue(makeHandle, true);
  if (!this.makeModelsCache[makeHandle]) {
  try {
   let modelsUrl = `${this.apiBaseUrl}/models?make_handle=${encodeURIComponent(makeHandle)}`;
  if (this.currentProductCategory) modelsUrl += `&product_category=${this.currentProductCategory}`;
  const response = await apiFetch(modelsUrl);
   const data = await response.json();
   if (data.models) {
   data.models.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
   this.makeModelsCache[makeHandle] = data.models;
   }
  } catch (e) { console.error('Error loading models:', e); }
  }
  this.populateModelSelect(this.makeModelsCache[makeHandle] || []);
  this.showBrowseModels(makeHandle, makeName);
 },

 showBrowseModels(makeHandle, makeName) {
  this.els.loading.style.display = 'none';
  this.els.products.style.display = 'none';
  this.els.products.innerHTML = '';
  this.els.products.classList.remove('pf-grid-view');
  this.els.resultsHeader.style.display = 'none';
  this.els.empty.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'block';
  if (this.els.clearFilters) this.els.clearFilters.style.display = 'block';
  this.els.modelsTitle.textContent = `${makeName} Models`;
  const models = this.makeModelsCache[makeHandle] || [];
  if (models.length === 0) {
  this.els.modelsGrid.innerHTML = this._pm('No models found for this manufacturer.');
  return;
  }
  this.els.modelsGrid.innerHTML = models.map(model => `
  <div class="pf-model-card" onclick="partsFinderApp.selectModelFromBrowse('${makeHandle}', '${model.handle}', '${this.escapeHtml(makeName)}', '${this.escapeHtml(model.name)}')">
   <div class="pf-model-card-name">${this.escapeHtml(model.name)}</div>
   ${model.product_count ? `<div class="pf-model-card-count">${model.product_count} products</div>` : ''}
  </div>
  `).join('');
  this.staggerChildren(this.els.modelsGrid, '.pf-model-card', 30);
  this.scrollToTop();
 },

 selectModelFromBrowse(makeHandle, modelHandle, makeName, modelName) {
  this.currentMake = makeHandle;
  this.currentMakeName = makeName;
  this.currentModel = modelHandle;
  this.currentModelName = modelName;

  if (this.sessionTracker) {
  try { this.sessionTracker.track('select_model', { handle: modelHandle, name: modelName }); } catch(e) {}
  }

  if (this.makeTomSelect) this.makeTomSelect.setValue(makeHandle, true);
  if (this.modelTomSelect) this.modelTomSelect.setValue(modelHandle, true);
  this.updateUrl();
  this.loadProducts();
 },

 showEmpty(context) {
  this.els.browseMakes.style.display = 'none';
  this.els.browseModels.style.display = 'none';
  this.els.products.style.display = 'none';
  this.els.products.innerHTML = '';
  this.els.products.classList.remove('pf-grid-view');
  this.els.resultsHeader.style.display = 'none';
  this.els.loading.style.display = 'none';
  this.els.searchResults.style.display = 'none';
  this.els.empty.style.display = 'block';
  this.hideTypeTabs();

  var titleEl = document.getElementById('pf-empty-title');
  var subtitleEl = document.getElementById('pf-empty-subtitle');
  if (titleEl && subtitleEl) {
   if (this.currentMake && this.currentModel) {
    titleEl.textContent = 'No Products Found for ' + (this.currentMakeName || this.currentMake) + ' ' + (this.currentModelName || this.currentModel);
    subtitleEl.textContent = 'We don\'t have products listed for this specific model yet. Try a different model or browse by category.';
   } else if (this.currentMake) {
    titleEl.textContent = 'No Products for ' + (this.currentMakeName || this.currentMake);
    subtitleEl.textContent = 'Try selecting a different make or search by part number instead.';
   } else if (this.currentSearchQuery) {
    titleEl.textContent = 'No Results for "' + this.escapeHtml(this.currentSearchQuery) + '"';
    subtitleEl.textContent = 'Check your spelling or try a broader search term. You can also browse by category or manufacturer.';
   } else {
    titleEl.textContent = 'No Products Found';
    subtitleEl.textContent = 'We could not find matching products for this selection. Try one of these options:';
   }
  }
 },

 renderPopularMakes() {
  var container = document.getElementById('pf-popular-makes');
  var grid = document.getElementById('pf-popular-makes-grid');
  if (!container || !grid || !this.allMakes || this.allMakes.length === 0) return;

  var popularHandles = this._popularMakeHandles;
  var popularMakes = [];
  for (var i = 0; i < popularHandles.length; i++) {
   var make = this.allMakes.find(function(m) { return m.handle === popularHandles[i]; });
   if (make) popularMakes.push(make);
  }

  if (popularMakes.length === 0) {
   popularMakes = this.allMakes.slice(0, 10);
  }

  var self = this;
  grid.innerHTML = popularMakes.map(function(make) {
   return '<button class="pf-popular-make-btn" onclick="partsFinderApp.selectPopularMake(\'' + make.handle + '\')" title="Browse ' + self.escapeHtml(make.name) + ' parts">' + self.escapeHtml(make.name) + '</button>';
  }).join('');

  container.style.display = 'block';
 },

 selectPopularMake(makeHandle) {
  if (this.makeTomSelect) {
   this.makeTomSelect.setValue(makeHandle);
  }
  this.saveRecentSearch({ type: 'make', handle: makeHandle, name: (this.allMakes.find(function(m) { return m.handle === makeHandle; }) || {}).name || makeHandle });
 },

 getRecentSearches() {
  try {
   var data = localStorage.getItem(this._recentSearchesKey);
   return data ? JSON.parse(data) : [];
  } catch(e) { return []; }
 },

 saveRecentSearch(entry) {
  try {
   var searches = this.getRecentSearches();
   var key = entry.type + ':' + (entry.handle || entry.query || '');
   searches = searches.filter(function(s) { return (s.type + ':' + (s.handle || s.query || '')) !== key; });
   searches.unshift(entry);
   if (searches.length > 8) searches = searches.slice(0, 8);
   localStorage.setItem(this._recentSearchesKey, JSON.stringify(searches));
   this.renderRecentSearches();
  } catch(e) {}
 },

 clearRecentSearches() {
  try { localStorage.removeItem(this._recentSearchesKey); } catch(e) {}
  var container = document.getElementById('pf-recent-searches');
  if (container) container.style.display = 'none';
 },

 renderRecentSearches() {
  var container = document.getElementById('pf-recent-searches');
  var list = document.getElementById('pf-recent-searches-list');
  if (!container || !list) return;

  var searches = this.getRecentSearches();
  if (searches.length === 0) {
   container.style.display = 'none';
   return;
  }

  var self = this;
  list.innerHTML = searches.map(function(s) {
   if (s.type === 'make') {
    return '<button class="pf-recent-search-btn" onclick="partsFinderApp.selectPopularMake(\'' + self.escapeHtml(s.handle) + '\')">' +
     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="10"/></svg>' +
     self.escapeHtml(s.name || s.handle) + '</button>';
   } else if (s.type === 'make-model') {
    return '<button class="pf-recent-search-btn" onclick="partsFinderApp.replayRecentMakeModel(\'' + self.escapeHtml(s.makeHandle) + '\', \'' + self.escapeHtml(s.modelHandle) + '\')">' +
     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="10"/></svg>' +
     self.escapeHtml(s.name) + '</button>';
   } else {
    return '<button class="pf-recent-search-btn" onclick="partsFinderApp.replayRecentSearch(\'' + self.escapeHtml(s.query) + '\')">' +
     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
     '&ldquo;' + self.escapeHtml(s.query) + '&rdquo;</button>';
   }
  }).join('');

  container.style.display = 'block';
 },

 replayRecentSearch(query) {
  if (this.els.quickSearchInput) this.els.quickSearchInput.value = query;
  this.onQuickSearch(query);
 },

 replayRecentMakeModel(makeHandle, modelHandle) {
  if (this.makeTomSelect) this.makeTomSelect.setValue(makeHandle);
  var self = this;
  var checkAndSet = function() {
   if (self.makeModelsCache[makeHandle] && self.modelTomSelect) {
    self.modelTomSelect.setValue(modelHandle);
   } else {
    setTimeout(checkAndSet, 200);
   }
  };
  setTimeout(checkAndSet, 300);
 },

 clearFilters() {
  if (this.sessionTracker) {
  try { this.sessionTracker.track('clear_filters', {}); } catch(e) {}
  }

  this.currentMake = null;
  this.currentMakeName = null;
  this.currentModel = null;
  this.currentModelName = null;
  this.currentCategory = null;
  this.currentCategoryName = null;
  this.currentParentCategory = null;
  this.currentParentCategoryName = null;
  this.categoryAncestors = [];
  this.currentSearchQuery = '';
  this.categoryProducts = null;
  this._categoryFilterMode = false;
  this._scopedMakes = null;
  this.browseMode = null;
  this.browseMfr = null;
  this.browseMfrName = null;
  this.browseModel = null;
  this.browseModelName = null;
  if (this.els.oemInput) this.els.oemInput.value = '';
  if (this.els.serialInput) this.els.serialInput.value = '';
  this.restoreMakeModelFull();
  this.syncMobileFromDesktop();
  if (this.allCategories.length > 0) this.renderCategories(this.allCategories);
  this.updateUrl();
  this.showMakes();
 },

 updateBackButton() {
  const backBtn = document.getElementById('pf-back-to-category');
  if (!backBtn) return;
  if (this._categoryFilterMode && this.categoryProducts && this.currentMake) {
  backBtn.style.display = 'inline-flex';
  } else {
  backBtn.style.display = 'none';
  }
 },

 updateFilterChips() {
  const container = document.getElementById('pf-active-filters');
  if (!container) return;
  const breadcrumb = document.getElementById('pf-breadcrumb-cats');
  const chipMake = document.getElementById('pf-chip-make');
  const chipModel = document.getElementById('pf-chip-model');
  const sepMake = document.getElementById('pf-chip-separator-make');
  const sepModel = document.getElementById('pf-chip-separator-model');
  let hasAny = false;

  if (breadcrumb) {
  const ancestors = this.categoryAncestors || [];
  const crumbs = ancestors.map(a => ({handle: a.handle || a.id, name: a.display_name || a.name}));
  if (this.currentCategoryName) {
   crumbs.push({handle: this.currentCategory, name: this.currentCategoryName, isCurrent: true});
  }
  if (crumbs.length > 0) {
   breadcrumb.innerHTML = crumbs.map((c, i) => {
   const safeName = c.name.replace(/'/g, "\\'");
   const chip = c.isCurrent
    ? `<span class="pf-filter-chip active" onclick="partsFinderApp.navigateToParentCategory()"><span class="pf-chip-label">${c.name}</span> &times;</span>`
    : `<span class="pf-filter-chip" onclick="partsFinderApp.selectCategory('${c.handle}', '${safeName}')"><span class="pf-chip-label">${c.name}</span></span>`;
   const sep = i < crumbs.length - 1 ? '<span class="pf-chip-separator">&rsaquo;</span>' : '';
   return chip + sep;
   }).join('');
   hasAny = true;
  } else {
   breadcrumb.innerHTML = '';
  }
  }

  if (sepMake) sepMake.style.display = (hasAny && this.currentMakeName) ? 'inline' : 'none';

  if (this.currentMakeName && chipMake) {
  document.getElementById('pf-chip-make-label').textContent = 'Make: ' + this.currentMakeName;
  chipMake.style.display = 'inline-flex';
  hasAny = true;
  } else if (chipMake) { chipMake.style.display = 'none'; }

  if (sepModel) sepModel.style.display = (this.currentMakeName && this.currentModelName) ? 'inline' : 'none';

  if (this.currentModelName && chipModel) {
  document.getElementById('pf-chip-model-label').textContent = 'Model: ' + this.currentModelName;
  chipModel.style.display = 'inline-flex';
  hasAny = true;
  } else if (chipModel) { chipModel.style.display = 'none'; }
  container.style.display = hasAny ? 'flex' : 'none';
 },

 clearMakeModelFilter() {
  if (!this.categoryProducts) return;
  this.currentMake = null;
  this.currentMakeName = null;
  this.currentModel = null;
  this.currentModelName = null;

  this.scopeMakeModelToProducts(this.categoryProducts);
  this.syncMobileFromDesktop();

  this.filteredProducts = [...this.categoryProducts];
  this.els.resultCount.textContent = this.categoryProducts.length;
  this.els.searchTitle.textContent = this.currentSearchQuery
  ? `"${this.currentSearchQuery}"`
  : this.getCategoryDisplayName();
  this.els.products.innerHTML = this.categoryProducts.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());

  const backBtn = document.getElementById('pf-back-to-category');
  if (backBtn) backBtn.style.display = 'none';

  this.updateFilterChips();
  this.updateUrl();
 },

 navigateToParentCategory() {
  if (this.currentParentCategory && this.currentParentCategoryName) {
  this.selectCategory(this.currentParentCategory, this.currentParentCategoryName);
  } else {
  this.clearFilters();
  }
 },

 clearModelFilter() {
  this.currentModel = null;
  this.currentModelName = null;
  if (this.modelTomSelect) this.modelTomSelect.clear(true);
  if (this.currentMake && this._categoryFilterMode && this.categoryProducts) {
  const makeFiltered = this.categoryProducts.filter(p =>
   p.compatible_models && p.compatible_models.some(cm =>
   cm.manufacturer && cm.manufacturer.toLowerCase() === this.currentMakeName.toLowerCase()
   )
  );
  this.filteredProducts = makeFiltered;
  this.els.resultCount.textContent = makeFiltered.length;
  this.els.products.innerHTML = makeFiltered.map((product, idx) => this.renderCategoryProductCard(product, idx)).join('');
  requestAnimationFrame(() => this.initCarousels());
  } else if (this.currentMake) {
  this.showBrowseModels(this.currentMake, this.currentMakeName);
  }
  this.updateFilterChips();
  this.updateUrl();
 },

 openMobileFilters() {
  const overlay = document.getElementById('pf-mobile-overlay');
  const panel = document.getElementById('pf-mobile-panel');
  const tab = document.getElementById('pf-mobile-filter-tab');
  if (overlay) overlay.classList.add('active');
  if (panel) panel.classList.add('open');
  if (tab) tab.classList.add('hidden');
  document.body.style.overflow = 'hidden';
  if (!this._mobileInited) { this.initMobileFilters(); this._mobileInited = true; }
  else { this.syncMobileFromDesktop(); }
  this.updateMobilePanelTitle();
 },

 closeMobileFilters() {
  const overlay = document.getElementById('pf-mobile-overlay');
  const panel = document.getElementById('pf-mobile-panel');
  const tab = document.getElementById('pf-mobile-filter-tab');
  if (overlay) overlay.classList.remove('active');
  if (panel) panel.classList.remove('open');
  if (tab) tab.classList.remove('hidden');
  document.body.style.overflow = '';
 },

 initMobileFilters() {
  const self = this;
  const mobileMakeEl = document.getElementById('pf-mobile-make-select');
  const mobileModelEl = document.getElementById('pf-mobile-model-select');

  if (mobileMakeEl && !this.mobileMakeTomSelect) {
  this.mobileMakeTomSelect = new AutoComplete({
   input: mobileMakeEl,
   items: [],
   placeholder: 'Type manufacturer...',
   maxVisible: 10,
   theme: 'dark',
   name: 'pf-mobile-make',
   onSelect: function(value) { self.onMobileMakeChange(value); }
  });
  this.syncMobileFromDesktop();
  }

  if (mobileModelEl && !this.mobileModelTomSelect) {
  this.mobileModelTomSelect = new AutoComplete({
   input: mobileModelEl,
   items: [],
   placeholder: 'Type model number...',
   maxVisible: 10,
   disabled: true,
   theme: 'dark',
   name: 'pf-mobile-model',
   onSelect: function(value) { self.onMobileModelChange(value); }
  });
  }

  const mobileSearchInput = document.getElementById('pf-mobile-search-input');
  if (mobileSearchInput) {
  mobileSearchInput.addEventListener('input', (e) => {
   clearTimeout(this._mobileSearchTimer);
   this._mobileSearchTimer = setTimeout(() => {
   if (this.els.quickSearchInput) this.els.quickSearchInput.value = e.target.value;
   this.onQuickSearch(e.target.value);
   if (e.target.value.length >= 2) this.closeMobileFilters();
   }, 300);
  });
  }
  const mobileCats = document.getElementById('pf-mobile-categories');
  if (mobileCats && this.allCategories.length > 0) {
  mobileCats.innerHTML = this.allCategories.map(cat => this.renderMobileCategoryItem(cat)).join('');
  }
 },

 syncMobileFromDesktop() {
  if (!this.mobileMakeTomSelect) return;

  this.mobileMakeTomSelect.clear(true);
  this.mobileMakeTomSelect.clearOptions();
  this.mobileMakeTomSelect.addOption({ value: '', text: '-- Select Make --' });

  if (this._scopedMakes) {
  Array.from(this._scopedMakes.values())
   .sort((a, b) => a.name.localeCompare(b.name))
   .forEach(make => {
   this.mobileMakeTomSelect.addOption({ value: make.handle, text: make.name });
   });
  } else if (this.allMakes) {
  this.allMakes.forEach(make => {
   this.mobileMakeTomSelect.addOption({ value: make.handle, text: make.name });
  });
  }

  if (this.mobileModelTomSelect) {
  this.mobileModelTomSelect.clear(true);
  this.mobileModelTomSelect.clearOptions();
  this.mobileModelTomSelect.addOption({ value: '', text: '-- Select Model --' });
  this.mobileModelTomSelect.disable();
  }

  if (this.currentMake) {
  this.mobileMakeTomSelect.setValue(this.currentMake, true);
  }

  const mobileOem = document.getElementById('pf-mobile-oem-input');
  const mobileSerial = document.getElementById('pf-mobile-serial-input');
  if (mobileOem && this.els.oemInput) mobileOem.value = this.els.oemInput.value;
  if (mobileSerial && this.els.serialInput) mobileSerial.value = this.els.serialInput.value;
 },

 updateMobilePanelTitle() {
  const title = document.getElementById('pf-mobile-panel-title');
  const tabText = document.querySelector('.pf-mobile-filter-tab-text');
  if (!title) return;
  const make = this.currentMakeName || this.currentMake;
  const model = this.currentModelName || this.currentModel;
  if (make && model) {
  title.textContent = `${make} ${model}`;
  if (tabText) tabText.textContent = `${make} ${model}`;
  } else if (make) {
  title.textContent = make;
  if (tabText) tabText.textContent = make;
  } else {
  title.textContent = 'Product Finder';
  if (tabText) tabText.textContent = 'Filters';
  }
 },

 onMobileMakeChange(makeHandle) {
  this.onMakeChange(makeHandle);
  if (this.mobileModelTomSelect) {
  this.mobileModelTomSelect.clear(true);
  this.mobileModelTomSelect.clearOptions();
  this.mobileModelTomSelect.addOption({ value: '', text: '-- Select Model --' });

  if (this._scopedMakes && makeHandle) {
   const scopedMake = this._scopedMakes.get(makeHandle);
   if (scopedMake) {
   Array.from(scopedMake.models.values())
    .sort((a, b) => a.name.localeCompare(b.name))
    .forEach(m => { this.mobileModelTomSelect.addOption({ value: m.handle, text: m.name }); });
   }
   this.mobileModelTomSelect.enable();
  } else if (makeHandle && this.makeModelsCache[makeHandle]) {
   this.makeModelsCache[makeHandle].forEach(m => {
   this.mobileModelTomSelect.addOption({ value: m.handle, text: m.name });
   });
   this.mobileModelTomSelect.enable();
  } else if (makeHandle) {
   this.mobileModelTomSelect.enable();
  }
  }
  if (this.makeTomSelect && makeHandle) this.makeTomSelect.setValue(makeHandle, true);
 },

 onMobileModelChange(modelHandle) {
  this.onModelChange(modelHandle);
  if (this.modelTomSelect && modelHandle) this.modelTomSelect.setValue(modelHandle, true);
 },

 renderMobileCategoryItem(cat, depth) {
  depth = depth || 0;
  const isActive = this.currentCategory === cat.handle || this.currentCategory === cat.id;
  const hasChildren = cat.children && cat.children.length > 0;
  const isExpanded = hasChildren && this.isCategoryExpanded(cat);
  const safeName = (cat.display_name || cat.name || '').replace(/'/g, "\\'");
  let html = `<div class="pf-category-group" data-mobile-category-id="${cat.id}">`;
  html += `<div class="pf-category-card ${isActive ? 'active' : ''}"${depth > 0 ? ' style="padding-left:' + (12 + depth * 12) + 'px"' : ''}>`;
  html += `<div style="display:flex;align-items:center;flex:1;gap:8px;" onclick="partsFinderApp.selectMobileCategory('${cat.handle || cat.id}', '${safeName}')">`;
  html += `<span class="pf-category-name">${cat.display_name || cat.name}</span></div>`;
  if (hasChildren) {
  html += `<span class="pf-category-toggle ${isExpanded ? 'expanded' : ''}" onclick="event.stopPropagation(); partsFinderApp.toggleMobileCategoryExpand('${cat.id}')" title="Expand subcategories">&rsaquo;</span>`;
  }
  html += `</div>`;
  if (hasChildren) {
  html += `<div class="pf-subcategories ${isExpanded ? 'expanded' : ''}" id="pf-mobile-subcats-${cat.id}">`;
  html += cat.children.map(child => this.renderMobileCategoryItem(child, depth + 1)).join('');
  html += `</div>`;
  }
  html += `</div>`;
  return html;
 },

 toggleMobileCategoryExpand(categoryId) {
  const subContainer = document.getElementById(`pf-mobile-subcats-${categoryId}`);
  const group = document.querySelector(`[data-mobile-category-id="${categoryId}"]`);
  const toggle = group ? group.querySelector('.pf-category-toggle') : null;
  if (subContainer) {
  const isExpanded = subContainer.classList.contains('expanded');
  subContainer.classList.toggle('expanded');
  if (toggle) toggle.classList.toggle('expanded');
  this._expandedCategories[categoryId] = !isExpanded;
  }
 },

 selectMobileCategory(categoryHandle, categoryName) {
  this.selectCategory(categoryHandle, categoryName);
  this.closeMobileFilters();
 },

 onMobileSearchSubmit() {
  const mobileOem = document.getElementById('pf-mobile-oem-input');
  const mobileSerial = document.getElementById('pf-mobile-serial-input');
  if (mobileOem && this.els.oemInput) this.els.oemInput.value = mobileOem.value;
  if (mobileSerial && this.els.serialInput) this.els.serialInput.value = mobileSerial.value;
  this.onSearchSubmit();
  this.closeMobileFilters();
 },

 showLowStockModal(variantId, title) {
  const sa = this.stockAlerts || {};
  const phoneNum = sa.phone_number || '18665168473';
  const phoneDisplay = sa.phone_display || '(866) 516-8473';
  const safeTitle = title.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '&quot;');
  const modalMessages = [
  'This item has very limited availability. We recommend calling to confirm stock before ordering.',
  'Heads up — this is the last unit we show in stock. Call us to make sure it\'s still available.',
  'Only one left! Give us a quick call to lock it in before someone else does.',
  'This product is almost sold out. A quick call ensures you get it.',
  'Low inventory alert — call to verify availability and get the best deal.'
  ];
  const msg = this._pickRandom(modalMessages);
  const phoneSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>';

  const overlay = document.createElement('div');
  overlay.className = 'pf-stock-modal-overlay';
  overlay.onclick = (e) => { if (e.target === overlay) overlay.remove(); };
  overlay.innerHTML = `
  <div class="pf-stock-modal">
   <div class="pf-stock-modal-icon">📞</div>
   <div class="pf-stock-modal-title">${this.escapeHtml(title)}</div>
   <div class="pf-stock-modal-msg">${msg}</div>
   <a href="tel:${phoneNum}" class="pf-stock-modal-call" onclick="try { partsFinderApp.sessionTracker && partsFinderApp.sessionTracker.track('modal_call_click', { title: '${safeTitle}' }); } catch(e) {}">
   ${phoneSvg} Call ${phoneDisplay}
   </a>
   <button class="pf-stock-modal-cart" onclick="this.closest('.pf-stock-modal-overlay').remove(); partsFinderApp.addToCart('${variantId}', '${safeTitle}')">
   <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="vertical-align:middle;margin-right:4px;opacity:0.6"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/></svg>
   Add to Cart Anyway
   </button>
  </div>
  `;
  document.body.appendChild(overlay);

  if (this.sessionTracker) {
  try { this.sessionTracker.track('low_stock_modal_shown', { title: title, variant_id: variantId }); } catch(e) {}
  }
 },

 async addToCart(variantId, title, cardId) {
  if (this.sessionTracker) {
  try { this.sessionTracker.track('add_to_cart', { variant_id: variantId, title: title }); } catch(e) {}
  }

  const numericId = parseInt(variantId, 10);
  if (!numericId) { this.showToast('Unable to add — missing product variant'); return; }

  const qtyInput = cardId ? document.getElementById(`${cardId}-qty`) : null;
  const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
  const btn = cardId ? document.querySelector(`#${cardId} .pf-add-btn`) : null;
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
  try {
  const response = await fetch('/cart/add.js', {
   method: 'POST',
   headers: { 'Content-Type': 'application/json' },
   body: JSON.stringify({ id: numericId, quantity: qty })
  });
  if (response.ok) {
   this.showToast(`Added ${qty} x ${title} to cart!`);
   this.updateCartCount();
  } else {
   const data = await response.json();
   this.showToast(data.description || 'Could not add to cart');
  }
  } catch (err) {
  this.showToast('Error adding to cart');
  } finally {
  if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
  }
 },

 async updateCartCount() {
  try {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  ['.cart-count', '.cart-item-count', '#cart-count', '[data-cart-count]'].forEach(sel => {
   const el = document.querySelector(sel);
   if (el) el.textContent = cart.item_count;
  });
  } catch (e) {  }
 },

 carousels: {},

 initCarousels() {
  document.querySelectorAll('#pf-products .pf-carousel').forEach(carousel => {
  const id = carousel.id;
  if (!id) return;
  const slides = carousel.querySelectorAll('.pf-carousel-slide');
  if (slides.length <= 1) return;
  this.carousels[id] = { currentIndex: 0, totalSlides: slides.length, autoplayInterval: null };
  this.startCarouselAutoplay(id);
  carousel.addEventListener('mouseenter', () => this.pauseCarouselAutoplay(id));
  carousel.addEventListener('mouseleave', () => this.startCarouselAutoplay(id));
  });
 },

 startCarouselAutoplay(carouselId) {
  if (!this.carousels[carouselId]) return;
  this.pauseCarouselAutoplay(carouselId);
  this.carousels[carouselId].autoplayInterval = setInterval(() => this.carouselNext(carouselId), 10000);
 },

 pauseCarouselAutoplay(carouselId) {
  if (this.carousels[carouselId]?.autoplayInterval) {
  clearInterval(this.carousels[carouselId].autoplayInterval);
  this.carousels[carouselId].autoplayInterval = null;
  }
 },

 carouselGoTo(carouselId, index) {
  const carousel = document.getElementById(carouselId);
  if (!carousel) return;
  const slides = carousel.querySelectorAll('.pf-carousel-slide');
  const dots = carousel.querySelectorAll('.pf-carousel-dot');
  const total = slides.length;
  if (total === 0) return;
  if (index < 0) index = total - 1;
  if (index >= total) index = 0;
  if (!this.carousels[carouselId]) {
  this.carousels[carouselId] = { currentIndex: 0, totalSlides: total, autoplayInterval: null };
  }
  this.carousels[carouselId].currentIndex = index;
  slides.forEach((s, i) => s.classList.toggle('active', i === index));
  dots.forEach((d, i) => d.classList.toggle('active', i === index));
 },

 carouselNext(carouselId) {
  const cur = this.carousels[carouselId]?.currentIndex || 0;
  this.carouselGoTo(carouselId, cur + 1);
 },

 carouselPrev(carouselId) {
  const cur = this.carousels[carouselId]?.currentIndex || 0;
  this.carouselGoTo(carouselId, cur - 1);
 },

 showToast(message) {
  this.els.toastMessage.textContent = message;
  this.els.toast.style.display = 'flex';
  this.els.toast.classList.add('show');
  setTimeout(() => { this.els.toast.classList.remove('show'); this.els.toast.style.display = 'none'; }, 3000);
 },

 escapeHtml(str) {
  if (!str) return '';
  return str.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
 },

 scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
 }
 };

 window.partsFinderApp = partsFinderApp;

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', () => partsFinderApp.init());
 } else {
 partsFinderApp.init();
 }
})();
